import { g as Qe } from "./index.module-IS0TU87b.js";
import { pleaseUpdate as zn, DomainError as pi, ErrorGroup as So } from "domain-errors";
import { a as Dr } from "./getLoginsForUrl-CvwpdvUD.js";
import { g as Yb, i as Xb, p as Jb, b as Qb, u as Zb } from "./getLoginsForUrl-CvwpdvUD.js";
import { jsx as n, jsxs as m, Fragment as T } from "react/jsx-runtime";
import C from "classnames";
import ke, { useContext as It, forwardRef as Hr, useState as R, useEffect as k, createContext as _n, useCallback as B, useRef as D, useMemo as M, Fragment as Mn, useLayoutEffect as Io, createElement as No } from "react";
import _i from "use-media";
import { trackError as $, sleep as hn, assertExhaustive as z, CancelToken as hi, Cancel as We, AuditlogEventType as Ne, VaultType as Ur } from "backend-client-web";
import { D as Vr, l as mi, g as Ve, j as fi, f as gi, c as zr, h as qr, L as jr, u as yi, k as Gr } from "./webauthn-DV2ZpN1b.js";
import { a as tv, e as nv, b as ov, d as iv, i as rv, m as sv, n as cv, o as av, p as lv, s as dv, t as uv } from "./webauthn-DV2ZpN1b.js";
import { calculateTotp as Kr, DEFAULT_TOTP_ALGORITHM as Ci, DEFAULT_TOTP_DIGITS as wi, DEFAULT_TOTP_PERIOD as bi, InvalidTotpSecretError as Ao, UnknownTotpAlgorithmError as Lo } from "vault-crypto";
import { i as _v, l as hv } from "./initLocale-BpJWxHk1.js";
import Yr from "mousetrap";
import { useLocation as Xr, Link as et } from "react-router-dom";
import { throttle as Jr, debounce as mn } from "throttle-debounce";
import { i18n as u } from "@lingui/core";
import { ReactComponent as Qr } from "./assets/e05728e87cd1ca23.svg";
import { ReactComponent as Zr } from "./assets/5d0be631bf7d3947.svg";
import es from "react-dom";
import { ReactComponent as Vt } from "./assets/b1c9ac3221e94b98.svg";
import { ReactComponent as cn } from "./assets/32192847008cf9fc.svg";
import { SwitchTransition as ts, CSSTransition as Fn, TransitionGroup as ns } from "react-transition-group";
import { ReactComponent as os } from "./assets/d1032194ec1096e8.svg";
import { ReactComponent as is } from "./assets/680caa6137361575.svg";
import { ReactComponent as rs } from "./assets/d3851543766ba342.svg";
import { ReactComponent as vi } from "./assets/1bcfd951ee5cd05c.svg";
import { ReactComponent as ss } from "./assets/ad255589c29ec33d.svg";
import { ReactComponent as cs } from "./assets/d7b1d3ba0e87a5ce.svg";
import { ReactComponent as as } from "./assets/c2a2136ef8bf18bd.svg";
import ls from "react-textarea-autosize";
import { newUuid as ds, isPin as us, getLeakedPasswordCheckSkipReason as ps, LeakedPasswordCheckSkippedReason as Po, getRulesForPasswordPolicy as _s, getPasswordPolicyCheckSkipReason as hs, checkPasswordRules as ms, getTotpDirectoryUri as fs, validateTotp as Ro, getNormalizedPatternParts as gs, getValueWithPlaceholder as Fe, normalizeCreditCardNumber as ys, normalizeCreditCardExpiration as Cs, normalizeCreditCard as ws, normalizeWebsitePattern as qn, getWebsiteAttributesEntry as bs, extractTotpParametersFromOtpauthUrl as kn, extractNormalizedTotpSecret as Si, normalizeLoginScopeEntry as vs, getRelatedDomains as Ss, LoginUiType as ce, normalizeWindowsDesktopAppScopeEntry as Is, normalizeWebsiteScopeEntry as Ns, normalizeTag as As, ALL_LOGIN_PERMISSIONS as Ls, getImplicitLoginWebsites as Ps, VaultType as Rs, transformAndUpdateLoginProtectedValues as Bs, recursivelyTransformProtectedValues as Pn, CannotUnprotectError as Ts, recursivelyTransformUnprotectedValues as Es, NO_LOGIN_PERMISSIONS as $s } from "client-core";
import { ReactComponent as xs } from "./assets/fa67615847943b2c.svg";
import { ReactComponent as Ms } from "./assets/f83ebf69fa353485.svg";
import { useCombobox as an } from "downshift";
import { CircularProgressbar as Fs } from "react-circular-progressbar";
import { Trans as f, useLingui as ks } from "@lingui/react";
import Ii from "scroll-into-view-if-needed";
import { ReactComponent as Ws } from "./assets/46dde8092160efa1.svg";
import { ReactComponent as Os } from "./assets/fca912dd1ab82474.svg";
import { ReactComponent as Ds } from "./assets/1b8acf1cc5bb7e55.svg";
import { ReactComponent as Hs } from "./assets/ed18499e3448aad6.svg";
import { deepEqual as we, strictDeepEqual as Us } from "fast-equals";
import "ip-regex";
import { ReactComponent as Vs } from "./assets/4be4720676aebafd.svg";
import { ReactComponent as fn } from "./assets/85901eed410d7b8f.svg";
import { ReactComponent as zs } from "./assets/639e0321c796a6fd.svg";
import Rt from "date-fns/format";
import { FieldArray as zt, Formik as Ni } from "formik";
import { PasswordPolicyCheckSkippedReason as Bo, DEFAULT_PASSWORD_RULES as qs, LoginUiType as U, getValueWithPlaceholder as ot, newUuid as Ai } from "persistable-types";
import { ReactComponent as js } from "./assets/5037526d0efb03e8.svg";
import { ReactComponent as Gs } from "./assets/3696c0364ce81148.svg";
import { ReactComponent as Li } from "./assets/6dd72cbfdf6e5c09.svg";
import { ReactComponent as Pi } from "./assets/f6d3b15c27dbc1ed.svg";
import { ReactComponent as Ks } from "./assets/778295d9919b1854.svg";
import { format as ln, differenceInDays as To } from "date-fns";
import { ReactComponent as Ys } from "./assets/63285cd6e3447d53.svg";
import * as Yt from "zod";
import { ReactComponent as Xs } from "./assets/e29a75303cd009cd.svg";
import Rn, { creditCardType as Pe } from "card-validator";
import { ReactComponent as jn } from "./assets/c707e009107b34db.svg";
import { ReactComponent as Js } from "./assets/92beb0d5816827f1.svg";
import { ReactComponent as Qs } from "./assets/79403247197ec9cd.svg";
import { ReactComponent as Zs } from "./assets/ea285cf2cf54ed10.svg";
import { ReactComponent as ec } from "./assets/4bda20dc465fd5e8.svg";
import { ReactComponent as tc } from "./assets/96e6c7c43a915c12.svg";
import { ReactComponent as nc } from "./assets/4cd29c4c3e16daa4.svg";
import { ReactComponent as Eo } from "./assets/acb05338a032c728.svg";
import { ReactComponent as oc } from "./assets/df6706eae6f7e6b2.svg";
import { ReactComponent as ic } from "./assets/c919f85dd32ab2ca.svg";
import { ReactComponent as rc } from "./assets/bc16c58eb1de638b.svg";
import { ReactComponent as sc } from "./assets/75bb17d442a9aa5e.svg";
import { ReactComponent as cc } from "./assets/f1a233802cf96ae4.svg";
import { ReactComponent as ac } from "./assets/d40fa15a82ff4ca7.svg";
import { ReactComponent as lc } from "./assets/223ca525897c672a.svg";
import { ReactComponent as dc } from "./assets/d123df5f858e83af.svg";
import { ReactComponent as uc } from "./assets/f598fbfdb8ac6254.svg";
import { ReactComponent as pc } from "./assets/6611daebac7597e8.svg";
import { ReactComponent as _c } from "./assets/7644f7f652e95045.svg";
import { ReactComponent as hc } from "./assets/b692a0c7133f8543.svg";
import { ReactComponent as mc } from "./assets/156b4b5c20cd2878.svg";
import { ReactComponent as fc } from "./assets/d78060e53f98da09.svg";
import { useDropzone as gc, ErrorCode as Xt } from "react-dropzone";
import { ReactComponent as yc } from "./assets/983c43103d868c6a.svg";
import { ReactComponent as Cc } from "./assets/63914d098b4b93cd.svg";
import { ReactComponent as wc } from "./assets/37d1c27ba23ee3c6.svg";
import { ReactComponent as bc } from "./assets/c8f08adbe83afe3e.svg";
import { ReactComponent as vc } from "./assets/3714337086137eb1.svg";
import { ReactComponent as Sc } from "./assets/6f01546abb6820c9.svg";
import { ReactComponent as Ic } from "./assets/071a4a0c17b97d20.svg";
import { ReactComponent as Nc } from "./assets/6018ebb68aec24ff.svg";
import { ReactComponent as Ac } from "./assets/b1d9c11a519c251c.svg";
import { ReactComponent as Lc } from "./assets/f890388180e1cc77.svg";
import { ReactComponent as Pc } from "./assets/35628939564c0034.svg";
import { ReactComponent as Rc } from "./assets/23d48c18813121c5.svg";
import { ReactComponent as Bc } from "./assets/6f870edbfbb0dec6.svg";
import { ReactComponent as Tc } from "./assets/b1be9f463c2a8d71.svg";
import Ec from "qrcode.react";
import { ReactComponent as Ri } from "./assets/4d1cb875de22e4dc.svg";
import { ReactComponent as $c } from "./assets/03d3ac1156fd958a.svg";
import { ReactComponent as xc } from "./assets/b5f66d241201a818.svg";
import { ReactComponent as Mc } from "./assets/df2bd372fc46c984.svg";
import { ReactComponent as Fc } from "./assets/f36883b8db9c47da.svg";
import { ReactComponent as kc } from "./assets/a67451c466ea8aca.svg";
import { ReactComponent as Wc } from "./assets/05454371d50be11f.svg";
import { ReactComponent as Oc } from "./assets/86370fb8f6d9029d.svg";
import { ReactComponent as Dc } from "./assets/02fe5840d790de36.svg";
import { ReactComponent as Hc } from "./assets/86a990c017ab6e32.svg";
import { ReactComponent as Uc } from "./assets/c1b53e269a6a3694.svg";
import { ReactComponent as Vc } from "./assets/588d2e3c75f50062.svg";
import { ReactComponent as zc } from "./assets/12f2ab3739adfbea.svg";
import { ReactComponent as qc } from "./assets/78cd0901269cea25.svg";
import { ReactComponent as jc } from "./assets/395bdae0699bb27f.svg";
import { ReactComponent as Gc } from "./assets/8dd98122bc298e52.svg";
import { ReactComponent as Kc } from "./assets/9b19acdf996aea57.svg";
import { ReactComponent as Yc } from "./assets/54f6a00bc15cee34.svg";
import Xc from "./assets/d89bc62f69d5a7b9.png";
var Gn = ((e) => (e[e.Undefined = 0] = "Undefined", e[e.NoCharacterClass = So.ClientWebSdk + 400] = "NoCharacterClass", e[e.PasswordTooShort = So.ClientWebSdk + 410] = "PasswordTooShort", e))(Gn || {});
class Bi extends pi {
  constructor(t, o, i, r) {
    super(t, o, i ?? o, r ?? zn);
  }
}
class Jc extends Bi {
  constructor() {
    super(Gn.NoCharacterClass, "no character class", "at least one type of chars must be selected", `Select at least one of the types (numbers, upper-case, lower-case, special).${zn}`);
  }
}
class Qc extends Bi {
  constructor() {
    super(Gn.PasswordTooShort, "password to short", "the requested password length is too short", `The password length must be at least on for each character type.${zn}`);
  }
}
const Wt = 999, $o = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", xo = "abcdefghijklmnopqrstuvwxyz", Mo = "0123456789", Fo = "!#$@&%*^+_?()\\;:.=~{}<>-,\"'/`|".slice(0, 10);
function Wn(e) {
  const t = new Uint32Array(1);
  return window.crypto.getRandomValues(t), t[0] >= Math.floor(4294967295 / e) * e ? Wn(e) : t[0] % e;
}
function Bt(e, t) {
  const o = Wn(e.value.length), i = t[Wn(t.length)];
  return {
    value: e.value.slice(0, o) + i + e.value.slice(o, e.value.length),
    /* TODO: entropy calculation is not exact here as distribution of char groups is not considered
     * actual entropy is a little bit higher
     */
    entropy: e.entropy + Math.log2(t.length)
  };
}
function dn(e, t, o, i, r) {
  const s = (t ? 1 : 0) + (o ? 1 : 0) + (i ? 1 : 0) + (r ? 1 : 0);
  if (s === 0)
    throw new Jc();
  if (e < s)
    throw new Qc();
  e > Wt && (e = Wt);
  const a = (t ? $o : "") + (o ? xo : "") + (i ? Mo : "") + (r ? Fo : "");
  let c = {
    value: "",
    entropy: 0
  };
  for (t && (c = Bt(c, $o)), o && (c = Bt(c, xo)), i && (c = Bt(c, Mo)), r && (c = Bt(c, Fo)); c.value.length < e; )
    c = Bt(c, a);
  return c;
}
const Ti = ke.createContext("default");
function Zc({
  children: e,
  uiStyle: t
}) {
  return /* @__PURE__ */ n(Ti.Provider, { value: t, children: e });
}
const _b = Hr(({
  children: e,
  uiStyle: t,
  element: o,
  className: i,
  ...r
}, s) => /* @__PURE__ */ n(Zc, { uiStyle: t, children: /* @__PURE__ */ n(o ?? "div", { className: C(i, {
  // eslint-disable-next-line css-modules/no-undef-class
  [Qe.defaultStyle]: t === "default",
  // eslint-disable-next-line css-modules/no-undef-class
  [Qe.highlightStyle]: t === "highlight"
}), ref: s, ...r, children: e }) }));
function Nt() {
  return It(Ti);
}
const Ei = ke.createContext("light");
function hb({
  children: e,
  forceUIMode: t
}) {
  const o = _i("(prefers-color-scheme: dark)"), i = t ?? (o ? "dark" : "light"), [r, s] = R(!1);
  return k(() => {
    document.documentElement.classList.add(Qe.noAnimation), i === "light" ? (document.documentElement.classList.add(Qe.lightMode), document.documentElement.classList.remove(Qe.darkMode)) : (document.documentElement.classList.remove(Qe.lightMode), document.documentElement.classList.add(Qe.darkMode)), setTimeout(() => {
      s(!0), document.documentElement.classList.remove(Qe.noAnimation);
    }, 5);
  }, [i]), /* @__PURE__ */ n(Ei.Provider, { value: i, children: r && e });
}
function X() {
  return It(Ei);
}
const $i = _n(!1);
function mb({
  children: e,
  value: t
}) {
  return /* @__PURE__ */ n($i.Provider, { value: t, children: e });
}
function Kn() {
  return It($i);
}
function fb({
  element: e,
  children: t,
  ...o
}) {
  const i = e ?? "div";
  return Kn() ? /* @__PURE__ */ n(i, { style: {
    outline: "5px solid #f0f"
  }, ...o, children: t }) : null;
}
const xi = _n({
  openLogin: void 0,
  setOpenLogin: () => {
  }
});
function gb({
  children: e
}) {
  const [t, o] = R(void 0);
  return /* @__PURE__ */ n(xi.Provider, { value: {
    openLogin: t,
    setOpenLogin: o
  }, children: e });
}
function Mi() {
  return It(xi);
}
function yb() {
  const {
    openLogin: e
  } = Mi();
  return e;
}
const Fi = _n({
  writeAuditlogEvent: () => {
    $(new Error("AuditlogWriteContext used without being set up!"));
  }
});
function Cb({
  children: e,
  writeAuditlogEvent: t
}) {
  return /* @__PURE__ */ n(Fi.Provider, { value: {
    writeAuditlogEvent: t
  }, children: e });
}
function wb() {
  return It(Fi);
}
function ea(e, t, o, i) {
  const r = o ?? wi, s = B((g) => Kr(g.toUpperCase().trim(), t ?? Ci, r, i ?? bi), [r, t, i]), [a] = R(() => {
    try {
      return e ? s(e) : void 0;
    } catch (g) {
      if (g instanceof Ao || g instanceof Lo)
        return;
      throw g;
    }
  }), [c, d] = R(() => a?.totp), [l, p] = R(), [_, h] = R(() => a ? (Date.now() - a.epochStart) * 100 / (a.epochEnd - a.epochStart) : void 0);
  return k(() => {
    if (!e) {
      d(void 0), p(void 0), h(void 0);
      return;
    }
    let g;
    const w = () => {
      const {
        totp: b,
        epochLeftMs: y,
        epochStart: v,
        epochEnd: S
      } = s(e.toUpperCase().trim());
      d(b), p([v, S]), g = setTimeout(w, y);
    };
    try {
      w();
    } catch (b) {
      if (b instanceof Ao || b instanceof Lo) {
        d(void 0), p(void 0), h(void 0);
        return;
      }
      throw b;
    }
    return () => {
      clearTimeout(g), p(void 0);
    };
  }, [s, e]), k(() => {
    if (l === void 0)
      return;
    const [g, w] = l, b = w - g, y = () => {
      const S = Date.now() - g;
      h(S * 100 / b);
    };
    y();
    const v = setInterval(y, 250);
    return () => {
      clearInterval(v);
    };
  }, [l]), {
    totp: c,
    totpPercent: _,
    totpDigits: c?.length ?? r
  };
}
function $e() {
  const [e, t] = R({
    width: 0,
    height: 0
  });
  return [ta(t), e];
}
function ta(e) {
  const [t, o] = R(null), i = B((s) => {
    o(s);
    const a = ko(s);
    e?.(a);
  }, [e]), r = B(() => {
    const s = ko(t);
    e?.(s);
  }, [t, e]);
  return k(() => {
    if (!t)
      return;
    const s = new ResizeObserver(r);
    return s.observe(t, {
      box: "border-box"
    }), () => s.disconnect();
  }, [t, r]), i;
}
function ko(e) {
  return e ? {
    width: e.offsetWidth,
    height: e.offsetHeight
  } : {
    width: 0,
    height: 0
  };
}
function na(e, t = 1e3) {
  return async (...o) => {
    const i = Date.now(), r = await e(...o), s = Date.now() - i, a = t - s;
    return a > 0 && await hn(a), r;
  };
}
function oa(e, t, o) {
  const {
    action: i,
    global: r,
    deps: s
  } = {
    deps: [],
    ...o
  }, a = D(new Yr());
  k(() => {
    r ? a.current.stopCallback = () => !1 : a.current.stopCallback = ia;
  }, [r]);
  const c = B(t, s);
  k(() => {
    const d = a.current;
    return d.bind(e, c, i), () => {
      d.unbind(e, i);
    };
  }, [i, c, e, r]);
}
function ia(e, t, o) {
  return t.tagName === "SELECT" || t.tagName === "TEXTAREA" || t instanceof HTMLInputElement && t.type !== "checkbox" && t.type !== "radio" || t instanceof HTMLElement && t?.contentEditable === "true";
}
function ki(e, t) {
  const o = Array.isArray(e) ? e : [e], i = M(() => o, o);
  k(() => {
    const r = (s) => {
      s.target instanceof Node && // Ignore disconnected elements. If in response to a click an element is removed from the
      // DOM is becomes disconnected and would thus no longer count as being inside our refs.
      s.target.isConnected && !Wo(s.target, i) && t();
    };
    return window.addEventListener("click", r), () => window.removeEventListener("click", r);
  }, [t, i]), k(() => {
    const r = (s) => {
      s.key === "Escape" && s.target instanceof Node && Wo(s.target, i) && t();
    };
    return window.addEventListener("keydown", r), () => window.removeEventListener("keydown", r);
  }, [t, i]);
}
function Wo(e, t) {
  return t.flatMap((r) => r.current ? r.current : []).some((r) => r.contains(e));
}
function bb({
  enabled: e,
  elRef: t
}) {
  const o = t === void 0 ? window : t.current, {
    pathname: i
  } = Xr(), r = D(/* @__PURE__ */ new Map());
  k(() => {
    if (!e)
      return;
    const s = r.current.get(i) ?? 0;
    o?.scrollTo(0, s);
  }, [o, e, i]), k(() => {
    if (!e)
      return;
    const s = Jr(100, () => {
      const a = o ? o instanceof HTMLElement ? o.scrollTop : o.scrollY : 0;
      r.current.set(window.location.pathname, a);
    });
    return o?.addEventListener("scroll", s), () => {
      o?.removeEventListener("scroll", s), s.cancel();
    };
  }, [o, t, e]);
}
function vt({
  isEmpty: e,
  onShow: t,
  onHide: o
}) {
  const [i, r] = R(e);
  k(() => {
    e && r(!0);
  }, [e]);
  const s = D(i);
  return k(() => {
    i !== s.current && (s.current = i, t && i && t(), o && !i && o());
  }, [t, o, i]), {
    show: i,
    setShow: r,
    action: {
      key: "show/hide",
      icon: Zr,
      label: u._(
        /** i18n */
        {
          id: "8vETh9"
        }
      ),
      activeIcon: Qr,
      activeLabel: u._(
        /** i18n */
        {
          id: "vLyv1R"
        }
      ),
      active: i,
      element: {
        type: "button",
        props: {
          onClick: (a) => {
            r((c) => !c), a.preventDefault();
          },
          type: "button",
          disabled: e
        }
      }
    }
  };
}
function ra({
  visible: e,
  anchor: t,
  innerAnchor: o = {
    top: 0,
    left: 0
  },
  rootStyle: i
}) {
  const r = D(null), s = D(null), a = B((l) => {
    r.current = l;
    let p = l;
    for (; p && p.scrollHeight <= p.clientHeight; )
      p = p.parentElement;
    s.current = p;
  }, []), c = D(document.createElement("div"));
  return k(() => {
    if (!e)
      return;
    const l = c.current;
    return document.body.appendChild(l), () => {
      document.body.removeChild(l);
    };
  }, [e]), sa({
    visible: e,
    positionElementScrollParentRef: s,
    portalRootRef: c
  }), ca({
    visible: e,
    anchor: t,
    innerAnchor: o,
    rootStyle: i,
    positioningElementRef: r,
    portalRootRef: c
  }), {
    PositionedPortal: B(({
      children: l
    }) => es.createPortal(l, c.current), []),
    updatePositioningElement: a
  };
}
function sa({
  visible: e,
  positionElementScrollParentRef: t,
  portalRootRef: o
}) {
  k(() => {
    if (!e)
      return;
    function i(s) {
      t.current?.scrollBy({
        top: s.deltaY,
        left: s.deltaX
      });
    }
    const r = o.current;
    return r.addEventListener("wheel", i), () => {
      r.removeEventListener("wheel", i);
    };
  }, [o, t, e]);
}
function ca({
  visible: e,
  anchor: t,
  innerAnchor: o,
  rootStyle: i,
  positioningElementRef: r,
  portalRootRef: s
}) {
  const a = B(() => {
    r.current && Object.assign(s.current.style, aa({
      posEl: r.current,
      posAnchor: t,
      innerAnchor: o,
      rootStyle: i
    }));
  }, [t, o, s, r, i]), c = B(() => {
    requestAnimationFrame(a);
  }, [a]);
  k(() => {
    if (e)
      return c(), document.addEventListener("scroll", c, !0), window.addEventListener("resize", c), () => {
        document.removeEventListener("scroll", c, !0), window.addEventListener("resize", c);
      };
  }, [c, e]);
}
function aa({
  posEl: e,
  posAnchor: t,
  innerAnchor: o,
  rootStyle: i
}) {
  const r = {
    position: "fixed",
    ...i
  }, s = e.getBoundingClientRect();
  "top" in t ? r.top = `${s.top + s.height * t.top}px` : r.bottom = `${document.documentElement.clientHeight - s.bottom + s.height * t.bottom}px`, "left" in t ? r.left = `${s.left + s.width * t.left}px` : r.right = `${document.documentElement.clientWidth - s.right + s.width * t.right}px`;
  const a = "top" in o ? -o.top : -(1 - o.bottom), c = "left" in o ? -o.left : -(1 - o.right);
  return r.transform = `translate(${c * 100}%, ${a * 100}%)`, r;
}
function vb(e) {
  const t = M(() => new Vr(e), [e]);
  k(() => (t.init(), () => t.close()), [t, e]);
}
function fe(e, t) {
  const [o, i] = R(!1), r = B(() => {
    if (!t)
      return;
    e(t), i(!0);
    const s = window.setTimeout(() => i(!1), 1e3);
    return () => window.clearTimeout(s);
  }, [e, t]);
  return {
    action: {
      key: "copy",
      icon: cn,
      label: u._(
        /** i18n */
        {
          id: "he3ygx"
        }
      ),
      activeIcon: Vt,
      active: o,
      activeLabel: u._(
        /** i18n */
        {
          id: "6V3Ea3"
        }
      ),
      element: {
        type: "button",
        props: {
          onClick: r,
          type: "button",
          disabled: !t
        }
      }
    }
  };
}
function Sb() {
  return M(() => mi() ? "metaKey" : "ctrlKey", []);
}
function la(...e) {
  return B((t) => {
    for (const o of e)
      typeof o == "function" ? o(t) : o && (o.current = t);
  }, e);
}
function Ib(e, t, o) {
  const i = D(/* @__PURE__ */ new Map()), r = D(o);
  return k(() => {
    r.current = o;
  }, [o]), k(() => {
    const a = t.map(r.current);
    for (const c of i.current.keys())
      a.includes(c) || i.current.delete(c);
  }, [t]), B((a) => {
    let c = i.current.get(a);
    return c || (c = {
      current: e
    }, i.current.set(a, c)), c;
  }, [e]);
}
function da(e, t = 500) {
  const [o, i] = R(!1), r = D();
  return k(() => {
    window.clearTimeout(r.current), e ? r.current = window.setTimeout(() => {
      i(!0);
    }, t) : i(!1);
  }, [t, e]), o;
}
const ua = "_PushState_1ibrb_1", pa = "_confirmed_1ibrb_19", _a = "_light_1ibrb_22", ha = "_warning_1ibrb_25", ma = "_error_1ibrb_28", fa = "_small_1ibrb_32", ga = "_connecting_1ibrb_67", ya = "_rotating_1ibrb_70", Ca = "_rotate_1ibrb_1", wa = "_IconWrapper_1ibrb_74", ba = "_Icon_1ibrb_74", va = "_fadeEnter_1ibrb_97", Sa = "_fadeExit_1ibrb_100", Ia = "_fadeEnterActive_1ibrb_103", Na = "_fadeExitActive_1ibrb_107", Re = {
  PushState: ua,
  confirmed: pa,
  light: _a,
  warning: ha,
  error: ma,
  small: fa,
  connecting: ga,
  rotating: ya,
  rotate: Ca,
  IconWrapper: wa,
  Icon: ba,
  fadeEnter: va,
  fadeExit: Sa,
  fadeEnterActive: Ia,
  fadeExitActive: Na
};
function Aa({
  className: e,
  state: t,
  small: o,
  unlockDeviceType: i
}) {
  const r = D(null), s = La(r, t === "connecting"), a = t === "confirmed", c = {
    enter: Re.fadeEnter,
    enterActive: Re.fadeEnterActive,
    exit: Re.fadeExit,
    exitActive: Re.fadeExitActive
  }, d = a ? Vt : i === "multiple" || i === "mobileSafari" ? os : i === "securityKey" ? rs : is, l = D(null), p = X();
  return /* @__PURE__ */ n("div", { ref: r, className: C(Re.PushState, Re[t], {
    [Re.rotating]: s,
    [Re.small]: o,
    [Re.light]: p === "light"
  }, e), children: /* @__PURE__ */ n(ts, { children: /* @__PURE__ */ n(Fn, { addEndListener: (_) => l.current?.addEventListener("transitionend", _, !1), classNames: c, nodeRef: l, children: /* @__PURE__ */ n("span", { className: Re.IconWrapper, ref: l, children: /* @__PURE__ */ n(d, { className: Re.Icon }) }) }, a ? "a" : "b") }) });
}
function La(e, t) {
  const [o, i] = R(t);
  return k(() => {
    const r = e?.current;
    function s() {
      i(!1), r?.removeEventListener("animationiteration", s);
    }
    return t ? i(!0) : r?.addEventListener("animationiteration", s), () => {
      r?.removeEventListener("animationiteration", s);
    };
  }, [e, t]), o;
}
const Pa = "_Button_1jnoy_1 _UnstyledButton_r3cpb_208", Ra = "_medium_1jnoy_31", Ba = "_small_1jnoy_35", Ta = "_PillButton_1jnoy_40 _Button_1jnoy_1 _UnstyledButton_r3cpb_208", Ea = "_primary_1jnoy_62 _PillButton_1jnoy_40 _Button_1jnoy_1 _UnstyledButton_r3cpb_208", $a = "_secondary_1jnoy_77 _PillButton_1jnoy_40 _Button_1jnoy_1 _UnstyledButton_r3cpb_208", xa = "_userConfirmation_1jnoy_92 _PillButton_1jnoy_40 _Button_1jnoy_1 _UnstyledButton_r3cpb_208", Ma = "_dark_1jnoy_109", Fa = "_highlight_1jnoy_110", ka = "_tertiary_1jnoy_122 _Button_1jnoy_1 _UnstyledButton_r3cpb_208", Tt = {
  Button: Pa,
  medium: Ra,
  small: Ba,
  PillButton: Ta,
  primary: Ea,
  secondary: $a,
  userConfirmation: xa,
  dark: Ma,
  highlight: Fa,
  tertiary: ka,
  default: "_default_1jnoy_141"
};
function me({
  element: e,
  buttonStyle: t,
  className: o,
  children: i,
  size: r,
  buttonRef: s,
  overrideColor: a,
  style: c,
  ...d
}) {
  const l = e ?? "button", p = Nt(), _ = X();
  return /* @__PURE__ */ n(l, { className: C(Tt.Button, Tt[t], Tt[p], Tt[_], Tt[r ?? "medium"], o), style: {
    ...c,
    "--color-override": a
  }, ...d, ref: s, children: i });
}
const Wa = "_ActionInputWrapper_kgcit_1", Oa = "_medium_kgcit_5", Da = "_small_kgcit_9", Ha = "_InputFieldWrapper_kgcit_13", Ua = "_ActionInput_kgcit_1", Va = "_highlight_kgcit_47", za = "_error_kgcit_54", qa = "_Placeholder_kgcit_63", ja = "_PlaceholderIcon_kgcit_78", Ga = "_PlaceholderText_kgcit_87", Ka = "_ClearButton_kgcit_96 _UnstyledButton_r3cpb_208", Ya = "_ErrorIcon_kgcit_97", Xa = "_Message_kgcit_113", ve = {
  ActionInputWrapper: Wa,
  medium: Oa,
  small: Da,
  InputFieldWrapper: Ha,
  ActionInput: Ua,
  highlight: Va,
  error: za,
  Placeholder: qa,
  PlaceholderIcon: ja,
  PlaceholderText: Ga,
  ClearButton: Ka,
  ErrorIcon: Ya,
  Message: Xa
};
function Nb({
  icon: e,
  placeholder: t,
  value: o,
  className: i,
  onClear: r,
  error: s,
  size: a,
  ...c
}) {
  const [d, l] = R(!1), p = Nt();
  return /* @__PURE__ */ m("label", { className: C(ve.ActionInputWrapper, ve[a ?? "medium"], i), children: [
    /* @__PURE__ */ m("div", { className: ve.InputFieldWrapper, children: [
      !d && !o && /* @__PURE__ */ m("div", { className: ve.Placeholder, children: [
        e && /* @__PURE__ */ n("div", { className: ve.PlaceholderIcon, children: e }),
        " ",
        /* @__PURE__ */ n("div", { className: ve.PlaceholderText, children: t })
      ] }),
      /* @__PURE__ */ n("input", { ...c, className: C(ve.ActionInput, {
        [ve.highlight]: p === "highlight",
        [ve.error]: !!s
      }), onFocus: () => l(!0), onBlur: () => l(!1), value: o, "data-lpignore": "true" }),
      " ",
      s ? /* @__PURE__ */ n("div", { className: ve.ErrorIcon, children: /* @__PURE__ */ n(ss, {}) }) : !!o && r && /* @__PURE__ */ n("button", { type: "button", className: ve.ClearButton, onClick: r, children: /* @__PURE__ */ n(vi, {}) })
    ] }),
    s && /* @__PURE__ */ n("div", { className: ve.Message, children: s })
  ] });
}
const Ja = "_Button_1s6un_1 _UnstyledButton_r3cpb_208", Oo = {
  Button: Ja
};
function Qa({
  element: e,
  className: t,
  children: o,
  ...i
}) {
  const r = e ?? "button", s = Nt();
  return /* @__PURE__ */ n(r, { className: C(Oo.Button, Oo[s], t), ...i, children: o });
}
const Za = "_Switch_lac3f_1", el = {
  Switch: Za
};
function on({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ n("input", { type: "checkbox", className: C(el.Switch, e), ...t });
}
const tl = "_Container_myfk9_1", nl = "_Checkbox_myfk9_17", ol = "_indeterminate_myfk9_30", il = "_Marker_myfk9_34", rl = "_cross_myfk9_47", sl = "_line_myfk9_50", ct = {
  Container: tl,
  Checkbox: nl,
  indeterminate: ol,
  Marker: il,
  cross: rl,
  line: sl
};
function Wi({
  className: e,
  checked: t,
  indeterminate: o,
  onChange: i,
  ...r
}) {
  const s = D(null);
  k(() => {
    s.current && (s.current.indeterminate = !!o);
  });
  const a = t && !o;
  return /* @__PURE__ */ m("div", { className: C(ct.Container, e), children: [
    a && /* @__PURE__ */ n(cs, { className: C(ct.Marker, ct.cross) }),
    !!o && /* @__PURE__ */ n(as, { className: C(ct.Marker, ct.line) }),
    /* @__PURE__ */ n("input", { type: "checkbox", ...r, checked: a, className: C(ct.Checkbox, {
      [ct.indeterminate]: o
    }), onChange: i, ref: s })
  ] });
}
const cl = "_InputContainer_5bgb3_1", al = "_hasIcon_5bgb3_20", ll = "_labelInside_5bgb3_23", dl = "_relaxedLabelInsideSpacing_5bgb3_27", ul = "_hasRightInlineUi_5bgb3_31", pl = "_hasBottomInlineUi_5bgb3_34", _l = "_disabled_5bgb3_37", hl = "_readOnly_5bgb3_38", ml = "_lightMode_5bgb3_41", fl = "_error_5bgb3_45", gl = "_warning_5bgb3_48", yl = "_darkMode_5bgb3_51", Cl = "_InputFieldWrapper_5bgb3_63", wl = "_InputLabel_5bgb3_67", bl = "_Input_5bgb3_1", vl = "_InputPlaceholder_5bgb3_73", Sl = "_InputBackgroundText_5bgb3_74", Il = "_raisedLabel_5bgb3_132", Nl = "_colorize_5bgb3_149", Al = "_autosize_5bgb3_181", Ll = "_focus_5bgb3_188", Pl = "_suggestions_5bgb3_192", Rl = "_monospace_5bgb3_199", Bl = "_Icon_5bgb3_215", Tl = "_InlineUi_5bgb3_231", El = "_Prefix_5bgb3_261", $l = "_Message_5bgb3_274", K = {
  InputContainer: cl,
  hasIcon: al,
  labelInside: ll,
  relaxedLabelInsideSpacing: dl,
  hasRightInlineUi: ul,
  hasBottomInlineUi: pl,
  disabled: _l,
  readOnly: hl,
  lightMode: ml,
  error: fl,
  warning: gl,
  darkMode: yl,
  InputFieldWrapper: Cl,
  InputLabel: wl,
  Input: bl,
  InputPlaceholder: vl,
  InputBackgroundText: Sl,
  raisedLabel: Il,
  colorize: Nl,
  autosize: Al,
  focus: Ll,
  suggestions: Pl,
  monospace: Rl,
  Icon: Bl,
  InlineUi: Tl,
  Prefix: El,
  Message: $l
};
function se({
  style: e,
  className: t,
  element: o,
  label: i,
  icon: r,
  error: s,
  reserveSpaceForMessage: a,
  warning: c,
  inlineUi: d,
  labelInside: l,
  placeholder: p,
  monospace: _,
  info: h,
  prefix: g,
  isSubmitting: w,
  disableRelaxedLabelInsideSpacing: b
}) {
  const y = typeof o?.props?.value == "string" ? o?.props?.value : "", [v, S] = R(!1);
  return k(() => {
    o?.props?.disabled && S(!1);
  }, [o?.props?.disabled]), /* @__PURE__ */ n(gn, { value: y, style: e, className: t, icon: r, label: i, placeholder: p, error: s, reserveSpaceForMessage: a, warning: c, focus: v, disabled: !!o?.props?.disabled, readOnly: !!o?.props?.readOnly, labelInside: l, relaxedLabelInsideSpacing: (o?.type === "textarea" || o?.type === "autosizeTextarea") && !b, monospace: _, info: h, prefix: g, renderInputElement: (I, E, A) => {
    if (o?.type === "textarea") {
      const {
        className: N,
        onFocus: P,
        onBlur: L,
        onChange: F,
        readOnly: O,
        ...W
      } = o.props ?? {};
      return /* @__PURE__ */ n("textarea", { ...W, value: I, className: C(E, N), onFocus: _t(() => S(!0), P), onBlur: _t(() => S(!1), L), onChange: F, readOnly: O || w, id: A });
    }
    if (o?.type === "autosizeTextarea") {
      const {
        className: N,
        onFocus: P,
        onBlur: L,
        onChange: F,
        readOnly: O,
        ...W
      } = o.props ?? {};
      return /* @__PURE__ */ n(ls, { ...W, value: I, className: C(E, N, K.autosize), onFocus: _t(() => S(!0), P), onBlur: _t(() => S(!1), L), onChange: F, readOnly: O || w, id: A });
    }
    if (!o || o.type === "input") {
      const {
        className: N,
        onFocus: P,
        onBlur: L,
        onChange: F,
        readOnly: O,
        ...W
      } = o?.props ?? {};
      return /* @__PURE__ */ n("input", { ...W, value: I, className: C(E, N), onFocus: _t(() => S(!0), P), onBlur: _t(() => S(!1), L), onChange: F, readOnly: O || w, id: A, "data-lpignore": "true" });
    }
  }, inlineUi: d });
}
function _t(e, t) {
  return t ? (o) => {
    e(o), t(o);
  } : e;
}
function gn({
  className: e,
  error: t,
  reserveSpaceForMessage: o,
  focus: i,
  disabled: r,
  readOnly: s,
  icon: a,
  inlineUi: c,
  label: d,
  placeholder: l,
  backgroundText: p,
  style: _,
  suggestions: h,
  suggestionsVisible: g,
  value: w,
  warning: b,
  renderInputElement: y,
  labelInside: v,
  relaxedLabelInsideSpacing: S,
  monospace: I,
  inputWrapperProps: E,
  info: A,
  prefix: N,
  isSubmitting: P
}) {
  const L = D(ds()), F = C(K.Input, {
    [K.focus]: i,
    [K.monospace]: I
  }), [O, {
    width: W
  }] = $e(), j = {
    ..._,
    "--inline-ui-width": c?.bottom ? "0px" : c?.width ?? "0px",
    "--inline-ui-height": c?.bottom ? c?.height ?? "0px" : "0px",
    "--prefix-width": `${W}px`
  }, V = !i && !w && !p && l, J = i && !s || w || l || p || N, G = X();
  return /* @__PURE__ */ m("div", { className: C(K.InputContainer, e, {
    [K.hasRightInlineUi]: c && !c.bottom,
    [K.hasBottomInlineUi]: c && c.bottom,
    [K.raisedLabel]: J,
    [K.disabled]: r,
    [K.readOnly]: s || P,
    [K.error]: t,
    [K.warning]: b,
    [K.hasIcon]: a,
    [K.colorize]: b || t,
    [K.suggestions]: g,
    [K.labelInside]: v || G === "dark" && d,
    [K.relaxedLabelInsideSpacing]: S,
    [K.lightMode]: G === "light",
    [K.darkMode]: G === "dark"
  }), style: j, children: [
    /* @__PURE__ */ m("div", { className: K.InputFieldWrapper, ...E, children: [
      d && /* @__PURE__ */ n("label", { htmlFor: L.current, className: K.InputLabel, children: d }),
      V && /* @__PURE__ */ n("span", { className: K.InputPlaceholder, children: l }),
      p && /* @__PURE__ */ n("span", { className: K.InputBackgroundText, children: p }),
      a && /* @__PURE__ */ n("div", { className: K.Icon, children: a }),
      y ? y(w, F, L.current) : /* @__PURE__ */ n("input", { className: F, type: "text", value: w, id: L.current, "data-lpignore": "true" }),
      c && /* @__PURE__ */ n("div", { className: K.InlineUi, children: c.node })
    ] }),
    N && /* @__PURE__ */ n("div", { className: K.Prefix, ref: O, children: N }),
    h,
    (typeof t == "string" || typeof b == "string" || A || o) && /* @__PURE__ */ n("div", { className: K.Message, children: t || b || A })
  ] });
}
const xl = "_fadeEnter_1q1f0_1", Ml = "_fadeExit_1q1f0_5", Fl = "_fadeEnterActive_1q1f0_9", kl = "_fadeExitActive_1q1f0_14", Jt = {
  fadeEnter: xl,
  fadeExit: Ml,
  fadeEnterActive: Fl,
  fadeExitActive: kl
}, Do = {
  enter: Jt.fadeEnter,
  exit: Jt.fadeExit,
  enterActive: Jt.fadeEnterActive,
  exitActive: Jt.fadeExitActive
};
function Yn({
  defaultChildren: e,
  activeChildren: t,
  active: o,
  className: i,
  stateWrapperClassName: r
}) {
  const s = D(null), a = D(null);
  return /* @__PURE__ */ n(ns, { className: i, children: o ? /* @__PURE__ */ n(Fn, { classNames: Do, addEndListener: () => {
  }, nodeRef: s, children: /* @__PURE__ */ n("div", { className: r, ref: s, children: t }) }, o ? "b" : "a") : /* @__PURE__ */ n(Fn, { classNames: Do, addEndListener: () => {
  }, nodeRef: a, children: /* @__PURE__ */ n("div", { className: r, ref: a, children: e }) }, o ? "b" : "a") });
}
const Wl = "_Dropdown_4ya18_1", Ol = {
  Dropdown: Wl
}, Oi = ke.forwardRef(({
  element: e,
  className: t,
  children: o,
  ...i
}, r) => /* @__PURE__ */ n(e ?? "div", { className: C(Ol.Dropdown, t), ref: r, ...i, children: o })), Dl = "_HoverOverlay_te52q_1", Hl = {
  HoverOverlay: Dl
};
function Xn({
  children: e,
  downwards: t,
  element: o,
  overlay: i,
  ariaLabel: r,
  ...s
}) {
  const a = o, [c, d] = R(!1), {
    PositionedPortal: l,
    updatePositioningElement: p
  } = ra({
    visible: c,
    anchor: t ? {
      top: 1,
      left: 0.5
    } : {
      bottom: 1,
      left: 0.5
    },
    innerAnchor: {
      top: 0,
      left: 0.5
    },
    rootStyle: {
      zIndex: "100",
      pointerEvents: "none"
    }
  }), _ = D(), h = Kn();
  return /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(
      a,
      {
        "aria-label": r,
        ...s,
        ref: p,
        onPointerEnter: () => {
          _.current = window.setTimeout(() => d(!0), 50);
        },
        onPointerLeave: (g) => {
          h && g.altKey || (clearTimeout(_.current), d(!1));
        },
        children: e
      }
    ),
    /* @__PURE__ */ n(l, { children: /* @__PURE__ */ n("div", { "aria-hidden": !0, className: C(Hl.HoverOverlay), children: i }) })
  ] });
}
function Ht({
  tooltip: e,
  element: t,
  ...o
}) {
  return /* @__PURE__ */ n(Xn, { element: t, ...o, overlay: e, ariaLabel: e });
}
const Ul = "_Wrapper_1xlqh_1", Vl = "_Action_1xlqh_6 _UnstyledButton_r3cpb_208", zl = "_inline_1xlqh_21", ql = "_ActionIcon_1xlqh_31", jl = "_OpenActionWrapper_1xlqh_45", Gl = "_Menu_1xlqh_50", Kl = "_dropdown_1xlqh_65", Me = {
  Wrapper: Ul,
  Action: Vl,
  inline: zl,
  ActionIcon: ql,
  OpenActionWrapper: jl,
  Menu: Gl,
  dropdown: Kl
};
function yn({
  inlineActions: e,
  dropdownActions: t,
  downwardsTooltips: o,
  dropdownClassName: i,
  horizontalDots: r
}) {
  return /* @__PURE__ */ m("div", { className: C(Me.Wrapper), children: [
    e.map(({
      key: s,
      ...a
    }) => /* @__PURE__ */ n(Di, { ...a, downwardsTooltip: o }, s)),
    !!t?.length && /* @__PURE__ */ n(Yl, { dropdownClassName: i, horizontalDots: r, children: t.map(({
      key: s,
      ...a
    }) => /* @__PURE__ */ n(Xl, { ...a }, s)) })
  ] });
}
function Di({
  icon: e,
  active: t,
  activeIcon: o,
  className: i,
  activeClassName: r,
  element: s,
  label: a,
  activeLabel: c,
  downwardsTooltip: d
}) {
  const l = o ?? e, p = t && c ? c : a;
  return /* @__PURE__ */ n(Ht, { element: s.type, tooltip: p, downwards: d, ...s.props, className: C(Me.Action, Me.inline, s.props?.className), children: /* @__PURE__ */ n(Yn, { active: t, defaultChildren: /* @__PURE__ */ n(e, { className: C(Me.ActionIcon, i) }), activeChildren: /* @__PURE__ */ n(l, { className: C(Me.ActionIcon, i, r) }) }) });
}
function Yl({
  children: e,
  dropdownClassName: t,
  horizontalDots: o
}) {
  const [i, r] = R(!1), s = B(() => r(!1), []), a = D(null);
  return ki(a, s), /* @__PURE__ */ m("div", { className: Me.OpenActionWrapper, ref: a, children: [
    /* @__PURE__ */ n(Di, { element: {
      type: "button",
      props: {
        type: "button",
        onClick: () => r(!i)
      }
    }, label: u._(
      /** i18n */
      {
        id: "2FYpfJ"
      }
    ), icon: o ? xs : Ms }, "more"),
    i && /* @__PURE__ */ n(Oi, { element: "ul", className: C(Me.Menu, t), onClick: s, children: e })
  ] });
}
function Xl({
  icon: e,
  element: t,
  active: o,
  activeIcon: i,
  className: r,
  activeClassName: s,
  label: a,
  activeLabel: c
}) {
  const d = o && i ? i : e, l = o && c ? c : a, p = t.type;
  return /* @__PURE__ */ n("li", { children: /* @__PURE__ */ m(p, { ...t.props, className: C(Me.Action, Me.dropdown, t.props?.className), children: [
    /* @__PURE__ */ n(d, { className: C(Me.ActionIcon, r, o && s) }),
    l
  ] }) });
}
const Jl = "_LightweightInput_1iqq6_1", Ql = {
  LightweightInput: Jl
};
function Zl({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ n("input", { type: "text", ...t, className: C(Ql.LightweightInput, e) });
}
function On({
  actions: e,
  targetInlineActions: t,
  minInlineActions: o,
  downwardsTooltips: i,
  bottom: r
}) {
  const {
    inlineActions: s,
    dropdownActions: a
  } = ed(e, {
    targetInlineActions: t,
    minInlineActions: o
  }), c = a.length ? s.length + 1 : s.length;
  return {
    node: /* @__PURE__ */ n(yn, { inlineActions: s, dropdownActions: a, downwardsTooltips: i, bottom: r }),
    width: `${1.75 * c - 0.25}rem`,
    height: "1.5rem",
    bottom: r
  };
}
function pe(e, {
  showAllInlineActions: t,
  minInlineActions: o
} = {}) {
  const [i, {
    width: r
  }] = $e(), s = Math.floor((r - 200) / 40), a = t ? void 0 : Math.max(1, Math.min(s, 4));
  return {
    ref: i,
    inlineUi: On({
      actions: e,
      targetInlineActions: a,
      minInlineActions: o
    })
  };
}
function ed(e, {
  minInlineActions: t,
  targetInlineActions: o
} = {}) {
  const i = td(t, o);
  if (i !== void 0 && e.length > i) {
    const r = e.slice(0, i - 1), s = e.slice(i - 1);
    return {
      inlineActions: r,
      dropdownActions: s
    };
  }
  return {
    inlineActions: e,
    dropdownActions: []
  };
}
function td(e, t) {
  return e !== void 0 && t !== void 0 ? Math.max(e, t) : e ?? t;
}
const nd = "_Options_uim5e_1", od = "_open_uim5e_14", id = "_darkMode_uim5e_18", rd = "_colorize_uim5e_21", sd = "_overlay_uim5e_24", cd = "_OptionButton_uim5e_54 _Option_uim5e_1", ad = "_highlighted_uim5e_58", ld = "_selected_uim5e_62", dd = "_OptionInfo_uim5e_79 _Option_uim5e_1", De = {
  Options: nd,
  open: od,
  darkMode: id,
  colorize: rd,
  overlay: sd,
  OptionButton: cd,
  highlighted: ad,
  selected: ld,
  OptionInfo: dd
};
function Hi({
  isOpen: e,
  value: t,
  colorize: o,
  filteredOptions: i,
  highlightedIndex: r,
  noMatchingOptionsText: s,
  optionsOverlay: a,
  getMenuProps: c,
  getItemProps: d,
  renderValueLabel: l,
  valuesEqual: p
}) {
  const _ = X();
  return /* @__PURE__ */ n("ul", { ...c({
    className: C(De.Options, {
      [De.open]: e,
      [De.colorize]: o,
      [De.overlay]: a,
      [De.darkMode]: _ === "dark"
    })
  }), children: e && (i.length ? i.map((h, g) => /* @__PURE__ */ n("li", { className: C(De.OptionButton, {
    [De.selected]: t && p(h, t),
    [De.highlighted]: r === g
  }), ...d({
    item: h,
    index: g
  }), children: l(h) }, g)) : s && /* @__PURE__ */ n("li", { className: De.OptionInfo, children: s }, "empty")) });
}
const ud = "_ClearButton_m0igx_1 _UnstyledButton_r3cpb_208", pd = "_Container_m0igx_11", Ho = {
  ClearButton: ud,
  Container: pd
};
function _d({
  value: e,
  options: t,
  noMatchingOptionsText: o,
  getValueLabel: i,
  getValueIconNode: r,
  valuesEqual: s,
  onFocus: a,
  onBlur: c,
  autoFocus: d,
  className: l,
  style: p,
  error: _,
  warning: h,
  disabled: g,
  readOnly: w,
  label: b,
  labelInside: y,
  optionsOverlay: v,
  inlineUi: S,
  // keep these props together since they form a correlated union with clearable
  ...I
}) {
  const [E, A] = R(""), N = D(null), [P, L] = R(t), {
    isOpen: F,
    getMenuProps: O,
    getInputProps: W,
    highlightedIndex: j,
    getItemProps: V,
    openMenu: J
  } = an({
    items: P,
    inputValue: E,
    selectedItem: e ?? null,
    itemToString: (H) => H ? i(H) : "",
    onSelectedItemChange: ({
      selectedItem: H
    }) => {
      I.clearable ? (I.onChange(H ?? void 0), A("")) : H && (I.onChange(H), A(""));
    },
    onStateChange: (H) => {
      H.type === an.stateChangeTypes.InputChange && A(H.inputValue ?? "");
    },
    stateReducer: (H, {
      changes: q
    }) => (g || w) && q.isOpen ? {
      ...q,
      isOpen: !1
    } : q
  });
  k(() => {
    const H = E.toLowerCase().trim();
    if (!H) {
      L(t);
      return;
    }
    L(t.filter((q) => i(q).toLowerCase().includes(H)));
  }, [i, E, t]);
  const [G, oe] = R(!1);
  return /* @__PURE__ */ n(gn, { focus: G, disabled: !!g, readOnly: !!w, className: C(Ho.Container, l), style: p, error: F ? void 0 : _, warning: F ? void 0 : h, label: b, labelInside: y, value: E, icon: e ? r?.(e) : void 0, backgroundText: !E && e ? i(e) : void 0, renderInputElement: (H, q, be) => /* @__PURE__ */ n("input", { ...W({
    id: be,
    onFocus: () => {
      a?.(), oe(!0);
    },
    onBlur: () => {
      c?.(), oe(!1);
    },
    onKeyDown: (ee) => {
      (ee.key === "ArrowDown" || ee.key === "ArrowUp") && !F && (ee.preventDownshiftDefault = !0), ee.key === "Enter" && !g && !w && (F ? P.length && (ee.preventDefault(), I.onChange(P[0])) : (ee.preventDefault(), J()));
    },
    type: "text",
    disabled: g,
    readOnly: w,
    autoFocus: d,
    className: q,
    ref: N
  }), "data-lpignore": "true" }), suggestionsVisible: F, suggestions: /* @__PURE__ */ n(Hi, { isOpen: F, value: e, colorize: !!(h || _), filteredOptions: P, highlightedIndex: j, noMatchingOptionsText: o, optionsOverlay: v, getMenuProps: O, getItemProps: V, valuesEqual: s, renderValueLabel: (H) => /* @__PURE__ */ n(hd, { option: H, getValueLabel: i, getValueIconNode: r }) }), inlineUi: E || e !== void 0 && I.clearable ? {
    node: /* @__PURE__ */ n("button", { type: "button", className: Ho.ClearButton, onClick: () => {
      A(""), J(), I.clearable && I.onChange(void 0), N.current?.focus();
    }, children: /* @__PURE__ */ n(vi, { title: u._(
      /** i18n */
      {
        id: "xCJdfg"
      }
    ) }) }),
    width: "1rem"
  } : S });
}
function hd({
  option: e,
  getValueLabel: t,
  getValueIconNode: o
}) {
  return o ? /* @__PURE__ */ m(T, { children: [
    o(e),
    " ",
    t(e)
  ] }) : /* @__PURE__ */ n(T, { children: t(e) });
}
const md = "_Loading_rnsnm_1", fd = {
  Loading: md
}, gd = "_Spinner_1gk9j_1", yd = {
  Spinner: gd
};
function Cn({
  size: e,
  armCount: t = 12,
  animationDurationMs: o = 1e3,
  armWidth: i = 0.075,
  armHeight: r = 0.25,
  armCornerRadius: s = 0.03
}) {
  return /* @__PURE__ */ n("div", { className: yd.Spinner, style: {
    // @ts-ignore
    "--size": e,
    "--animation-duration": `${o}ms`,
    "--arm-width": i,
    "--arm-height": r,
    "--arm-corner-radius": s
  }, children: Array(t).fill(void 0).map((a, c) => /* @__PURE__ */ n("div", { style: {
    // @ts-ignore
    "--rotate": `${c / t}turn`,
    animationDelay: `${-o + (c + 1) * o / t}ms`
  } }, `${t}-${c}`)) });
}
function Dn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ n("div", { className: C(fd.Loading, e), ...t, children: /* @__PURE__ */ n(Cn, { size: "80px" }) });
}
const Cd = "_TotpCountdown_1qwcq_1", wd = "_hidden_1qwcq_11", bd = "_darkMode_1qwcq_21", vd = "_finishing_1qwcq_35", Sd = "_starting_1qwcq_49", Et = {
  TotpCountdown: Cd,
  hidden: wd,
  darkMode: bd,
  finishing: vd,
  starting: Sd
};
function Id({
  percent: e,
  hidden: t,
  className: o
}) {
  const i = X();
  return /* @__PURE__ */ n(Fs, { value: 100 - e, strokeWidth: 50, className: C(Et.TotpCountdown, {
    [Et.finishing]: e >= 84,
    [Et.starting]: e < 2,
    [Et.darkMode]: i === "dark",
    [Et.hidden]: !!t
  }, o), counterClockwise: !0 });
}
const Nd = "_CopyButton_x6l9h_1", Ad = "_success_x6l9h_27", Ld = "_Icon_x6l9h_35", Pd = "_Content_x6l9h_52", ht = {
  CopyButton: Nd,
  success: Ad,
  Icon: Ld,
  Content: Pd
};
function Rd({
  onClick: e,
  className: t,
  success: o,
  defaultIcon: i,
  defaultText: r,
  successText: s,
  successIcon: a,
  disabled: c
}) {
  const d = i, l = a ?? i;
  return /* @__PURE__ */ n("button", { className: C(ht.CopyButton, t), onClick: e, type: "button", disabled: c, children: /* @__PURE__ */ n(Yn, { active: o, activeChildren: /* @__PURE__ */ m("div", { className: C(ht.Content, ht.success), children: [
    /* @__PURE__ */ n("div", { className: ht.Icon, children: /* @__PURE__ */ n(l, {}) }),
    /* @__PURE__ */ n("p", { children: s ?? r })
  ] }), defaultChildren: /* @__PURE__ */ m("div", { className: ht.Content, children: [
    /* @__PURE__ */ n("div", { className: ht.Icon, children: /* @__PURE__ */ n(d, {}) }),
    /* @__PURE__ */ n("p", { children: r })
  ] }) }) });
}
function Ab({
  onClick: e,
  className: t,
  copied: o,
  disabled: i
}) {
  return /* @__PURE__ */ n(Rd, { className: t, success: o, defaultText: u._(
    /** i18n */
    {
      id: "he3ygx"
    }
  ), defaultIcon: cn, successText: u._(
    /** i18n */
    {
      id: "6V3Ea3"
    }
  ), successIcon: Vt, onClick: e, disabled: i });
}
const Bd = "_ArrowIcon_xe8or_1", Qt = {
  ArrowIcon: Bd
}, Jn = ke.forwardRef(({
  direction: e,
  className: t,
  ...o
}, i) => e === "up" ? /* @__PURE__ */ n(Hs, { ref: i, className: C(Qt.ArrowIcon, t), ...o }) : e === "right" ? /* @__PURE__ */ n(Ds, { ref: i, className: C(Qt.ArrowIcon, t), ...o }) : e === "down" ? /* @__PURE__ */ n(Ws, { ref: i, className: C(Qt.ArrowIcon, t), ...o }) : /* @__PURE__ */ n(Os, { ref: i, className: C(Qt.ArrowIcon, t), ...o })), Td = "_MoreOptions_ta625_1", Ed = "_MoreOptionsCollapse_ta625_18", $d = "_visible_ta625_32", Bn = {
  MoreOptions: Td,
  MoreOptionsCollapse: Ed,
  visible: $d
};
function Lb({
  children: e,
  ...t
}) {
  const [o, i] = R(!1), r = D(null);
  return /* @__PURE__ */ m("div", { ...t, children: [
    /* @__PURE__ */ m(me, { buttonStyle: "tertiary", size: "small", type: "button", onClick: () => {
      o ? i(!1) : (i(!0), window.setTimeout(() => {
        r.current && Ii(r.current, {
          scrollMode: "if-needed",
          behavior: "smooth",
          block: "nearest",
          inline: "nearest"
        });
      }, 100));
    }, className: C(Bn.MoreOptions), children: [
      /* @__PURE__ */ n("span", { children: /* @__PURE__ */ n(f, { id: "3Siwmw" }) }),
      /* @__PURE__ */ n(Jn, { direction: o ? "up" : "down" })
    ] }),
    /* @__PURE__ */ n("div", { className: C(Bn.MoreOptionsCollapse, {
      [Bn.visible]: o
    }), ref: r, children: e })
  ] });
}
const xd = "_LinkButton_sy3k1_1 _UnstyledButton_r3cpb_208", Md = {
  LinkButton: xd
};
function it({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ n("button", { className: C(Md.LinkButton, e), ...o, children: t });
}
const Fd = "_MessageBox_1pt86_1", kd = "_large_1pt86_21", Wd = "_hasClose_1pt86_24", Od = "_success_1pt86_27", Dd = "_warning_1pt86_31", Hd = "_error_1pt86_35", Ud = "_dark_1pt86_39", Vd = "_light_1pt86_40", zd = "_highlight_1pt86_40", qd = "_hidden_1pt86_43", jd = "_Content_1pt86_57", Gd = "_SmallIcon_1pt86_61", Kd = "_SmallContent_1pt86_72", Yd = "_LargeIcon_1pt86_83", Xd = "_LargeText_1pt86_93", Jd = "_LargeHeadline_1pt86_99", Qd = "_LargeContent_1pt86_109", Zd = "_Close_1pt86_127 _UnstyledButton_r3cpb_208", ue = {
  MessageBox: Fd,
  large: kd,
  hasClose: Wd,
  success: Od,
  warning: Dd,
  error: Hd,
  dark: Ud,
  light: Vd,
  highlight: zd,
  hidden: qd,
  Content: jd,
  SmallIcon: Gd,
  SmallContent: Kd,
  LargeIcon: Yd,
  LargeText: Xd,
  LargeHeadline: Jd,
  LargeContent: Qd,
  Close: Zd
};
function Ot(e) {
  const {
    sizeProps: t,
    restProps: o
  } = eu(e), {
    hidden: i,
    type: r,
    onClose: s,
    className: a,
    children: c,
    style: d,
    contentClassName: l,
    ...p
  } = o, _ = X(), h = Nt(), [g, w] = $e();
  return /* @__PURE__ */ m("div", { className: C(ue.MessageBox, r && ue[r], ue[_], ue[h], a, {
    [ue.hidden]: i,
    [ue.large]: t.large,
    [ue.hasClose]: !!s
  }), "aria-hidden": i, style: {
    ...d,
    "--content-height": w.height > 0 ? `${w.height}px` : "auto"
  }, ...p, children: [
    /* @__PURE__ */ n("div", { className: ue.Content, ref: g, children: t.large ? /* @__PURE__ */ n(nu, { headline: t.headline, icon: t.icon, contentClassName: l, children: c }) : /* @__PURE__ */ n(tu, { type: r, noDefaultIcon: t.noDefaultIcon, contentClassName: l, children: c }) }),
    s && /* @__PURE__ */ n("button", { type: "button", onClick: s, className: ue.Close, children: /* @__PURE__ */ n(fn, { "aria-label": u._(
      /** i18n */
      {
        id: "yz7wBu"
      }
    ) }) })
  ] });
}
function eu(e) {
  if (e.large) {
    const {
      large: r,
      headline: s,
      icon: a,
      ...c
    } = e;
    return {
      sizeProps: {
        large: r,
        headline: s,
        icon: a
      },
      restProps: c
    };
  }
  const {
    large: t,
    noDefaultIcon: o,
    ...i
  } = e;
  return {
    sizeProps: {
      large: t,
      noDefaultIcon: o
    },
    restProps: i
  };
}
function tu({
  type: e,
  noDefaultIcon: t,
  children: o,
  contentClassName: i
}) {
  return /* @__PURE__ */ m(T, { children: [
    !t && (e === "success" ? /* @__PURE__ */ n(Vs, { className: ue.SmallIcon }) : e === "warning" || e === "error" ? /* @__PURE__ */ n(zs, { className: ue.SmallIcon }) : e === "progress" ? /* @__PURE__ */ n("div", { className: ue.SmallIcon, children: /* @__PURE__ */ n(Cn, { size: "1rem", armCount: 10, armWidth: 0.15, armHeight: 0.3 }) }) : null),
    /* @__PURE__ */ n("div", { className: C(ue.SmallContent, i), children: o })
  ] });
}
function nu({
  headline: e,
  icon: t,
  children: o,
  contentClassName: i
}) {
  return /* @__PURE__ */ m(T, { children: [
    t && /* @__PURE__ */ n(t, { className: ue.LargeIcon }),
    /* @__PURE__ */ m("div", { className: ue.LargeText, children: [
      /* @__PURE__ */ n("p", { className: ue.LargeHeadline, children: /* @__PURE__ */ n("strong", { children: e }) }),
      /* @__PURE__ */ n("p", { className: C(ue.LargeContent, i), children: o })
    ] })
  ] });
}
function ou({
  children: e,
  message: t,
  recheck: o,
  hidden: i,
  onRecheckSuccess: r,
  ...s
}) {
  const [a, c] = R(), d = B(async () => {
    if (o)
      try {
        c("inProgress"), await Promise.all([o(), hn(2e3)]), c("done");
      } catch {
        c(void 0);
      }
  }, [o]);
  return k(() => {
    if (a === "done")
      c(i ? "showSuccess" : void 0);
    else if (a === "showSuccess") {
      const l = window.setTimeout(() => c("hideSuccess"), 2e3);
      return () => window.clearTimeout(l);
    }
  }, [i, r, a]), a === "inProgress" ? /* @__PURE__ */ n(Ot, { type: "progress", ...s, children: /* @__PURE__ */ n(f, { id: "2SqvU5" }) }) : a === "showSuccess" || a === "hideSuccess" ? /* @__PURE__ */ n(Ot, { ...s, type: "success", hidden: a === "hideSuccess", onTransitionEnd: () => {
    c(void 0), r?.();
  }, children: /* @__PURE__ */ n(f, { id: "J8XjuC" }) }) : /* @__PURE__ */ m(Ot, { ...s, type: "warning", hidden: i, children: [
    t,
    " ",
    o && /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n(it, { type: "button", onClick: () => {
        d().catch($);
      }, children: /* @__PURE__ */ n(f, { id: "3WxAes" }) }),
      " "
    ] }),
    e
  ] });
}
function iu(e) {
  return /* @__PURE__ */ n(ou, { message: u._(
    /** i18n */
    {
      id: "HqgpzW"
    }
  ), ...e });
}
const Qn = {
  length: 16,
  letters: !0,
  numbers: !0,
  special: !0
};
function Ui({
  password: e,
  setPassword: t,
  initialState: o,
  onSettingsChange: i
}) {
  const [r, s] = R(o), a = ru(r, e), c = B((h) => {
    if (eo(h)) {
      const g = dn(h.length, h.letters, h.letters, h.numbers, h.special);
      t(g.value, !0), i?.(g.value);
    } else
      t("", !1), i?.("");
  }, [i, t]);
  k(() => {
    const h = Je(o);
    (r.type === "generatedPolicy" || r.type === "generatedNoPolicy") && !we(r, o) ? (s(o), c(h)) : r.type === "generatedCustom" && we(r.settings, h) && s(o);
  }, [o, r, c]);
  const d = B((h) => {
    const g = Je(o), w = we(g, h);
    r.type === "generatedCustom" && we(r.settings, h) || r.type === o.type && w || (w ? (s(o), c(g)) : (s({
      type: "generatedCustom",
      settings: h
    }), c(h)));
  }, [o, r, c]), l = B((h) => {
    t(h, !1), s({
      type: "userInput"
    });
  }, [t]), p = M(() => () => {
    let h;
    r.type === "userInput" ? (s(o), h = Je(o)) : h = Je(r);
    const g = dn(h.length, h.letters, h.letters, h.numbers, h.special).value;
    t(g, !0);
  }, [o, r, t]), _ = B(() => {
    s(o);
    const h = Je(o);
    c(h);
  }, [o, c]);
  if (r.type === "generatedPolicy" || r.type === "generatedNoPolicy")
    return {
      type: r.type,
      password: e,
      setCustomPassword: l,
      regeneratePassword: p,
      resetToInitial: _,
      strengthIndication: a,
      settings: Je(r),
      changeSettings: d
    };
  if (r.type === "generatedCustom")
    return {
      type: r.type,
      password: e,
      setCustomPassword: l,
      regeneratePassword: p,
      resetToInitial: _,
      strengthIndication: a,
      settings: Je(r),
      changeSettings: d,
      initialStateType: o.type
    };
  if (r.type === "userInput")
    return {
      type: r.type,
      password: e,
      setCustomPassword: l,
      regeneratePassword: p,
      resetToInitial: _,
      strengthIndication: a
    };
  z(r);
}
function Vi(e) {
  const t = e ?? Qn;
  return dn(t.length, t.letters, t.letters, t.numbers, t.special).value;
}
function ru(e, t) {
  return M(() => {
    if (us(t))
      return u._(
        /** i18n */
        {
          id: "sXULwc"
        }
      );
    if (e.type !== "userInput") {
      const o = Je(e);
      if (zi(o))
        return u._(
          /** i18n */
          {
            id: "FLkaGY"
          }
        );
    }
    return "";
  }, [t, e]);
}
function Je(e) {
  switch (e.type) {
    case "generatedPolicy":
      return Zn(e.policy);
    case "generatedNoPolicy":
      return e.settings ?? Qn;
    case "generatedCustom":
      return e.settings;
  }
}
function Zn(e) {
  switch (e.type) {
    case "custom": {
      const t = {
        letters: !0,
        numbers: e.rules.numbers,
        special: e.rules.special
      };
      return {
        ...t,
        length: Math.max(e.rules.length, Dt(t))
      };
    }
    default:
      z(e.type);
  }
}
function zi(e) {
  return eo(e) && e.length >= 12 && e.letters;
}
function eo(e) {
  return e.length >= Dt(e) && (e.letters || e.numbers || e.special);
}
function Dt(e) {
  return (e.numbers ? 1 : 0) + (e.letters ? 2 : 0) + (e.special ? 1 : 0);
}
function Zt(e, t, {
  ignoreKeys: o,
  customGetDifferenceCount: i
} = {}) {
  const r = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]);
  if (o)
    for (const a of o)
      r.delete(a);
  return Array.from(r).reduce((a, c) => {
    const d = e[c], l = t[c], p = i?.[c];
    return p ? a + p(d, l) : Us(d, l) ? a : a + 1;
  }, 0);
}
function Uo(e, t, o) {
  o && o.preventDefault && typeof o.preventDefault == "function" && o.preventDefault(), o && o.stopPropagation && typeof o.stopPropagation == "function" && o.stopPropagation(), e.submitForm().catch(t);
}
const su = "_SubtleLink_waso4_1", cu = {
  SubtleLink: su
};
function qi({
  element: e,
  className: t,
  children: o,
  ...i
}) {
  return /* @__PURE__ */ n(e ?? "a", { className: C(cu.SubtleLink, t), ...i, children: o });
}
const au = "_IconWrapper_1wbwy_1", lu = "_Icon_1wbwy_1", Vo = {
  IconWrapper: au,
  Icon: lu
}, zo = "external noreferrer";
function Ae({
  children: e,
  noIcon: t,
  rel: o,
  ...i
}) {
  return /* @__PURE__ */ m(qi, { target: "_blank", rel: o ? `${zo} ${o}` : zo, ...i, children: [
    e,
    !t && /* @__PURE__ */ n("span", { className: Vo.IconWrapper, children: /* @__PURE__ */ n(Gs, { className: Vo.Icon }) })
  ] });
}
const du = "_ShortcutHint_4cxcy_1", uu = "_dark_4cxcy_14", pu = "_lightBackground_4cxcy_18", Tn = {
  ShortcutHint: du,
  dark: uu,
  lightBackground: pu
};
function _u({
  label: e,
  className: t,
  lightBackground: o,
  ...i
}) {
  const r = X();
  return /* @__PURE__ */ n("div", { className: C(t, Tn.ShortcutHint, Tn[r], o && Tn.lightBackground), ...i, children: e });
}
const hu = "_LoginStatus_1oh3r_1", mu = "_dark_1oh3r_8", fu = "_HeadlineWrapper_1oh3r_13", gu = "_Headline_1oh3r_13", yu = "_LearnMore_1oh3r_29", Cu = "_Table_1oh3r_38", mt = {
  LoginStatus: hu,
  dark: mu,
  HeadlineWrapper: fu,
  Headline: gu,
  LearnMore: yu,
  Table: Cu
};
async function ji(e) {
  throw await hn(e), new to();
}
class to extends Error {
}
function Gi(e) {
  const [t, o] = R(e), i = D(e), r = D(), s = B(() => {
    r.current?.cancel();
    const c = new hi();
    return r.current = c, c;
  }, []), a = B(async (c) => {
    const d = s();
    let l;
    const p = (_) => {
      if (window.clearTimeout(l), d.isCancelled)
        throw new We();
      i.current = _, o(_);
    };
    return c((_, h) => {
      h ? l = window.setTimeout(() => p(_), h) : p(_);
    }, d);
  }, [s]);
  return [t, i, a];
}
const wu = 2e3, bu = 2e3;
function vu({
  initialLeakedPasswordCheckStatus: e,
  updateEnabled: t,
  getLeakedPasswordData: o
}) {
  const [i, r, s] = Gi(e ?? (t ? {
    status: "inProgress"
  } : void 0)), a = B(async (_) => r.current?.status !== "timeout" && r.current?.status !== "error" && r.current?.status !== "waiting" && r.current?.status !== "inProgress" && r.current?.password === _ ? r.current : s(async (h, g) => {
    h({
      status: "inProgress",
      password: _
    });
    const w = await qo(_, o, g);
    return h(w), w;
  }), [o, r, s]), c = B((_) => {
    a(_).catch((h) => {
      h instanceof We || $(h);
    });
  }, [a]), d = B(async (_) => {
    try {
      return await a(_);
    } catch (h) {
      if (h instanceof We)
        return qo(_, o);
      throw h;
    }
  }, [o, a]), l = M(() => mn(bu, c), [c]), p = B((_) => {
    s((h) => {
      h({
        status: "waiting",
        password: _
      });
    }).catch($), l(_);
  }, [l, s]);
  return t ? {
    leakedPasswordCheckStatus: i,
    updateLeakedPasswordCheck: c,
    updateLeakedPasswordCheckWithResult: d,
    enqueueUpdateLeakedPasswordCheck: p
  } : {
    leakedPasswordCheckStatus: e,
    updateLeakedPasswordCheck: () => {
    },
    updateLeakedPasswordCheckWithResult: async (_) => ({
      status: "timeout",
      password: _
    }),
    enqueueUpdateLeakedPasswordCheck: () => {
    }
  };
}
async function qo(e, t, o) {
  const i = ps(e);
  if (i !== void 0)
    return {
      status: "skipped",
      password: e,
      reason: i
    };
  try {
    const {
      leakCount: r,
      leakedPasswordsChangeTime: s
    } = await Promise.race([t(e, o), ji(wu)]);
    return {
      status: "checked",
      password: e,
      leakCount: r,
      checkedAt: (/* @__PURE__ */ new Date()).toISOString(),
      leakedPasswordsChangeTime: s
    };
  } catch (r) {
    if (r instanceof We)
      throw r;
    return r instanceof to ? {
      status: "timeout",
      password: e
    } : {
      status: "error",
      error: r
    };
  }
}
function jo(e) {
  return e.status === "checked" || e.status === "skipped" || e.status === "timeout" || e.status === "error";
}
const Su = "_LoginStatusLine_1fd95_1", Iu = "_Label_1fd95_6", Nu = "_Info_1fd95_16", Au = "_dark_1fd95_30", Lu = "_hidden_1fd95_35", Pu = "_LabelInner_1fd95_45", Ru = "_ElementHider_1fd95_63", Ue = {
  LoginStatusLine: Su,
  Label: Iu,
  Info: Nu,
  dark: Au,
  hidden: Lu,
  LabelInner: Pu,
  ElementHider: Ru
};
function wn({
  label: e,
  children: t,
  hidden: o
}) {
  const i = X();
  return /* @__PURE__ */ m("tr", { className: C(Ue.LoginStatusLine, o && Ue.hidden, i === "dark" && Ue.dark), children: [
    /* @__PURE__ */ n("th", { className: Ue.Label, children: /* @__PURE__ */ n("div", { className: C(Ue.LabelInner, o && Ue.hidden), children: /* @__PURE__ */ n("span", { children: e }) }) }),
    /* @__PURE__ */ n("td", { className: Ue.Info, children: /* @__PURE__ */ n(Bu, { hidden: o, children: /* @__PURE__ */ n(Ut, { children: t }) }) })
  ] });
}
function Bu({
  hidden: e,
  children: t
}) {
  const [o, {
    height: i
  }] = $e();
  return /* @__PURE__ */ n("div", { className: C(Ue.ElementHider, e && Ue.hidden), style: {
    "--height": i !== 0 ? `${i}px` : void 0
  }, children: /* @__PURE__ */ n("div", { ref: o, children: t }) });
}
const Tu = "_LoginStatusLineInfo_6v1yp_1", Eu = "_Icon_6v1yp_7", $u = "_Title_6v1yp_12", xu = "_HoverOverlay_6v1yp_16", Mu = "_grey_6v1yp_30", Fu = "_red_6v1yp_34", ku = "_green_6v1yp_42", Ye = {
  LoginStatusLineInfo: Tu,
  Icon: Eu,
  Title: $u,
  HoverOverlay: xu,
  grey: Mu,
  red: Fu,
  green: ku
};
function re({
  status: e,
  title: t,
  children: o,
  grey: i,
  hoverOverlay: r
}) {
  const s = /* @__PURE__ */ m(T, { children: [
    e === void 0 ? null : e === "check" ? /* @__PURE__ */ n(Li, { className: Ye.Icon }) : e === "exclamationMark" ? /* @__PURE__ */ n(Pi, { className: Ye.Icon }) : e === "inProgress" ? /* @__PURE__ */ n(Cn, { size: "1.2rem", armCount: 12 }) : z(e),
    /* @__PURE__ */ n("span", { className: Ye.Title, children: t })
  ] });
  return /* @__PURE__ */ m("div", { className: C(Ye.LoginStatusLineInfo, {
    [Ye.green]: e === "check",
    [Ye.red]: e === "exclamationMark",
    [Ye.grey]: e === "inProgress" || i
  }), children: [
    r ? /* @__PURE__ */ n(Xn, { element: "span", className: Ye.HoverOverlay, downwards: !0, overlay: r, children: s }) : s,
    o && /* @__PURE__ */ n("span", { children: o })
  ] });
}
const Wu = "_LoginStatusLineMessage_1t0ux_1", Ou = "_hidden_1t0ux_4", Go = {
  LoginStatusLineMessage: Wu,
  hidden: Ou
};
function Du({
  children: e,
  hidden: t
}) {
  return /* @__PURE__ */ n("p", { className: C(Go.LoginStatusLineMessage, t && Go.hidden), "aria-hidden": !t, children: e });
}
function Hu({
  leakedPasswordCheckStatus: e,
  hidden: t
}) {
  const [o, i] = R(jo(e) ? e : void 0);
  k(() => {
    jo(e) && o !== e && i(e);
  }, [o, e]);
  const r = e.status === "checked" && e.leakCount !== 0;
  return /* @__PURE__ */ n(wn, { label: u._(
    /** i18n */
    {
      id: "jqKyAL"
    }
  ), hidden: t, children: /* @__PURE__ */ m(
    "div",
    {
      children: [
        e.status === "checked" ? e.leakCount === 0 ? /* @__PURE__ */ n(re, { status: "check", title: u._(
          /** i18n */
          {
            id: "dsVW-d"
          }
        ) }) : /* @__PURE__ */ n(re, { status: "exclamationMark", title: u._(
          /** i18n */
          {
            id: "yVsUTE"
          }
        ) }) : e.status === "waiting" ? /* @__PURE__ */ n(re, { title: u._(
          /** i18n */
          {
            id: "IVBLxC"
          }
        ), grey: !0 }) : e.status === "inProgress" ? /* @__PURE__ */ n(re, { status: "inProgress", title: u._(
          /** i18n */
          {
            id: "RLe7Vk"
          }
        ) }) : e.status === "error" || e.status === "timeout" ? /* @__PURE__ */ n(re, { title: u._(
          /** i18n */
          {
            id: "dgi-MR"
          }
        ) }) : e.status === "skipped" ? e.reason === Po.empty ? /* @__PURE__ */ n(re, { title: u._(
          /** i18n */
          {
            id: "9QBiCg"
          }
        ) }) : e.reason === Po.pin ? /* @__PURE__ */ n(re, { title: u._(
          /** i18n */
          {
            id: "OD70Pz"
          }
        ) }) : z(e.reason) : z(e),
        (r || o?.status === "checked" && o?.leakCount !== 0) && /* @__PURE__ */ n(Du, { hidden: !r, children: /* @__PURE__ */ n(f, { id: "2DMQa6" }) })
      ]
    },
    e.status === "checked" ? e.leakCount === 0 ? "ok" : "leaked" : e.status
  ) });
}
function Uu({
  passwordOrigin: e,
  hidden: t
}) {
  return /* @__PURE__ */ n(wn, { label: u._(
    /** i18n */
    {
      id: "Zh8_S3"
    }
  ), hidden: t, children: e && /* @__PURE__ */ n(Vu, { passwordOrigin: e }) });
}
function Vu({
  passwordOrigin: e
}) {
  switch (e.type) {
    case "generator":
      return /* @__PURE__ */ n(re, { status: "check", title: u._(
        /** i18n */
        {
          id: "io56z3"
        }
      ) }, e.type);
    case "import":
      return /* @__PURE__ */ n(re, { title: u._(
        /** i18n */
        {
          id: "l3s5ri"
        }
      ) }, e.type);
    case "userInput":
      return /* @__PURE__ */ n(re, { title: u._(
        /** i18n */
        {
          id: "75kBFR"
        }
      ) }, e.type);
    case "shareLink":
      return /* @__PURE__ */ n(re, { title: e.senderEmail ? u._(
        /** i18n */
        {
          id: "KvvdlN",
          values: {
            0: e.senderEmail
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "yXCI8f"
        }
      ) }, e.type);
    default:
      return z(e);
  }
}
const zu = "_RuleResultsInfo_z5awn_1", qu = "_RuleResultInfo_z5awn_12", ju = "_Icon_z5awn_21", Gu = "_fulfilled_z5awn_25", kt = {
  RuleResultsInfo: zu,
  RuleResultInfo: qu,
  Icon: ju,
  fulfilled: Gu
};
function Ku({
  passwordQualityCheckStatus: e,
  hidden: t
}) {
  return e.status === "noPolicy" ? null : /* @__PURE__ */ n(wn, { label: e.checkSource === "passwordPolicy" ? u._(
    /** i18n */
    {
      id: "Xjatg3"
    }
  ) : e.checkSource === "defaultRules" ? u._(
    /** i18n */
    {
      id: "Dib_Lo"
    }
  ) : z(e), hidden: t, children: e.status === "checked" ? e.result ? /* @__PURE__ */ n(re, { status: "check", title: e.checkSource === "passwordPolicy" ? u._(
    /** i18n */
    {
      id: "yrwl2P"
    }
  ) : e.checkSource === "defaultRules" ? u._(
    /** i18n */
    {
      id: "SFzKmX"
    }
  ) : z(e), hoverOverlay: /* @__PURE__ */ n(Hn, { ruleResults: e.ruleResults, rules: e.rules }) }, "check") : /* @__PURE__ */ n(re, { status: e.checkSource === "passwordPolicy" ? "exclamationMark" : void 0, title: e.checkSource === "passwordPolicy" ? u._(
    /** i18n */
    {
      id: "PE_sod"
    }
  ) : e.checkSource === "defaultRules" ? u._(
    /** i18n */
    {
      id: "Kts_x5"
    }
  ) : z(e), hoverOverlay: /* @__PURE__ */ n(Hn, { ruleResults: e.ruleResults, rules: e.rules }) }, "exclamationMark") : e.status === "skipped" ? e.reason === Bo.empty ? /* @__PURE__ */ n(re, { title: u._(
    /** i18n */
    {
      id: "9QBiCg"
    }
  ) }) : e.reason === Bo.pin ? /* @__PURE__ */ n(re, { title: u._(
    /** i18n */
    {
      id: "sXULwc"
    }
  ) }, "pin") : z(e.reason) : z(e) });
}
function Hn({
  ruleResults: e,
  rules: t
}) {
  const o = /* @__PURE__ */ n(T, { children: "‑" });
  return /* @__PURE__ */ m("ul", { className: kt.RuleResultsInfo, children: [
    /* @__PURE__ */ n($t, { fulfilled: e.lower, children: /* @__PURE__ */ n(f, { id: "sbGnrd", values: {
      nonBreakingHyphen: o
    } }) }),
    e.upper !== void 0 && /* @__PURE__ */ n($t, { fulfilled: e.upper, children: /* @__PURE__ */ n(f, { id: "umLW9t", values: {
      nonBreakingHyphen: o
    } }) }),
    e.numbers !== void 0 && /* @__PURE__ */ n($t, { fulfilled: e.numbers, children: /* @__PURE__ */ n(f, { id: "qdmWOt", values: {
      nonBreakingHyphen: o
    } }) }),
    e.special !== void 0 && /* @__PURE__ */ n($t, { fulfilled: e.special, children: /* @__PURE__ */ n(f, { id: "9XZ3SQ" }) }),
    " ",
    /* @__PURE__ */ n($t, { fulfilled: e.length, children: /* @__PURE__ */ n(f, { id: "gKfrpZ", values: {
      0: t.length
    } }) })
  ] });
}
function $t({
  fulfilled: e,
  children: t
}) {
  return /* @__PURE__ */ m("li", { className: C(kt.RuleResultInfo, e && kt.fulfilled), children: [
    e ? /* @__PURE__ */ n(Li, { className: kt.Icon }) : /* @__PURE__ */ n(Ks, { className: kt.Icon }),
    t
  ] });
}
function Yu({
  totpAvailableCheckStatus: e,
  hidden: t
}) {
  return e.status === "initial" ? null : /* @__PURE__ */ n(wn, { label: u._(
    /** i18n */
    {
      id: "uTlc8J"
    }
  ), hidden: t, children: /* @__PURE__ */ n(
    "div",
    {
      children: e.status === "setValid" ? /* @__PURE__ */ n(re, { status: "check", title: u._(
        /** i18n */
        {
          id: "F6pfE9"
        }
      ) }) : e.status === "setInvalid" ? /* @__PURE__ */ n(re, { status: "exclamationMark", title: u._(
        /** i18n */
        {
          id: "JHB_Ky"
        }
      ) }) : e.status === "notSetAvailable" ? /* @__PURE__ */ n(re, { title: e.documentationUrl ? /* @__PURE__ */ n(f, { id: "LLv_gG", components: {
        0: /* @__PURE__ */ n(Ae, { href: e.documentationUrl })
      } }) : u._(
        /** i18n */
        {
          id: "0NYdnW"
        }
      ) }) : e.status === "inProgress" ? /* @__PURE__ */ n(re, { status: "inProgress", title: u._(
        /** i18n */
        {
          id: "RLe7Vk"
        }
      ) }) : e.status === "error" || e.status === "timeout" ? /* @__PURE__ */ n(re, { title: u._(
        /** i18n */
        {
          id: "eSarfH"
        }
      ) }) : e.status === "noWebsites" || e.status === "notSetUnknown" ? null : z(e)
    },
    e.status
  ) });
}
function Xu({
  leakedPasswordCheckStatus: e,
  passwordQualityCheckStatus: t,
  totpAvailableCheckStatus: o,
  passwordOrigin: i,
  hidePasswordStatus: r,
  className: s,
  ...a
}) {
  const c = X(), d = r || !e, l = r || t.status === "noPolicy", p = o.status === "initial" || o.status === "noWebsites" || o.status === "notSetUnknown", _ = r || i === void 0;
  return d && l && p && _ ? null : /* @__PURE__ */ m("div", { ...a, className: C(mt.LoginStatus, s, {
    [mt.dark]: c === "dark"
  }), children: [
    /* @__PURE__ */ m("div", { className: mt.HeadlineWrapper, children: [
      /* @__PURE__ */ n("h3", { className: mt.Headline, children: /* @__PURE__ */ n(f, { id: "a7UoOG" }) }),
      /* @__PURE__ */ n(Ae, { href: u._(
        /** i18n */
        {
          id: "zL0h3H"
        }
      ), className: mt.LearnMore, children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) })
    ] }),
    /* @__PURE__ */ n("table", { className: mt.Table, children: /* @__PURE__ */ m("tbody", { children: [
      e && /* @__PURE__ */ n(Hu, { leakedPasswordCheckStatus: e, hidden: d }),
      /* @__PURE__ */ n(Ku, { passwordQualityCheckStatus: t, hidden: l }),
      /* @__PURE__ */ n(Uu, { passwordOrigin: i, hidden: _ }),
      o && /* @__PURE__ */ n(Yu, { totpAvailableCheckStatus: o, hidden: p })
    ] }) })
  ] });
}
const Ju = "_SectionBox_1ltrl_1", Qu = "_darkMode_1ltrl_12", Zu = "_Header_1ltrl_17", ep = "_Headline_1ltrl_23", tp = "_Body_1ltrl_29", np = "_fullWidth_1ltrl_32", ft = {
  SectionBox: Ju,
  darkMode: Qu,
  Header: Zu,
  Headline: ep,
  Body: tp,
  fullWidth: np
};
function no({
  className: e,
  children: t,
  headline: o,
  headlineLevel: i,
  fullWidthBody: r,
  bodyClassName: s,
  headerClassName: a,
  ...c
}) {
  const d = `h${i ?? 3}`, l = X();
  return /* @__PURE__ */ m("div", { className: C(ft.SectionBox, {
    [ft.darkMode]: l === "dark"
  }, e), ...c, children: [
    o && /* @__PURE__ */ n("header", { className: C(ft.Header, a), children: /* @__PURE__ */ n(d, { className: ft.Headline, children: o }) }),
    /* @__PURE__ */ n("div", { className: C(ft.Body, {
      [ft.fullWidth]: r
    }, s), children: t })
  ] });
}
const op = "_BoxBody_14o0b_1", ip = "_Restore_14o0b_6", Ko = {
  BoxBody: op,
  Restore: ip
};
function rp({
  loginLabel: e,
  movedLoginInfo: t,
  ...o
}) {
  const [i, r] = R(!1), s = M(() => {
    if (t.kind !== "delete")
      return;
    const a = t.restore;
    if (a)
      return async () => {
        try {
          r(!0), await a();
        } finally {
          r(!1);
        }
      };
  }, [t]);
  return /* @__PURE__ */ m(no, { ...o, bodyClassName: Ko.BoxBody, children: [
    /* @__PURE__ */ m("span", { children: [
      t.kind === "transfer" ? /* @__PURE__ */ n(f, { id: "Q7krwP", values: {
        0: t.recipientEmail,
        loginLabel: e
      } }) : t.kind === "delete" ? t.newPath ? /* @__PURE__ */ n(f, { id: "-BllQ_", values: {
        loginLabel: e
      }, components: {
        0: /* @__PURE__ */ n(et, { to: t.newPath })
      } }) : /* @__PURE__ */ n(f, { id: "nYAZ22", values: {
        loginLabel: e
      } }) : /* @__PURE__ */ n(f, { id: "BBrYPy", values: {
        0: sp(t),
        loginLabel: e
      } }),
      t.newPath && t.kind === "move" && /* @__PURE__ */ m(T, { children: [
        " ",
        /* @__PURE__ */ n(et, { to: t.newPath, children: /* @__PURE__ */ n(f, { id: "Jf0PuK" }) })
      ] })
    ] }),
    s && /* @__PURE__ */ n(me, { buttonStyle: "secondary", size: "small", onClick: s, className: Ko.Restore, disabled: i, children: i ? /* @__PURE__ */ n(f, { id: "I89uD4" }) : /* @__PURE__ */ n(f, { id: "yKu_3Y" }) })
  ] });
}
function sp({
  newVaultLabel: e,
  newTag: t
}) {
  return `${t ? `${e}/${t}` : e}`;
}
const cp = "_LoginPropertiesBox_xvcs5_1", ap = "_dark_xvcs5_8", lp = "_HeadlineWrapper_xvcs5_14", dp = "_Icon_xvcs5_20", up = "_Headline_xvcs5_14", pp = "_HeadlineControls_xvcs5_37", _p = "_LoginProperties_xvcs5_1", hp = "_Property_xvcs5_53", Ze = {
  LoginPropertiesBox: cp,
  dark: ap,
  HeadlineWrapper: lp,
  Icon: dp,
  Headline: up,
  HeadlineControls: pp,
  LoginProperties: _p,
  Property: hp
};
function Ki({
  className: e,
  icon: t,
  headline: o,
  headlineControls: i,
  children: r,
  ...s
}) {
  const a = X();
  return /* @__PURE__ */ m("div", { ...s, className: C(Ze.LoginPropertiesBox, e, {
    [Ze.dark]: a === "dark"
  }), children: [
    /* @__PURE__ */ m("div", { className: Ze.HeadlineWrapper, children: [
      /* @__PURE__ */ n(t, { className: Ze.Icon }),
      /* @__PURE__ */ n("h3", { className: Ze.Headline, children: o }),
      /* @__PURE__ */ n("div", { className: Ze.HeadlineControls, children: i })
    ] }),
    r
  ] });
}
function Yi({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ n("div", { className: C(e, Ze.LoginProperties), ...o, children: t });
}
function tt({
  className: e,
  headline: t,
  children: o,
  ...i
}) {
  return /* @__PURE__ */ m("div", { className: C(e, Ze.Property), ...i, children: [
    /* @__PURE__ */ n("h4", { children: t }),
    /* @__PURE__ */ n("p", { children: o })
  ] });
}
function mp({
  passkey: e,
  creationTime: t,
  noRpIdLink: o,
  showUsernames: i,
  ...r
}) {
  const s = e.username.trim() || void 0, a = e.userDisplayName.trim() || void 0;
  return /* @__PURE__ */ n(Ki, { ...r, headline: u._(
    /** i18n */
    {
      id: "FGSN4s"
    }
  ), headlineControls: /* @__PURE__ */ n(Ae, { href: u._(
    /** i18n */
    {
      id: "gI3rrk"
    }
  ), children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) }), icon: Ys, children: /* @__PURE__ */ m(Yi, { children: [
    /* @__PURE__ */ n(tt, { headline: /* @__PURE__ */ n(f, { id: "On0aF2" }), children: o ? e.rpId : /* @__PURE__ */ n(Ae, { href: `https://${e.rpId}`, children: e.rpId }) }),
    i && /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n(tt, { headline: /* @__PURE__ */ n(f, { id: "-mYRSM" }), children: s ?? /* @__PURE__ */ n("em", { children: /* @__PURE__ */ n(f, { id: "sC7b2B" }) }) }),
      a && a !== s && /* @__PURE__ */ n(tt, { headline: /* @__PURE__ */ n(f, { id: "SffKi3" }), children: a })
    ] }),
    t && /* @__PURE__ */ n(tt, { headline: /* @__PURE__ */ n(f, { id: "FNcMGM" }), children: ln(new Date(t ?? 0), "PPPp", {
      locale: Ve()
    }) })
  ] }) });
}
function fp(e) {
  const [t, o] = R(rn(e)), i = B(() => {
    o(rn(e));
  }, [e]), r = B((s) => {
    o((a) => ({
      ...a,
      [s]: !1
    }));
  }, []);
  return k(() => {
    o((s) => rn(e, s));
  }, [e]), {
    nonEmptyFields: t,
    resetNonEmptyFields: i,
    resetNonEmptyField: r
  };
}
function rn(e, t) {
  const o = {};
  for (const i of Object.keys(e)) {
    const r = i, s = e[r], a = t?.[r];
    let c;
    typeof s == "object" && !Array.isArray(s) && s !== null ? c = rn(s, a) : c = Un(s) || !!a, o[r] = c;
  }
  return o;
}
function Un(e) {
  return Array.isArray(e) ? e.length > 0 && e.some(Un) : typeof e == "object" && e !== null ? Object.values(e).some(Un) : !!e;
}
function gp({
  passwordIsGenerated: e,
  password: t,
  initialPassword: o,
  initialPasswordOrigin: i
}) {
  return M(() => e ? {
    type: "generator"
  } : t === o ? i : {
    type: "userInput"
  }, [e, t, o, i]);
}
function Xi({
  policy: e,
  skipDefaultRules: t,
  initialPassword: o
}) {
  const i = M(() => e ? {
    rules: _s(e),
    source: {
      checkSource: "passwordPolicy",
      passwordPolicyChangeTime: e.changeTime
    }
  } : {
    rules: qs,
    source: {
      checkSource: "defaultRules"
    },
    skipCheck: t
  }, [e, t]), r = B((_) => {
    if (i.source.checkSource === "defaultRules" && i.skipCheck)
      return {
        status: "noPolicy",
        ...i.source
      };
    const h = hs(_);
    if (h)
      return {
        status: "skipped",
        reason: h,
        password: _,
        ...i.source
      };
    const {
      result: g,
      ruleResults: w
    } = ms(_, i.rules);
    return {
      status: "checked",
      result: g,
      ruleResults: w,
      rules: i.rules,
      password: _,
      ...i.source
    };
  }, [i]), [s, a] = R(() => r(o)), c = B((_) => {
    l.current = _, a(r(_));
  }, [r]), d = B((_) => {
    l.current = _;
    const h = r(_);
    return a(h), h;
  }, [r]), l = D(), p = D(i);
  return k(() => {
    we(p.current, i) || (p.current = i, l.current && c(l.current));
  }, [i, c]), {
    passwordQualityCheckStatus: s,
    updatePasswordQualityCheck: c,
    updatePasswordQualityCheckWithResult: d
  };
}
const yp = Yt.record(Yt.string(), Yt.object({
  documentation: Yt.string().optional()
}));
let xt;
async function Cp(e) {
  if (xt)
    return xt;
  xt = bp();
  try {
    return await Promise.race([xt, wp(e)]);
  } catch (t) {
    throw t instanceof We || (xt = void 0), t;
  }
}
async function wp(e) {
  const t = e.emitter.once("cancel");
  throw e.isCancelled ? new We() : (await t, new We());
}
async function bp() {
  const t = await (await fetch(fs())).json();
  return yp.parse(t);
}
const vp = 300, Sp = 2e3;
function Ip({
  websites: e,
  scope: t,
  totp: o
}) {
  const [
    i,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    r,
    s
  ] = Gi(() => o ? {
    status: Ro(o) ? "setValid" : "setInvalid"
  } : {
    status: "initial"
  }), a = B((l, p, _) => {
    s(async (h, g) => {
      if (l) {
        h({
          status: Ro(l) ? "setValid" : "setInvalid"
        });
        return;
      }
      const w = [...p, ...Np(_)];
      if (!w.length) {
        h({
          status: "noWebsites"
        });
        return;
      }
      const b = new Set(w.flatMap((v) => {
        if (v === void 0)
          return [];
        const {
          hostname: S
        } = gs(v, {
          usePunycode: !0
        }), I = Dr(S);
        return !I.error && I.listed && I.domain ? I.domain : [];
      }));
      if (!b.size) {
        h({
          status: "noWebsites"
        });
        return;
      }
      h({
        status: "inProgress"
      }, 10);
      let y;
      try {
        y = await Promise.race([Cp(g), ji(Sp)]);
      } catch (v) {
        if (v instanceof We)
          throw v;
        if (v instanceof to) {
          h({
            status: "timeout"
          });
          return;
        }
        h({
          status: "error",
          error: v
        });
        return;
      }
      for (const v of b) {
        const S = y[v];
        if (S) {
          h({
            status: "notSetAvailable",
            documentationUrl: S.documentation
          });
          return;
        }
      }
      h({
        status: "notSetUnknown"
      });
    }).catch((h) => {
      h instanceof We || $(h);
    });
  }, [s]), c = M(() => mn(vp, a), [a]), d = D(!0);
  return k(() => {
    d.current ? (d.current = !1, a(o, e, t)) : c(o, e, t);
  }, [t, o, a, c, s, e]), i;
}
function Np(e) {
  return e?.flatMap((t) => {
    const o = Fe(t);
    return o.kind === "website" ? o.pattern : [];
  }) ?? [];
}
const Ap = "_FormElementInfoLine_1pl67_1", Lp = "_AddElement_1pl67_12 _UnstyledButton_r3cpb_208", Ji = {
  FormElementInfoLine: Ap,
  AddElement: Lp
};
function rt({
  children: e
}) {
  return /* @__PURE__ */ n("div", { className: Ji.FormElementInfoLine, children: e });
}
function bt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ n("button", { className: C(Ji.AddElement, e), type: "button", ...t });
}
const Pp = "_AddButtonGroup_11aci_1", Rp = {
  AddButtonGroup: Pp
};
function qt({
  children: e
}) {
  return /* @__PURE__ */ n("div", { className: Rp.AddButtonGroup, children: e });
}
const Bp = "_AddButton_b7n3i_1", Tp = "_emphasized_b7n3i_5", Yo = {
  AddButton: Bp,
  emphasized: Tp
}, Ep = [], Qi = _n({
  resolved: {},
  add: () => {
  },
  disabled: !1
});
function $p({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ n(Qi.Provider, { value: e, children: t });
}
function Zi() {
  return It(Qi);
}
function jt(e) {
  return Zi().resolved[e] ?? Ep;
}
function Gt({
  buttons: e,
  emphasized: t
}) {
  const {
    add: o,
    disabled: i
  } = Zi();
  return e.map((r) => /* @__PURE__ */ n(bt, { onClick: () => o(r), disabled: i, className: C(Yo.AddButton, r === t && Yo.emphasized), children: /* @__PURE__ */ n(xp, { id: r }) }, r));
}
function xp({
  id: e
}) {
  switch (e) {
    case "displayHeadline":
      return /* @__PURE__ */ n(f, { id: "EOObln" });
    case "displayName":
      return /* @__PURE__ */ n(f, { id: "oG3KmT" });
    case "totp":
      return /* @__PURE__ */ n(f, { id: "648VR4" });
    case "password":
      return /* @__PURE__ */ n(f, { id: "5_Zg7X" });
    case "website":
      return /* @__PURE__ */ n(f, { id: "iOiHwJ" });
    case "androidApp":
      return /* @__PURE__ */ n(f, { id: "bWn0ME" });
    default:
      z(e);
  }
}
function oo({
  anchor: e
}) {
  const t = jt(e);
  return t.length === 0 ? null : /* @__PURE__ */ n(rt, { children: /* @__PURE__ */ n(qt, { children: /* @__PURE__ */ n(Gt, { buttons: t }) }) });
}
const Mp = ["implicitWebsites", "scope", "websites", "wifiSsid", "username", "password", "passkey"], Fp = [
  // The scope buttons come first because they add the field they sit closest to, which is where
  // that field lays its own buttons out once it is there. Anything else would reorder the group
  // the moment the field appears.
  {
    id: "website",
    adds: "websites",
    anchors: ["websites", "implicitWebsites"],
    // The beta ui states the websites as scope entries, which are added from the scope itself.
    available: ({
      uiType: e,
      enableScopeCreationBetaUi: t
    }) => e === U.login && !t
  },
  {
    id: "androidApp",
    adds: "androidApps",
    anchors: ["websites", "implicitWebsites"],
    available: ({
      uiType: e,
      enableScopeCreationBetaUi: t,
      hasAvailableAndroidApps: o
    }) => e === U.login && !t && o
  },
  {
    id: "displayHeadline",
    adds: "displayHeadline",
    anchors: ["scope", "websites", "implicitWebsites", "wifiSsid", "username"]
  },
  {
    id: "displayName",
    adds: "title",
    anchors: ["username"]
  },
  {
    id: "totp",
    adds: "totp",
    anchors: ["password", "passkey"],
    // Only a website login has a second factor to store, and the secret is one of the login's
    // secrets even while it is only being added.
    available: ({
      uiType: e,
      permissions: t
    }) => e === U.login && t.viewSecrets
  },
  {
    id: "password",
    adds: "password",
    anchors: ["passkey"]
  }
], io = Fp;
function kp(e) {
  const t = io.find((o) => o.id === e);
  if (!t)
    throw new Error(`No add button spec for ${e}`);
  return t.adds;
}
function Wp(e, t) {
  return t.permissions.editLogin ? io.filter(({
    adds: o,
    available: i
  }) => !e[o] && (!i || i(t))).map(({
    id: o
  }) => o) : [];
}
function Op(e) {
  return Mp.filter((t) => e[t]);
}
function Dp({
  availableAnchors: e,
  applicableButtons: t
}) {
  const o = {};
  for (const {
    id: i,
    anchors: r
  } of io) {
    if (!t.includes(i))
      continue;
    const s = r.find((a) => e.includes(a));
    s && (o[s] ??= []).push(i);
  }
  return o;
}
function ze(e, t) {
  return {
    action: {
      icon: Xs,
      label: u._(
        /** i18n */
        {
          id: "cnGeoo"
        }
      ),
      key: "delete",
      element: {
        type: "button",
        props: {
          type: "button",
          onClick: e,
          ...t
        }
      }
    }
  };
}
const Hp = "_AndroidAppIcon_tbb7d_1", Up = {
  AndroidAppIcon: Hp
}, Vp = "_FormElement_1b9s0_1", zp = {
  FormElement: Vp
};
function Y({
  el: e,
  className: t,
  children: o,
  ...i
}) {
  return /* @__PURE__ */ n(e ?? "div", { className: C(zp.FormElement, t), ...i, children: o });
}
function he(e) {
  return function(o) {
    return ke.memo(o, ({
      formik: i,
      ...r
    }, {
      formik: s,
      ...a
    }) => {
      for (const c of e)
        if (
          // Match formik FastField: https://github.com/jaredpalmer/formik/blob/958d67ca2c3e006031c31150ea0a42248b28ffc7/packages/formik/src/FastField.tsx#L79-L87
          i.values[c] !== s.values[c] || i.touched[c] !== s.touched[c] || i.errors[c] !== s.errors[c] || i.isSubmitting !== s.isSubmitting
        )
          return !1;
      for (const c of Object.keys(r))
        if (en(r, c) && en(a, c) && r[c] !== a[c] || en(r, c) !== en(a, c))
          return !1;
      return !0;
    });
  };
}
function en(e, t) {
  return t in e;
}
const qp = he(["androidApps"])(({
  formik: e,
  availableAndroidAppsById: t,
  readOnly: o,
  autoFocusNewEntry: i,
  clearNewEntryAutoFocus: r,
  removeField: s
}) => {
  const a = e.values.androidApps ?? [];
  let c;
  a.length ? c = a : c = [void 0];
  const [d, l] = R(), p = c.length === 1 && c[0] === void 0 && !s, _ = B(({
    iconDataUri: h,
    ...g
  }) => ({
    ...g,
    signature: ""
  }), []);
  return /* @__PURE__ */ n(zt, { name: "androidApps", render: (h) => /* @__PURE__ */ m(T, { children: [
    c.map((g, w) => {
      const b = `androidApps.${w}`, y = e.getFieldProps(b).value;
      return /* @__PURE__ */ n(er, { availableAndroidAppsById: t, toOption: _, value: y ?? void 0, readOnly: o, autoFocus: w === d || !a.length && i, clearAutoFocus: () => {
        l(void 0), r();
      }, hideDelete: p, deleteApp: () => {
        h.remove(w), a.length <= 1 && s?.();
      }, onChange: (v) => {
        w >= a.length ? h.push(v) : e.setFieldValue(b, v ?? void 0, !1).catch($);
      }, isSubmitting: e.isSubmitting }, b);
    }),
    t && !o && /* @__PURE__ */ n(rt, { children: /* @__PURE__ */ n(bt, { onClick: () => {
      l(c.length ?? 0), a.length === 0 && h.push(void 0), h.push(void 0);
    }, children: /* @__PURE__ */ n(f, { id: "iOiHwJ" }) }) })
  ] }) });
});
function er({
  autoFocus: e,
  availableAndroidAppsById: t,
  clearAutoFocus: o,
  deleteApp: i,
  hideDelete: r,
  isSubmitting: s,
  onChange: a,
  readOnly: c,
  value: d,
  toOption: l
}) {
  const p = M(() => t && Object.values(t)?.map(l), [t, l]);
  return !p || c ? d ? /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { element: {
    type: "input",
    props: {
      type: "text",
      readOnly: !0,
      value: d.displayName
    }
  }, label: u._(
    /** i18n */
    {
      id: "zVJj0U"
    }
  ), icon: Xo(d?.appId, t), inlineUi: On({
    actions: c ? [] : [ze(i, {
      disabled: s
    }).action]
  }) }) }) : null : /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(_d, { clearable: !1, options: p, label: u._(
    /** i18n */
    {
      id: "zVJj0U"
    }
  ), getValueIconNode: ({
    appId: _
  }) => Xo(_, t), getValueLabel: ({
    displayName: _
  }) => _, valuesEqual: ({
    appId: _
  }, {
    appId: h
  }) => _ === h, noMatchingOptionsText: u._(
    /** i18n */
    {
      id: "nr1I0W"
    }
  ), value: d, onChange: (_) => {
    _ && a(_), o();
  }, autoFocus: e, inlineUi: On({
    actions: r ? [] : [ze(i, {
      disabled: s
    }).action]
  }) }, "select") });
}
function Xo(e, t) {
  if (!e || !t)
    return;
  const o = t[e];
  if (!(!o || !o.iconDataUri?.startsWith("data:")))
    return /* @__PURE__ */ n("img", { src: o.iconDataUri, alt: "", className: Up.AndroidAppIcon });
}
const jp = "_FormInputPlaceholder_1g6mh_1", Gp = "_ButtonWrapper_1g6mh_8", Kp = "_hasInlineUi_1g6mh_19", Yp = "_HiddenValuePill_1g6mh_23 _UnstyledButton_r3cpb_208", Xp = "_dark_1g6mh_41", Jp = "_HeyloginIcon_1g6mh_44", Qp = "_PillText_1g6mh_55", Zp = "_InlineUi_1g6mh_65", e_ = "_Message_1g6mh_85", t_ = "_error_1g6mh_94", n_ = "_warning_1g6mh_97", Be = {
  FormInputPlaceholder: jp,
  ButtonWrapper: Gp,
  hasInlineUi: Kp,
  HiddenValuePill: Yp,
  dark: Xp,
  HeyloginIcon: Jp,
  PillText: Qp,
  InlineUi: Zp,
  Message: e_,
  error: t_,
  warning: n_
}, St = ke.forwardRef(({
  inlineUi: e,
  onButtonClick: t,
  changed: o,
  children: i,
  className: r,
  style: s,
  error: a,
  warning: c,
  info: d,
  reserveSpaceForMessage: l,
  ...p
}, _) => {
  const h = X(), g = h === "light" ? Js : Qs;
  return /* @__PURE__ */ m("div", { className: r, ...p, children: [
    /* @__PURE__ */ m("div", { className: C(Be.FormInputPlaceholder, Be[h], {
      [Be.hasInlineUi]: e
    }), style: {
      "--inline-ui-width": e?.width ?? 0,
      ...s
    }, children: [
      /* @__PURE__ */ n("div", { className: Be.ButtonWrapper, ref: _, children: /* @__PURE__ */ m("button", { type: "button", className: Be.HiddenValuePill, onClick: t, children: [
        /* @__PURE__ */ n(g, { className: Be.HeyloginIcon }),
        /* @__PURE__ */ m("span", { className: Be.PillText, children: [
          i,
          o && /* @__PURE__ */ m(T, { children: [
            " ",
            /* @__PURE__ */ n(f, { id: "d_ZbMk" })
          ] })
        ] })
      ] }) }),
      e && /* @__PURE__ */ n("div", { className: Be.InlineUi, children: e.node })
    ] }),
    (a || c || d || l) && /* @__PURE__ */ n("div", { className: C(Be.Message, a && Be.error, c && !a && Be.warning), children: a || c || d })
  ] });
}), o_ = "_CreditCardIcon_52bk9_1", i_ = "_CreditCardExpirationSecurityCode_52bk9_8", r_ = "_CreditCardSecurityCode_52bk9_14", s_ = "_CreditCardExpiration_52bk9_8", Mt = {
  CreditCardIcon: o_,
  CreditCardExpirationSecurityCode: i_,
  CreditCardSecurityCode: r_,
  CreditCardExpiration: s_
}, c_ = {
  [Pe.types.AMERICAN_EXPRESS]: Zs,
  [Pe.types.DINERS_CLUB]: ec,
  [Pe.types.DISCOVER]: tc,
  [Pe.types.ELO]: nc,
  [Pe.types.HIPERCARD]: ic,
  [Pe.types.HIPER]: oc,
  [Pe.types.JCB]: rc,
  [Pe.types.MAESTRO]: sc,
  [Pe.types.MASTERCARD]: cc,
  [Pe.types.UNIONPAY]: ac,
  [Pe.types.VISA]: lc
}, a_ = he(["creditCard", "uiType"])(({
  formik: e,
  readOnly: t,
  writeToClipboard: o,
  hideSecrets: i,
  writeAuditlogEvent: r,
  nonEmptyFields: s
}) => {
  const {
    warnings: a,
    card: c
  } = l_(e), d = M(() => c ? c_[c?.type] ?? Eo : Eo, [c]), {
    action: l
  } = fe(o, e.values.creditCard?.number?.replaceAll(" ", "")), {
    ref: p,
    inlineUi: _
  } = pe([l]), {
    action: h
  } = fe(o, e.values.creditCard?.cardHolder), {
    ref: g,
    inlineUi: w
  } = pe([h]), b = M(() => e.values.creditCard?.expiration?.replaceAll(/\s/g, ""), [e.values.creditCard?.expiration]), {
    action: y
  } = fe(o, b), {
    ref: v,
    inlineUi: S
  } = pe([y]), {
    action: I,
    show: E,
    setShow: A
  } = vt({
    isEmpty: !e.values.creditCard?.securityCode,
    onShow: () => r?.({
      type: Ne.CREDIT_CARD_R_SECURITY_CODE_SHOW
    })
  }), {
    action: N
  } = fe((q) => {
    o(q, !0), r?.({
      type: Ne.CREDIT_CARD_R_SECURITY_CODE_COPY
    });
  }, e.values.creditCard?.securityCode), {
    ref: P,
    inlineUi: L
  } = pe([N, I]), {
    action: F,
    show: O,
    setShow: W
  } = vt({
    isEmpty: !e.values.creditCard?.pin,
    onShow: () => r?.({
      type: Ne.CREDIT_CARD_R_PIN_SHOW
    })
  }), {
    action: j
  } = fe((q) => {
    o(q, !0), r?.({
      type: Ne.CREDIT_CARD_R_PIN_COPY
    });
  }, e.values.creditCard?.pin), V = M(() => ({
    icon: jn,
    element: {
      type: "button",
      props: {
        type: "button",
        disabled: !O,
        onClick: () => {
          const {
            value: q
          } = dn(4, !1, !1, !0, !1);
          e.setFieldValue("creditCard.pin", q).catch($);
        }
      }
    },
    key: "generate",
    label: u._(
      /** i18n */
      {
        id: "YU1MkM"
      }
    )
  }), [e, O]), J = M(() => e.values.creditCard?.pin ? [j, F] : [j, F, V], [j, e.values.creditCard?.pin, V, F]), {
    ref: G,
    inlineUi: oe
  } = pe(J), H = e.values.uiType === "creditCard";
  return /* @__PURE__ */ m(xe, { children: [
    (H || s.number) && /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { label: u._(
      /** i18n */
      {
        id: "xHIEQ5"
      }
    ), icon: /* @__PURE__ */ n(d, { title: c?.niceType ?? u._(
      /** i18n */
      {
        id: "ooW934"
      }
    ), className: Mt.CreditCardIcon }), error: e.touched.creditCard?.number ? e.errors.creditCard?.number : void 0, warning: a.number, element: {
      type: "input",
      props: {
        type: "text",
        autoComplete: "off",
        ...e.getFieldProps("creditCard.number"),
        onBlur: (q) => {
          if (e.getFieldProps("creditCard.number").onBlur(q), t)
            return;
          const be = ys(q.currentTarget.value);
          e.setFieldValue("creditCard.number", be.number).catch($), e.setFieldValue("creditCard.displayMaskedNumber", be.displayMaskedNumber).catch($), e.setFieldValue("creditCard.displayType", be.displayType).catch($);
        },
        readOnly: t,
        ref: p
      }
    }, isSubmitting: e.isSubmitting, inlineUi: _ }) }),
    (H || s.cardHolder) && /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { label: u._(
      /** i18n */
      {
        id: "bMFXRG"
      }
    ), error: e.touched.creditCard?.cardHolder ? e.errors.creditCard?.cardHolder : void 0, element: {
      type: "input",
      props: {
        type: "text",
        autoComplete: "off",
        ...e.getFieldProps("creditCard.cardHolder"),
        onBlur: (q) => {
          e.getFieldProps("creditCard.cardHolder").onBlur(q), !t && e.setFieldValue("creditCard.cardHolder", q.currentTarget.value.trim()).catch($);
        },
        readOnly: t,
        ref: g
      }
    }, isSubmitting: e.isSubmitting, inlineUi: w }) }),
    (H || s.expiration || s.securityCode) && /* @__PURE__ */ m(Y, { className: Mt.CreditCardExpirationSecurityCode, children: [
      (H || s.expiration) && /* @__PURE__ */ n(se, { label: u._(
        /** i18n */
        {
          id: "2Pjc5z"
        }
      ), className: Mt.CreditCardExpiration, error: e.touched.creditCard?.expiration ? e.errors.creditCard?.expiration : void 0, warning: a.expiration, element: {
        type: "input",
        props: {
          type: "text",
          autoComplete: "off",
          ...e.getFieldProps("creditCard.expiration"),
          onBlur: (q) => {
            e.getFieldProps("creditCard.expiration").onBlur(q), !t && e.setFieldValue("creditCard.expiration", Cs(q.currentTarget.value)).catch($);
          },
          readOnly: t,
          ref: v
        }
      }, isSubmitting: e.isSubmitting, inlineUi: S }),
      !i && (H || s.securityCode) && (E ? /* @__PURE__ */ n(se, { label: c ? u._(
        /** i18n */
        {
          id: "j9cdwV",
          values: {
            0: c.code.name,
            1: c.code.size
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "wLmRnI"
        }
      ), className: Mt.CreditCardSecurityCode, error: e.touched.creditCard?.securityCode ? e.errors.creditCard?.securityCode : void 0, warning: a.securityCode, element: {
        type: "input",
        props: {
          type: "text",
          autoComplete: "off",
          ...e.getFieldProps("creditCard.securityCode"),
          readOnly: t,
          ref: P
        }
      }, isSubmitting: e.isSubmitting, inlineUi: L, monospace: !0 }) : /* @__PURE__ */ n(St, { inlineUi: L, ref: P, onButtonClick: () => A(!0), className: Mt.CreditCardSecurityCode, changed: e.initialValues.creditCard?.securityCode !== e.values.creditCard?.securityCode, children: /* @__PURE__ */ n(f, { id: "BqrHbB" }) }))
    ] }),
    !i && (H || s.pin) && /* @__PURE__ */ n(Y, { children: O ? /* @__PURE__ */ n(se, { label: u._(
      /** i18n */
      {
        id: "sXULwc"
      }
    ), error: e.touched.creditCard?.pin ? e.errors.creditCard?.pin : void 0, element: {
      type: "input",
      props: {
        type: "text",
        autoComplete: "off",
        ...e.getFieldProps("creditCard.pin"),
        readOnly: t,
        ref: G
      }
    }, isSubmitting: e.isSubmitting, inlineUi: oe, monospace: !0 }) : /* @__PURE__ */ n(St, { inlineUi: oe, ref: G, onButtonClick: () => W(!0), changed: e.initialValues.creditCard?.pin !== e.values.creditCard?.pin, children: /* @__PURE__ */ n(f, { id: "2cIs6V" }) }) })
  ] });
});
function l_(e) {
  const {
    card: t,
    cardNumberWarning: o,
    cardValid: i
  } = M(() => {
    const c = Rn.number(e.values.creditCard?.number);
    return {
      cardValid: c.isValid,
      card: c.card,
      cardNumberWarning: En(e, "number", c)
    };
  }, [e]), r = M(() => {
    const c = Rn.expirationDate(e.values.creditCard?.expiration);
    return En(e, "expiration", c);
  }, [e]), s = M(() => {
    if (!i || !t)
      return !1;
    const c = Rn.cvv(e.values.creditCard?.securityCode, t.code.size);
    return En(e, "securityCode", c);
  }, [t, i, e]);
  return {
    warnings: {
      number: o ? u._(
        /** i18n */
        {
          id: "0FSRiz"
        }
      ) : void 0,
      expiration: r ? u._(
        /** i18n */
        {
          id: "Lyd22-"
        }
      ) : void 0,
      securityCode: s ? u._(
        /** i18n */
        {
          id: "7xaBoY"
        }
      ) : void 0
    },
    card: t
  };
}
function En(e, t, o) {
  return e.values.creditCard?.[t] ? e.touched.creditCard?.[t] ? !o.isValid : !o.isPotentiallyValid : !1;
}
const d_ = "_Button_m6o5o_1 _UnstyledButton_r3cpb_208", u_ = "_TextWrapper_m6o5o_12", p_ = "_Text_m6o5o_12", $n = {
  Button: d_,
  TextWrapper: u_,
  Text: p_
};
function __({
  onClick: e,
  visible: t,
  label: o,
  successLabel: i,
  className: r,
  animateHeightChanges: s
}) {
  const [a, c] = R(!1), d = D(), l = B((p) => {
    window.clearTimeout(d.current), e(p), c(!0), d.current = window.setTimeout(() => c(!1), 2e3);
  }, [e]);
  return /* @__PURE__ */ n(Ut, { disabled: !s, children: !a && !t ? null : /* @__PURE__ */ n("button", { type: "button", className: C($n.Button, r), onClick: l, "aria-hidden": !t, children: /* @__PURE__ */ n(Yn, { active: a, className: $n.TextWrapper, activeChildren: /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(Vt, {}),
    i
  ] }), defaultChildren: /* @__PURE__ */ n(T, { children: o }), stateWrapperClassName: $n.Text }) }) });
}
const h_ = "_PasswordGenerator_1091q_1", m_ = "_darkMode_1091q_15", f_ = "_PasswordInput_1091q_20", g_ = "_PasswordInfo_1091q_24", y_ = "_InfoButton_1091q_34", C_ = "_PasswordPolicyCheck_1091q_38", w_ = "_Result_1091q_41", b_ = "_Icon_1091q_44", v_ = "_OptionsGroup_1091q_51", S_ = "_SwitchGroup_1091q_56", I_ = "_OptionSwitch_1091q_65", N_ = "_Switch_1091q_56", A_ = "_NumberOfCharacters_1091q_85", L_ = "_NumberOfCharactersInternal_1091q_91", P_ = "_ButtonGroup_1091q_102", R_ = "_Button_1091q_102", te = {
  PasswordGenerator: h_,
  darkMode: m_,
  PasswordInput: f_,
  PasswordInfo: g_,
  InfoButton: y_,
  PasswordPolicyCheck: C_,
  Result: w_,
  Icon: b_,
  OptionsGroup: v_,
  SwitchGroup: S_,
  OptionSwitch: I_,
  Switch: N_,
  NumberOfCharacters: A_,
  NumberOfCharactersInternal: L_,
  ButtonGroup: P_,
  Button: R_
};
function Vn({
  className: e,
  error: t,
  hideButtons: o,
  hideNewPasswordLabel: i,
  newPasswordLabel: r,
  oldPassword: s,
  oldPasswordLabel: a,
  savedSettings: c,
  apply: d,
  close: l,
  onNewPasswordBlur: p,
  saveSettings: _,
  writeToClipboard: h,
  password: g,
  setCustomPassword: w,
  checkPasswordPolicy: b,
  animateHeightChanges: y,
  ...v
}) {
  const S = X(), [I, E] = R(!1), {
    action: A
  } = fe((H) => {
    h(H, !0);
  }, s), N = M(() => [A], [A]), P = pe(N), {
    action: L
  } = fe((H) => {
    h(H, !0);
  }, g), F = M(() => ({
    key: "regenerate",
    icon: dc,
    label: u._(
      /** i18n */
      {
        id: "6exX-8"
      }
    ),
    element: {
      type: "button",
      props: {
        onClick: () => v.regeneratePassword(),
        type: "button"
      }
    }
  }), [v]), O = M(() => v.type === "userInput" ? [L] : [F, L], [L, F, v.type]), W = pe(O, {
    showAllInlineActions: !0
  }), {
    passwordQualityCheckStatus: j,
    updatePasswordQualityCheck: V
  } = Xi({
    policy: b,
    skipDefaultRules: !0,
    initialPassword: g
  });
  k(() => {
    V(g);
  }, [g, V]);
  const [J, G] = $e(), oe = G.width > 500;
  return /* @__PURE__ */ m("div", { className: C(te.PasswordGenerator, {
    [te.darkMode]: S === "dark"
  }, e), ref: J, onKeyDown: (H) => {
    H.key === "Escape" && l?.();
  }, children: [
    s && /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        value: s,
        disabled: !0,
        autoComplete: "off",
        autoCapitalize: "off",
        autoCorrect: "off",
        ref: P.ref
      }
    }, labelInside: !0, label: a ?? u._(
      /** i18n */
      {
        id: "CqOvzI"
      }
    ), className: te.PasswordInput, monospace: !0, inlineUi: P.inlineUi }),
    /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        value: g,
        onChange: (H) => w(H.target.value),
        autoComplete: "off",
        autoCapitalize: "off",
        autoCorrect: "off",
        onKeyDown: (H) => {
          !o && H.key === "Enter" && d?.();
        },
        onBlur: (H) => p?.(H.currentTarget.value),
        ref: W.ref
      }
    }, labelInside: !i, label: i ? void 0 : r ?? u._(
      /** i18n */
      {
        id: "_nT6AE"
      }
    ), className: te.PasswordInput, error: t, monospace: !0, inlineUi: W.inlineUi }),
    /* @__PURE__ */ m("div", { className: te.PasswordInfo, children: [
      /* @__PURE__ */ n("div", { children: v.type === "userInput" ? /* @__PURE__ */ n("strong", { children: /* @__PURE__ */ n(f, { id: "pS7MTY" }) }) : /* @__PURE__ */ m(T, { children: [
        /* @__PURE__ */ n(f, { id: "LZdUlh" }),
        /* @__PURE__ */ n("strong", { children: v.type === "generatedPolicy" ? /* @__PURE__ */ n(f, { id: "G5YMCW" }) : v.type === "generatedNoPolicy" ? /* @__PURE__ */ n(f, { id: "aPPyP8" }) : v.type === "generatedCustom" ? /* @__PURE__ */ n(f, { id: "XJ1mLl" }) : z(v.type) })
      ] }) }),
      v.type === "generatedPolicy" || v.type === "generatedNoPolicy" ? !I && /* @__PURE__ */ n(it, { type: "button", onClick: () => E(!0), className: te.InfoButton, children: oe ? /* @__PURE__ */ n(f, { id: "kKIiKD" }) : /* @__PURE__ */ n(f, { id: "o-XJ9D" }) }) : v.type === "generatedCustom" || v.type === "userInput" ? /* @__PURE__ */ n(it, { type: "button", onClick: () => {
        v.resetToInitial(), E(!1);
      }, className: te.InfoButton, children: v.type === "generatedCustom" ? oe ? /* @__PURE__ */ n(f, { id: "qCZ4Yg" }) : /* @__PURE__ */ n(f, { id: "OfhWJH" }) : /* @__PURE__ */ n(f, { id: "19BWU3" }) }) : z(v.type)
    ] }),
    /* @__PURE__ */ n(Ut, { disabled: !y, children: v.type !== "userInput" && (v.type === "generatedCustom" || I) && /* @__PURE__ */ n(B_, { value: v.settings, onChange: v.changeSettings }) }),
    /* @__PURE__ */ n(__, { label: u._(
      /** i18n */
      {
        id: "i6xssJ"
      }
    ), successLabel: u._(
      /** i18n */
      {
        id: "idD8Ev"
      }
    ), onClick: () => v.type !== "userInput" && _(v.settings), visible: v.type === "generatedCustom" && v.initialStateType === "generatedNoPolicy" && zi(v.settings) && !we(c ?? Qn, v.settings), animateHeightChanges: y }),
    /* @__PURE__ */ n(Ut, { disabled: !y, children: j.status === "checked" && j.checkSource === "passwordPolicy" && !j.result && /* @__PURE__ */ n("div", { className: te.PasswordPolicyCheck, children: /* @__PURE__ */ n(f, { id: "snjodo", components: {
      0: /* @__PURE__ */ n(Xn, { element: "span", className: te.Result, overlay: /* @__PURE__ */ n(Hn, { ruleResults: j.ruleResults, rules: j.rules }) }),
      1: /* @__PURE__ */ n(Pi, { className: te.Icon })
    } }) }) }),
    !o && /* @__PURE__ */ m("div", { className: te.ButtonGroup, children: [
      /* @__PURE__ */ n(me, { buttonStyle: "tertiary", element: "button", type: "button", size: "small", onClick: l, className: te.Button, children: /* @__PURE__ */ n(f, { id: "dEgA5A" }) }),
      /* @__PURE__ */ n(me, { buttonStyle: "primary", element: "button", type: "button", size: "small", onClick: d, className: te.Button, children: /* @__PURE__ */ n(f, { id: "DB8zMK" }) })
    ] })
  ] });
}
function B_({
  value: e,
  onChange: t
}) {
  const [o, i] = R(), r = B(() => {
    i(`${e.length}`);
  }, [e.length]), s = B((l) => {
    i(l);
    const p = parseInt(l, 10), _ = eo({
      ...e,
      length: p
    }) && p <= Wt;
    t({
      ...e,
      length: _ ? p : e.length
    });
  }, [e, t]), a = B((l) => {
    i(void 0);
    const p = parseInt(l, 10), _ = Math.min(Math.max(Dt(e), Number.isNaN(p) ? 0 : p), Wt);
    t({
      ...e,
      length: _
    });
  }, [t, e]), c = B((l) => {
    const p = (b, y) => b !== y, _ = p(l === "letters", e.letters), h = p(l === "numbers", e.numbers), g = p(l === "special", e.special), w = Math.max(Dt({
      ...e,
      letters: _,
      numbers: h,
      special: g
    }), e.length);
    t({
      ...e,
      letters: _,
      numbers: h,
      special: g,
      length: w
    });
  }, [t, e]), d = /* @__PURE__ */ n(T, { children: "‑" });
  return /* @__PURE__ */ m("div", { className: te.OptionsGroup, children: [
    /* @__PURE__ */ m("div", { className: te.SwitchGroup, children: [
      /* @__PURE__ */ n("div", { children: /* @__PURE__ */ m("label", { className: te.OptionSwitch, children: [
        /* @__PURE__ */ n(on, { checked: e.numbers, onChange: () => c("numbers"), className: te.Switch }),
        "0",
        d,
        "9"
      ] }) }),
      /* @__PURE__ */ n("div", { children: /* @__PURE__ */ m("label", { className: te.OptionSwitch, children: [
        /* @__PURE__ */ n(on, { checked: e.letters, onChange: () => c("letters"), className: te.Switch }),
        "A",
        d,
        "Z a",
        d,
        "z"
      ] }) }),
      /* @__PURE__ */ n("div", { children: /* @__PURE__ */ m("label", { className: te.OptionSwitch, children: [
        /* @__PURE__ */ n(on, { checked: e.special, onChange: () => c("special"), className: te.Switch }),
        "#@$"
      ] }) })
    ] }),
    /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        type: "text",
        value: o ?? `${e.length}`,
        min: Dt(e),
        max: Wt,
        onFocus: () => r(),
        onChange: (l) => s(l.target.value),
        onBlur: (l) => a(l.target.value),
        className: te.NumberOfCharactersInternal,
        // show numeric keypad on ios: https://stackoverflow.com/a/27538989
        pattern: "[0-9]*",
        inputMode: "numeric"
      }
    }, label: u._(
      /** i18n */
      {
        id: "NC2AI2"
      }
    ), labelInside: !0, className: te.NumberOfCharacters })
  ] });
}
const T_ = "_FormInputElement_xmsc6_1", E_ = {
  FormInputElement: T_
}, $_ = "_CustomFieldSettings_10qiw_1", x_ = "_dark_10qiw_12", M_ = "_Header_10qiw_17", F_ = "_Headline_10qiw_23", k_ = "_MoveButtons_10qiw_30", W_ = "_MoveButton_10qiw_30 _UnstyledButton_r3cpb_208", O_ = "_Icon_10qiw_41", D_ = "_OptionLabel_10qiw_57", H_ = "_AutofillOption_10qiw_67", U_ = "_InfoLink_10qiw_72", V_ = "_InfoIcon_10qiw_76", z_ = "_ButtonGroup_10qiw_84", q_ = "_Button_10qiw_84", _e = {
  CustomFieldSettings: $_,
  dark: x_,
  Header: M_,
  Headline: F_,
  MoveButtons: k_,
  MoveButton: W_,
  Icon: O_,
  OptionLabel: D_,
  AutofillOption: H_,
  InfoLink: U_,
  InfoIcon: V_,
  ButtonGroup: z_,
  Button: q_
};
function j_({
  close: e,
  field: t,
  setField: o,
  isNewlyCreatedField: i,
  deleteField: r,
  moveUp: s,
  moveDown: a
}) {
  const c = X(), d = D(null), l = D(null);
  return k(() => {
    i && (d.current?.focus({
      preventScroll: !0
    }), l.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth"
    }));
  }, [i]), /* @__PURE__ */ n(Ni, { initialValues: {
    name: t.name,
    protected: t.protected,
    autofill: t.autofill ?? {
      enabled: !1,
      fieldIdOrName: ""
    }
  }, onSubmit: (p) => {
    const {
      autofill: _,
      ...h
    } = p, g = _.fieldIdOrName.trim(), w = _.enabled && !!g, b = {
      enabled: w,
      fieldIdOrName: w ? g : ""
    };
    o({
      ...t,
      ...h,
      name: p.name.trim(),
      autofill: b
    }), e();
  }, validate: (p) => {
    let _ = {};
    return p.name.trim() || (_ = {
      ..._,
      name: u._(
        /** i18n */
        {
          id: "1xTnZJ"
        }
      )
    }), _;
  }, children: (p) => /* @__PURE__ */ m("div", { ref: l, className: C(_e.CustomFieldSettings, c === "dark" && _e.dark), onKeyDown: (_) => {
    _.key === "Enter" ? p.submitForm().catch($) : _.key === "Escape" && e();
  }, children: [
    /* @__PURE__ */ m("div", { className: _e.Header, children: [
      /* @__PURE__ */ n("h3", { className: _e.Headline, children: i ? /* @__PURE__ */ n(f, { id: "CgUQh7" }) : /* @__PURE__ */ n(f, { id: "LaF9tZ" }) }),
      /* @__PURE__ */ m("div", { className: _e.MoveButtons, children: [
        /* @__PURE__ */ n(Jo, { direction: "up", onClick: s, disabled: !s }),
        /* @__PURE__ */ n(Jo, { direction: "down", onClick: a, disabled: !a })
      ] })
    ] }),
    /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        ...p.getFieldProps("name"),
        ref: d
      }
    }, label: u._(
      /** i18n */
      {
        id: "nrXDdR"
      }
    ), error: p.touched.name && p.errors.name, reserveSpaceForMessage: !0 }),
    /* @__PURE__ */ m("label", { className: _e.OptionLabel, children: [
      /* @__PURE__ */ n(Wi, { ...p.getFieldProps({
        name: "protected",
        type: "checkbox"
      }) }),
      /* @__PURE__ */ n(f, { id: "g9eOjA" })
    ] }),
    /* @__PURE__ */ n(G_, { formik: p }),
    /* @__PURE__ */ m("div", { className: _e.ButtonGroup, children: [
      /* @__PURE__ */ n(me, { buttonStyle: "tertiary", element: "button", type: "button", size: "small", onClick: () => {
        i && r(), e();
      }, className: _e.Button, children: /* @__PURE__ */ n(f, { id: "dEgA5A" }) }),
      /* @__PURE__ */ n(me, { buttonStyle: "primary", element: "button", type: "button", size: "small", onClick: () => {
        p.submitForm().catch($);
      }, className: _e.Button, children: i ? /* @__PURE__ */ n(f, { id: "m16xKo" }) : /* @__PURE__ */ n(f, { id: "DB8zMK" }) })
    ] })
  ] }) });
}
function Jo({
  direction: e,
  ...t
}) {
  return /* @__PURE__ */ n("button", { className: _e.MoveButton, ...t, children: e === "up" ? /* @__PURE__ */ n(mc, { className: _e.Icon }) : /* @__PURE__ */ n(hc, { className: _e.Icon }) });
}
function G_({
  formik: e
}) {
  const [t, o] = R(!1), {
    onChange: i,
    ...r
  } = e.getFieldProps({
    name: "autofill.enabled",
    type: "checkbox"
  });
  return /* @__PURE__ */ m("div", { className: C(_e.AutofillOption), children: [
    /* @__PURE__ */ m("label", { className: _e.OptionLabel, children: [
      /* @__PURE__ */ n(Wi, { ...r, onChange: (s) => {
        i(s), o(!0);
      } }),
      /* @__PURE__ */ n(f, { id: "OsXw_g" })
    ] }),
    /* @__PURE__ */ n("a", { href: u._(
      /** i18n */
      {
        id: "N7BSBJ"
      }
    ), target: "_blank", rel: "noreferrer", className: _e.InfoLink, children: /* @__PURE__ */ n(fc, { className: _e.InfoIcon }) }),
    e.values.autofill.enabled && /* @__PURE__ */ n(Zl, { ...e.getFieldProps("autofill.fieldIdOrName"), placeholder: u._(
      /** i18n */
      {
        id: "NqixkT"
      }
    ), autoFocus: t })
  ] });
}
const K_ = he(["customFields", "totp"])(({
  formik: e,
  writeToClipboard: t,
  readOnly: o,
  hideSecrets: i,
  savePasswordGeneratorSettings: r,
  passwordGeneratorSettings: s,
  openInlineDialog: a,
  setOpenInlineDialog: c,
  writeAuditlogEvent: d,
  passwordPolicy: l
}) => {
  const {
    customFields: p
  } = e.values;
  return /* @__PURE__ */ n(zt, { name: "customFields", render: (_) => /* @__PURE__ */ n(T, { children: p.map((h, g) => {
    if (h.protected && i)
      return null;
    const w = `customFields.${g}`, b = `${w}.value`, y = e.getFieldProps(b), v = e.initialValues.customFields[g], S = g === 0 ? void 0 : () => _.move(g, g - 1), I = g === p.length - 1 ? void 0 : () => _.move(g, g + 1);
    return /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(Y_, { moveDown: I, moveUp: S, element: {
        type: h.multiline ? "autosizeTextarea" : "input",
        props: {
          ...y
        }
      }, disableRelaxedLabelInsideSpacing: !0, isSubmitting: e.isSubmitting, field: h, setField: (E) => {
        e.setFieldValue(w, E, !0).catch($);
      }, deleteCustomField: () => _.remove(g), writeToClipboard: t, readOnly: o, passwordGenerator: {
        savePasswordGeneratorSettings: r,
        passwordGeneratorSettings: s,
        passwordPolicy: l
      }, openInlineDialog: a, setOpenInlineDialog: c, initialValue: v?.value, writeAuditlogEvent: d }, h.id) }, h.id),
      h.autofill?.enabled && !(a && a.type === "customFieldSettings" && a.id === h.id) && /* @__PURE__ */ n(rt, { children: /* @__PURE__ */ n(f, { id: "6Z8CEa" }) })
    ] });
  }) }) });
}), Y_ = ke.forwardRef(({
  writeToClipboard: e,
  deleteCustomField: t,
  readOnly: o,
  passwordGenerator: i,
  openInlineDialog: r,
  setOpenInlineDialog: s,
  writeAuditlogEvent: a,
  element: c,
  initialValue: d,
  field: l,
  setField: p,
  hideMultilineOption: _,
  moveDown: h,
  moveUp: g,
  ...w
}, b) => {
  const y = c?.props?.value ?? "", v = y.includes(`
`), {
    action: S
  } = fe((ee) => {
    e(ee, l.protected), a?.({
      type: Ne.LOGIN_R_CUSTOM_FIELD_COPY,
      customFieldId: l.id
    });
  }, y), {
    action: I
  } = ze(t, {
    disabled: c.props?.disabled
  }), {
    action: E,
    show: A,
    setShow: N
  } = vt({
    isEmpty: !y,
    onShow: () => {
      a?.({
        type: Ne.LOGIN_R_CUSTOM_FIELD_SHOW,
        customFieldId: l.id
      });
    }
  }), P = l.multiline !== void 0 && !_ ? {
    icon: pc,
    activeIcon: uc,
    active: l.multiline,
    element: {
      type: "button",
      props: {
        type: "button",
        disabled: c.props?.disabled || v || l.protected && !A,
        onClick: () => {
          p({
            ...l,
            multiline: !l.multiline
          });
        }
      }
    },
    key: "multiline",
    label: u._(
      /** i18n */
      {
        id: "4PKEJ_"
      }
    ),
    activeLabel: u._(
      /** i18n */
      {
        id: "VNhKXF"
      }
    )
  } : void 0, L = {
    icon: jn,
    element: {
      type: "button",
      props: {
        type: "button",
        disabled: r !== void 0 || c.props?.disabled,
        onClick: () => {
          a?.({
            type: Ne.LOGIN_R_PASSWORD_SHOW,
            customFieldId: l.id
          }), s({
            type: "password",
            field: l.id
          });
        }
      }
    },
    key: "generate",
    label: u._(
      /** i18n */
      {
        id: "19BWU3"
      }
    )
  }, F = {
    icon: _c,
    element: {
      type: "button",
      props: {
        type: "button",
        disabled: r !== void 0 || c.props?.disabled,
        onClick: () => {
          s({
            type: "customFieldSettings",
            id: l.id
          });
        }
      }
    },
    key: "settings",
    label: u._(
      /** i18n */
      {
        id: "Tz0i8g"
      }
    )
  }, O = [];
  O.push(S), l.protected && O.push(E), P && !o && O.push(P), l.protected && i && !o && O.push(L), o || O.push(F, I);
  const {
    ref: W,
    inlineUi: j
  } = pe(O), V = D(null), J = la(W, b, V), [G, oe] = R();
  k(() => {
    G && (V.current?.focus(), V.current?.setSelectionRange(G.start ?? null, G.end ?? null), oe(void 0));
  }, [G]);
  const [H, q] = R(!1);
  k(() => {
    H && (V.current?.focus(), q(!1));
  }, [H]);
  const be = B((ee) => {
    r?.type === "customFieldSettings" && r.id === l.id && r.isNewField && q(!0), p(ee);
  }, [l.id, r, p]);
  return !o && i && r?.type === "password" && r.field === l.id ? /* @__PURE__ */ n(X_, { oldPassword: y, writeToClipboard: e, fieldName: l.name, setFieldValue: (ee) => {
    p({
      ...l,
      value: ee,
      multiline: !1
    });
  }, ...i, close: () => s(void 0) }) : !o && r?.type === "customFieldSettings" && r.id === l.id ? /* @__PURE__ */ n(j_, { field: l, setField: be, close: () => s(void 0), deleteField: t, isNewlyCreatedField: r.isNewField, moveUp: g, moveDown: h }) : l.protected && !A ? /* @__PURE__ */ n(St, { inlineUi: j, ref: W, onButtonClick: () => N(!0), className: w.className, changed: d !== y, children: /* @__PURE__ */ n(f, { id: "h8lzfw", values: {
    0: l.name
  } }) }) : /* @__PURE__ */ n(se, { ...w, label: l.name, element: {
    ...c,
    props: {
      // TS can't correlate element.type with element.props here, so we need to cast to any.
      ...c.props,
      ref: J,
      readOnly: o,
      className: C(c.props?.className, E_.FormInputElement),
      onKeyDown: (ee) => {
        ee.shiftKey && ee.key === "Enter" && !l.multiline && (oe({
          start: V.current?.selectionStart ?? void 0,
          end: V.current?.selectionEnd ?? void 0
        }), p({
          ...l,
          multiline: !0
        }));
      },
      onPaste: l.multiline ? void 0 : (ee) => {
        const Oe = ee.clipboardData?.getData("text");
        if (!Oe || !Oe.trim().includes(`
`))
          return;
        const x = V.current?.selectionStart ?? y.length, ie = V.current?.selectionEnd ?? y.length, Le = y.slice(0, x) + Oe + y.slice(ie);
        p({
          ...l,
          value: Le,
          multiline: !0
        });
        const st = x + Oe.length;
        oe({
          start: st,
          end: st
        }), ee.preventDefault();
      }
    }
  }, inlineUi: j, monospace: l.protected });
});
function X_({
  oldPassword: e,
  close: t,
  writeToClipboard: o,
  savePasswordGeneratorSettings: i,
  passwordGeneratorSettings: r,
  setFieldValue: s,
  fieldName: a,
  passwordPolicy: c
}) {
  const [d, l] = R(Vi(c ? Zn(c) : r)), p = Ui({
    password: d,
    setPassword: l,
    initialState: c ? {
      type: "generatedPolicy",
      policy: c
    } : {
      type: "generatedNoPolicy",
      settings: r
    }
  });
  return /* @__PURE__ */ n(Y, { el: Vn, ...p, oldPassword: e, close: t, apply: () => {
    s(p.password), t();
  }, writeToClipboard: o, saveSettings: i, savedSettings: r, oldPasswordLabel: u._(
    /** i18n */
    {
      id: "Gv57aB",
      values: {
        fieldName: a
      }
    }
  ), newPasswordLabel: a, checkPasswordPolicy: c, animateHeightChanges: !0 });
}
const J_ = he(["displayHeadline"])(({
  formik: e,
  readOnly: t,
  autoFocus: o,
  clearAutoFocus: i,
  deleteDisplayHeadline: r
}) => {
  const {
    ref: s,
    inlineUi: a
  } = pe(t || !r ? [] : [ze(() => {
    r().catch($);
  }, {
    disabled: e.isSubmitting
  }).action]);
  return /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { element: {
    type: "input",
    props: {
      type: "text",
      ...e.getFieldProps("displayHeadline"),
      readOnly: t,
      inputMode: "text",
      autoComplete: "off",
      disabled: e.isSubmitting,
      autoFocus: o,
      onBlur: (c) => {
        i(), e.getFieldProps("displayHeadline").onBlur(c);
      },
      ref: s
    }
  }, label: u._(
    /** i18n */
    {
      id: "MHrjPM"
    }
  ), error: e.touched.displayHeadline ? e.errors.displayHeadline : void 0, inlineUi: a }) });
}), Q_ = he(["title"])(({
  formik: e,
  readOnly: t,
  autoFocus: o,
  clearAutoFocus: i,
  deleteDisplayName: r
}) => {
  const {
    ref: s,
    inlineUi: a
  } = pe(t ? [] : [ze(() => {
    r().catch($);
  }, {
    disabled: e.isSubmitting
  }).action]);
  return t && !e.values.title ? null : /* @__PURE__ */ n(Y, { el: se, label: u._(
    /** i18n */
    {
      id: "pfa8F0"
    }
  ), error: e.touched.title ? e.errors.title : void 0, element: {
    type: "input",
    props: {
      type: "text",
      autoComplete: "off",
      ...e.getFieldProps("title"),
      autoFocus: o,
      onBlur: (c) => {
        i(), e.getFieldProps("title").onBlur(c), e.setFieldValue("title", c.currentTarget.value.trim()).catch($);
      },
      readOnly: t,
      ref: s
    }
  }, isSubmitting: e.isSubmitting, inlineUi: a });
});
function Z_() {
  const e = D(!1);
  return k(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function un(e, t) {
  const [o, i] = R(!1), r = Z_();
  return [B(
    async (...a) => {
      try {
        return i(!0), await e(...a);
      } finally {
        r.current && i(!1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps are checked for this function itself, see eslint config
    t
  ), o];
}
const eh = "_FileInput_v37iw_1", th = "_dragging_v37iw_18", nh = "_reject_v37iw_21", oh = "_Button_v37iw_26", ih = "_Results_v37iw_31", rh = "_Message_v37iw_40", sh = "_info_v37iw_53", ch = "_success_v37iw_56", ah = "_error_v37iw_59", ge = {
  FileInput: eh,
  dragging: th,
  reject: nh,
  Button: oh,
  Results: ih,
  Message: rh,
  info: sh,
  success: ch,
  error: ah
};
function Pb(e) {
  const t = tr(e);
  return /* @__PURE__ */ n(nr, { ...e, ...t });
}
function tr({
  onFileChanged: e,
  asyncValidator: t,
  ...o
}) {
  const [i, r] = R([]), [s, a] = un(async (_, h) => {
    const g = await _(h), w = Array.isArray(g) ? g : g ? [g] : [];
    return r(w), w.length === 0;
  }, []), [c, d] = un(async (_, h) => {
    if (r([]), await e?.(void 0), h.length !== 0 || _.length !== 1)
      return;
    const g = _[0];
    if (!g)
      return;
    let w = !0;
    t && (w = await s(t, g)), w && e && await e(g);
  }, [t, e, s]), l = B((_, h) => {
    c(_, h).catch($);
  }, [c]);
  return {
    dropzone: gc({
      multiple: !1,
      disabled: a || d,
      onDrop: l,
      ...o
    }),
    asyncErrors: i,
    isDropping: d,
    isValidating: a
  };
}
function nr({
  filename: e,
  error: t,
  success: o,
  hint: i,
  className: r,
  dropAreaClassName: s,
  buttonSize: a,
  dropzone: c,
  asyncErrors: d,
  isDropping: l,
  ...p
}) {
  const h = [M(() => {
    if (c.acceptedFiles.length + c.fileRejections.length > 1)
      return u._(
        /** i18n */
        {
          id: "dYkHqs"
        }
      );
    const w = c.fileRejections.flatMap((y) => y.errors), b = /* @__PURE__ */ new Set([...w.map((y) => lh(y, p)), ...d.map((y) => y.message)]);
    return Array.from(b).join(", ");
  }, [d, c.acceptedFiles.length, c.fileRejections, p]), t].filter((w) => !!w).join(", "), g = da(l, 300);
  return /* @__PURE__ */ m("div", { className: r, children: [
    /* @__PURE__ */ m("div", { ...c.getRootProps(), className: C(ge.FileInput, {
      [ge.dragging]: c.isDragActive && !c.isDragReject,
      [ge.reject]: c.isDragReject
    }, s), children: [
      /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(f, { id: "sRPuK1" }) }),
      /* @__PURE__ */ n(me, { buttonStyle: "secondary", className: ge.Button, type: "button", size: a, children: /* @__PURE__ */ n(f, { id: "O2UpM1" }) }),
      /* @__PURE__ */ n("input", { type: "file", ...c.getInputProps() })
    ] }),
    /* @__PURE__ */ m("div", { className: ge.Results, children: [
      e && /* @__PURE__ */ n("p", { children: e }),
      g && /* @__PURE__ */ n("p", { className: C(ge.Message, ge.info), children: /* @__PURE__ */ n(f, { id: "7JeyPs" }) }),
      h ? /* @__PURE__ */ m("p", { className: C(ge.Message, ge.error), children: [
        /* @__PURE__ */ n(fn, {}),
        h
      ] }) : o ? /* @__PURE__ */ m("p", { className: C(ge.Message, ge.success), children: [
        /* @__PURE__ */ n(Vt, {}),
        " ",
        o
      ] }) : i ? /* @__PURE__ */ n("p", { className: C(ge.Message, ge.info), children: i }) : null
    ] })
  ] });
}
function lh(e, {
  accept: t,
  minSize: o,
  maxSize: i
}) {
  const {
    code: r
  } = e;
  if (r === Xt.FileInvalidType && t) {
    const s = Object.values(t).flat();
    if (s.length > 1) {
      const a = s.join(", ");
      return u._(
        /** i18n */
        {
          id: "oIJDgg",
          values: {
            commaSeparatedAccept: a
          }
        }
      );
    }
    return u._(
      /** i18n */
      {
        id: "UnpytQ",
        values: {
          0: s[0]
        }
      }
    );
  }
  return r === Xt.TooManyFiles ? u._(
    /** i18n */
    {
      id: "dYkHqs"
    }
  ) : r === Xt.FileTooSmall && o !== void 0 ? u._(
    /** i18n */
    {
      id: "oQ4Inb",
      values: {
        0: Qo(o)
      }
    }
  ) : r === Xt.FileTooLarge && i !== void 0 ? u._(
    /** i18n */
    {
      id: "Go9HlN",
      values: {
        0: Qo(i)
      }
    }
  ) : e.message;
}
function Qo(e, t = 1) {
  const i = ["B", "KB", "MB", "GB", "TB"], r = Math.floor(Math.log(Math.abs(e)) / Math.log(1024)), s = r >= i.length ? i.length - 1 : r, a = e / Math.pow(1024, s);
  return `${u.number(a, {
    maximumFractionDigits: t,
    // @ts-expect-error Not yet supported in types for our typescript version
    roundingMode: "floor"
  })} ${i[s]}`;
}
const dh = "_ElsterCertificateView_95pj9_1", uh = "_DropIndicator_95pj9_5", ph = "_HeadlineButtons_95pj9_19", _h = "_HeadlineButton_95pj9_19 _UnstyledButton_r3cpb_208", hh = "_Valid_95pj9_39", mh = "_error_95pj9_40", fh = "_warning_95pj9_43", gh = "_Info_95pj9_47", ye = {
  ElsterCertificateView: dh,
  DropIndicator: uh,
  HeadlineButtons: ph,
  HeadlineButton: _h,
  Valid: hh,
  error: mh,
  warning: fh,
  Info: gh
}, yh = he(["elsterCertificate"])(({
  formik: e,
  elsterValidator: t,
  elsterError: o,
  setElsterError: i,
  permissions: r
}) => {
  const {
    dropzone: s,
    isDropping: a
  } = tr({
    accept: {
      "application/x-pkcs12": [".pfx"]
    },
    onFileChanged: async (c) => {
      if (r.editLogin) {
        if (!c) {
          await e.setFieldValue("elsterCertificate", void 0);
          return;
        }
        await e.setFieldValue("elsterCertificate", {
          isPlaceholder: !0,
          file: c
        }), await t.isElsterCertificateFile(c) ? i(void 0) : i("certificateFileInvalid");
      }
    }
  });
  return e.values.elsterCertificate && !e.values.elsterCertificate.isPlaceholder ? /* @__PURE__ */ n(Zo, { elsterCertificate: e.values.elsterCertificate, dropzone: s, permissions: r }) : r.editLogin ? /* @__PURE__ */ n(Ch, { formik: e, elsterValidator: t, setElsterError: i, elsterError: o, dropzone: s, isDropping: a }) : e.initialValues.elsterCertificate && !e.initialValues.elsterCertificate.isPlaceholder ? /* @__PURE__ */ n(Zo, { elsterCertificate: e.initialValues.elsterCertificate, dropzone: s, permissions: r }) : null;
});
function Zo({
  elsterCertificate: e,
  dropzone: t,
  permissions: o
}) {
  const i = M(() => {
    if (!e.validFrom)
      return;
    const c = /* @__PURE__ */ new Date(), d = new Date(e.validFrom);
    if (d > c)
      return {
        type: "notYetValid",
        days: To(d, c)
      };
  }, [e.validFrom]), r = M(() => {
    if (!e.validUntil)
      return;
    const c = /* @__PURE__ */ new Date(), d = new Date(e.validUntil), l = To(d, c);
    if (d < c)
      return {
        type: "expired",
        days: Math.abs(l)
      };
    if (l <= 90)
      return {
        type: "expiring",
        days: l
      };
  }, [e.validUntil]), {
    onClick: s,
    ...a
  } = t.getRootProps();
  return (
    // Using a wrapper for dropzone here, because dropzone needs a ref, which can't easily be passed
    // through to the underlying HTML element of ElsterCertificatePropertiesBox
    /* @__PURE__ */ n("div", { ...o.editLogin ? a : {}, children: /* @__PURE__ */ m(or, { className: C(ye.ElsterCertificateView, t.isDragActive && ye.dragActive), headlineControls: /* @__PURE__ */ m("div", { className: ye.HeadlineButtons, children: [
      o.viewSecrets && /* @__PURE__ */ n(Ht, { element: "a", tooltip: u._(
        /** i18n */
        {
          id: "mzI_c-"
        }
      ), className: ye.HeadlineButton, href: `data:application/octet-stream;charset=utf-8;base64,${e.certificateData}`, download: e.filename, children: /* @__PURE__ */ n(yc, {}) }),
      o.editLogin && /* @__PURE__ */ m(T, { children: [
        /* @__PURE__ */ n(Ht, { element: "button", tooltip: u._(
          /** i18n */
          {
            id: "fqSfXY"
          }
        ), className: ye.HeadlineButton, type: "button", onClick: s, children: /* @__PURE__ */ n(wc, {}) }),
        /* @__PURE__ */ n("input", { type: "file", ...t.getInputProps() })
      ] })
    ] }), children: [
      t.isDragActive && /* @__PURE__ */ n("div", { className: ye.DropIndicator, children: /* @__PURE__ */ n(f, { id: "FaJHZV" }) }),
      /* @__PURE__ */ m(Yi, { children: [
        /* @__PURE__ */ n(tt, { headline: u._(
          /** i18n */
          {
            id: "QKwPIb"
          }
        ), children: e.subjectCN }),
        /* @__PURE__ */ n(tt, { headline: u._(
          /** i18n */
          {
            id: "YpDGl8"
          }
        ), children: /* @__PURE__ */ m("span", { className: C(ye.Valid, {
          [ye.warning]: i?.type === "notYetValid"
        }), children: [
          ln(new Date(e.validFrom), "Pp", {
            locale: Ve()
          }),
          i && /* @__PURE__ */ n("span", { className: ye.Info, children: i.type === "notYetValid" ? /* @__PURE__ */ n(f, { id: "ioJ69e", values: {
            0: i.days
          } }) : z(i.type) })
        ] }) }),
        /* @__PURE__ */ n(tt, { headline: u._(
          /** i18n */
          {
            id: "zzp4XX"
          }
        ), children: /* @__PURE__ */ m("span", { className: C(ye.Valid, {
          [ye.warning]: r?.type === "expiring",
          [ye.error]: r?.type === "expired"
        }), children: [
          ln(new Date(e.validUntil), "Pp", {
            locale: Ve()
          }),
          r && /* @__PURE__ */ n("span", { className: ye.Info, children: r.type === "expired" ? /* @__PURE__ */ n(f, { id: "gF3rsX", values: {
            0: r.days
          } }) : r.type === "expiring" ? /* @__PURE__ */ n(f, { id: "pIh7Lu", values: {
            0: r.days
          } }) : z(r) })
        ] }) }),
        /* @__PURE__ */ n(tt, { headline: u._(
          /** i18n */
          {
            id: "chZjJd"
          }
        ), children: e.serialNumber })
      ] })
    ] }) })
  );
}
function Ch({
  formik: e,
  elsterError: t,
  dropzone: o,
  isDropping: i
}) {
  return /* @__PURE__ */ n(or, { headlineControls: /* @__PURE__ */ n(Ae, { href: u._(
    /** i18n */
    {
      id: "XXAMDz"
    }
  ), children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) }), children: /* @__PURE__ */ n(nr, { accept: {
    "application/x-pkcs12": [".pfx"]
  }, filename: e.values.elsterCertificate?.isPlaceholder ? e.values.elsterCertificate.file.name : e.values.elsterCertificate?.filename, error: t === "certificateFileInvalid" ? u._(
    /** i18n */
    {
      id: "5AhbSx"
    }
  ) : t === "certificateFileMissingPrimaryCertificate" ? u._(
    /** i18n */
    {
      id: "e3UJKQ"
    }
  ) : t === "certificateFileNotUploaded" ? u._(
    /** i18n */
    {
      id: "9L73ua"
    }
  ) : void 0, success: e.values.elsterCertificate && (!t || t === "passwordIncorrect") ? u._(
    /** i18n */
    {
      id: "qnfy4M"
    }
  ) : void 0, dropzone: o, isDropping: i, asyncErrors: [] }) });
}
function or({
  children: e,
  headlineControls: t,
  ...o
}) {
  return /* @__PURE__ */ n(Ki, { headline: u._(
    /** i18n */
    {
      id: "xkM21M"
    }
  ), icon: Cc, headlineControls: t, ...o, children: e });
}
function ir({
  values: e,
  focusedWebsiteInput: t,
  focusedScopeEntryInput: o,
  allowElsterCertificatePlaceholder: i
}) {
  const {
    websites: r,
    websiteAttributes: s,
    newFocusedWebsiteValue: a
  } = rr(e, t);
  return {
    normalizedValues: {
      ...e,
      scope: wh(e.scope, o),
      websites: vh(r),
      websiteAttributes: s,
      ...bh(e),
      creditCard: e.creditCard ? ws(e.creditCard) : e.creditCard,
      androidApps: e.androidApps ? Sh(e.androidApps) : e.androidApps,
      elsterCertificate: e.elsterCertificate ? Ih(e.elsterCertificate, !!i) : e.elsterCertificate,
      // Ensure that the field is set to undefined instead of being unset
      displayHeadline: e.displayHeadline ?? void 0
    },
    newFocusedWebsiteValue: a
  };
}
function rr(e, t) {
  const o = [...e.websites], i = {
    ...e.websiteAttributes
  };
  let r;
  if (t) {
    const s = o[t.index];
    if (s) {
      const a = t.oldNormalizedValue;
      r = qn(s);
      const c = bs(s);
      o[t.index] = r, i[r] = {
        ...i[r],
        ...i?.[a],
        ...c
      };
    }
  }
  for (const s of Object.keys(i))
    o.includes(s) || delete i[s];
  return e.websiteAttributes === void 0 && Object.keys(i).length === 0 ? {
    websites: o,
    websiteAttributes: void 0,
    newFocusedWebsiteValue: r
  } : {
    websites: o,
    websiteAttributes: i,
    newFocusedWebsiteValue: r
  };
}
function wh(e, t) {
  if (!e)
    return;
  const o = e?.filter((i) => i !== void 0 && !sr(i));
  if (t) {
    const i = Fe(o[t.index]);
    i && (o[t.index] = vs(i));
  }
  if (o.length)
    return o;
}
function sr(e) {
  const t = Fe(e);
  switch (t.kind) {
    case "unknown":
      return !1;
    case "website":
      return qn(t.pattern) === "";
    case "androidApp":
      return !1;
    case "windowsDesktopApp":
      return t.exeName === "";
    case "newWebsite":
    case "newAndroidApp":
    case "newWindowsDesktopApp":
      return !0;
    default:
      z(t);
  }
}
function bh(e) {
  if (!e.totp)
    return {
      totp: void 0,
      totpAlgorithm: void 0,
      totpDigits: void 0,
      totpPeriod: void 0
    };
  const t = kn(e.totp);
  if (t)
    return {
      totp: t.secret,
      totpAlgorithm: t.algorithm,
      totpDigits: t.digits,
      totpPeriod: t.period
    };
  const o = Si(e.totp);
  return o ? {
    totp: o,
    totpAlgorithm: e.totpAlgorithm,
    totpDigits: e.totpDigits,
    totpPeriod: e.totpPeriod
  } : e.totp ? {
    totp: e.totp,
    totpAlgorithm: e.totpAlgorithm,
    totpDigits: e.totpDigits,
    totpPeriod: e.totpPeriod
  } : {
    totp: void 0,
    totpAlgorithm: void 0,
    totpDigits: void 0,
    totpPeriod: void 0
  };
}
function vh(e) {
  return e.filter((t) => t !== void 0 && t !== "");
}
function Sh(e) {
  return e?.filter((t) => t !== void 0);
}
function Ih(e, t) {
  if (e.isPlaceholder) {
    if (!t)
      throw new Error("Unexpectedly received certificate placeholder!");
    return {
      certificateData: "",
      filename: e.file.name,
      issuer: "",
      subjectCN: "",
      serialNumber: "",
      validFrom: "",
      validUntil: ""
    };
  }
  return e;
}
const Nh = "_RelatedDomains_1qt23_1", Ah = {
  RelatedDomains: Nh
}, Lh = he(["websites", "websiteAttributes"])(({
  formik: e,
  writeToClipboard: t,
  readOnly: o,
  focusedWebsiteInputRef: i,
  enableExeDetection: r,
  allowAdd: s,
  autoFocusNewEntry: a,
  clearNewEntryAutoFocus: c,
  removeField: d
}) => {
  const l = jt("websites"), p = e.values.websites ?? [];
  let _;
  p.length ? _ = p : _ = [void 0];
  const h = _[0], g = _.length === 1 && (h === void 0 || qn(h) === "") && !d, [w, b] = R();
  return o && !_.some((y) => !!y) ? null : /* @__PURE__ */ n(zt, { name: "websites", render: (y) => /* @__PURE__ */ n(T, { children: _.map((v, S) => /* @__PURE__ */ n(Ph, { formik: e, index: S, readOnly: o, autoFocus: w === S || !p.length && a, writeToClipboard: t, enableExeDetection: r, hideDelete: g, deleteWebsite: () => {
    y.remove(S), p.length <= 1 && d?.();
  }, clearAutoFocus: () => {
    b(void 0), c();
  }, focusedWebsiteInputRef: i, infoLineButtons: (s || l.length > 0) && !o && S === _.length - 1 ? /* @__PURE__ */ m(qt, { children: [
    s && /* @__PURE__ */ n(bt, { onClick: () => {
      b(e.values.websites.length), p.length === 0 && y.push(void 0), y.push(void 0);
    }, children: /* @__PURE__ */ n(f, { id: "iOiHwJ" }) }),
    /* @__PURE__ */ n(Gt, { buttons: l })
  ] }) : void 0 }, S)) }) });
});
function Ph({
  formik: e,
  focusedWebsiteInputRef: t,
  index: o,
  ...i
}) {
  const r = `websites.${o}`, s = e.getFieldProps(r), a = e.values.websiteAttributes?.[s.value], c = ot(a?.protocol);
  return /* @__PURE__ */ n(ro, { ...i, fieldProps: s, onFocus: () => {
    t.current = {
      index: o,
      oldNormalizedValue: s.value
    };
  }, onBlur: () => {
    const {
      websites: d,
      websiteAttributes: l
    } = rr(e.values, t.current);
    t.current = void 0, e.setFieldValue("websites", d).catch($), e.setFieldValue("websiteAttributes", l).catch($);
  }, protocol: c, isSubmitting: e.isSubmitting });
}
function ro({
  autoFocus: e,
  clearAutoFocus: t,
  deleteWebsite: o,
  enableExeDetection: i,
  fieldProps: r,
  hideDelete: s,
  infoLineButtons: a,
  isSubmitting: c,
  onBlur: d,
  onFocus: l,
  protocol: p,
  readOnly: _,
  writeToClipboard: h,
  linkTarget: g,
  additionalRelatedDomains: w
}) {
  const {
    onBlur: b,
    ...y
  } = r, {
    action: v
  } = fe(h, y?.value ?? ""), S = y.value ? {
    icon: bc,
    key: "openinbrowser",
    label: u._(
      /** i18n */
      {
        id: "yxTdsJ"
      }
    ),
    element: {
      type: "a",
      props: {
        href: g ?? `${ot(p) ?? "http"}://${y.value}`,
        target: "_blank",
        rel: "noopener noreferrer"
      }
    }
  } : void 0, {
    ref: I,
    inlineUi: E
  } = pe([S ?? [], v, !_ && !s ? ze(o, {
    disabled: c
  }).action : []].flat()), [A, N] = R(), P = M(() => {
    const F = new Set(w);
    for (const O of Rh(y.value) ?? [])
      F.add(O);
    return F.size ? [...F] : void 0;
  }, [w, y.value]), L = M(() => i ? y.value?.endsWith(".exe") ? "app" : y.value === "" || typeof y.value != "string" || !y.value.includes(".") || y.value.match("\\.e?x?e?$") ? "ambiguous" : "website" : "website", [y.value, i]);
  return /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { label: L === "ambiguous" ? u._(
      /** i18n */
      {
        id: "DLZKkf"
      }
    ) : L === "app" ? u._(
      /** i18n */
      {
        id: "LMUw1U"
      }
    ) : u._(
      /** i18n */
      {
        id: "On0aF2"
      }
    ), element: {
      type: "input",
      props: {
        type: "text",
        ...y,
        autoFocus: e,
        readOnly: _,
        inputMode: "url",
        autoCapitalize: "off",
        autoCorrect: "off",
        onFocus: l,
        onBlur: (F) => {
          b(F), !_ && (t(), d(F));
        },
        ref: I
      }
    }, isSubmitting: c, inlineUi: E }) }),
    (P || a) && /* @__PURE__ */ m(rt, { children: [
      P && /* @__PURE__ */ n("span", { className: Ah.RelatedDomains, children: A === y.value || P.length < 4 ? P.length === 1 ? /* @__PURE__ */ n(f, { id: "ai680t", values: {
        0: P[0]
      } }) : /* @__PURE__ */ m(T, { children: [
        /* @__PURE__ */ n(f, { id: "y4UGV2", values: {
          0: P.slice(0, P.length - 1).join(", "),
          1: P[P.length - 1]
        } }),
        P.length >= 4 && /* @__PURE__ */ m(T, { children: [
          " ",
          /* @__PURE__ */ n(it, { type: "button", onClick: () => {
            N(void 0);
          }, children: /* @__PURE__ */ n(f, { id: "vLyv1R" }) })
        ] })
      ] }) : /* @__PURE__ */ m(T, { children: [
        /* @__PURE__ */ n(f, { id: "czBEzZ", values: {
          0: P.length
        } }),
        " ",
        /* @__PURE__ */ n(it, { type: "button", onClick: () => {
          N(y.value);
        }, children: /* @__PURE__ */ n(f, { id: "8vETh9" }) })
      ] }) }),
      a
    ] })
  ] });
}
function Rh(e) {
  if (!e)
    return;
  const t = /^([a-z]+:)?\/\//.exec(e);
  let o;
  try {
    o = new URL(t ? e : `https://${e}`);
  } catch {
    return;
  }
  return Ss(o.hostname);
}
function Bh({
  implicitWebsites: e,
  writeToClipboard: t,
  addEntryButtons: o
}) {
  const i = B(() => {
    throw new Error("Not allowed");
  }, []), r = jt("implicitWebsites");
  return e.map((s, a) => /* @__PURE__ */ n(ro, { autoFocus: !1, clearAutoFocus: i, deleteWebsite: i, fieldProps: {
    value: s.website,
    name: "",
    onBlur: i,
    onChange: i
  }, hideDelete: !0, isSubmitting: !1, onBlur: i, onFocus: i, writeToClipboard: t, readOnly: !0, linkTarget: s.linkTarget, additionalRelatedDomains: s.relatedOrigins, infoLineButtons: (o || r.length > 0) && a === e.length - 1 ? /* @__PURE__ */ m(qt, { children: [
    o,
    /* @__PURE__ */ n(Gt, { buttons: r })
  ] }) : void 0 }, a));
}
const Th = "_LoginEdit_1yc07_1", Eh = "_MovedLoginHint_1yc07_7", $h = "_movedLogin_1yc07_15", xh = "_Main_1yc07_15", Mh = "_Preform_1yc07_21", Fh = "_FormGroup_1yc07_29", kh = "_SubmitContainer_1yc07_48", Wh = "_darkMode_1yc07_68", Oh = "_useSafeArea_1yc07_78", Dh = "_Info_1yc07_96", Hh = "_UnsavedChangesWarning_1yc07_133", Uh = "_SubmitButton_1yc07_138", Vh = "_saved_1yc07_149", zh = "_SavedSuccessIcon_1yc07_152", qh = "_ShortcutHint_1yc07_157", jh = "_ImportLink_1yc07_172", de = {
  LoginEdit: Th,
  MovedLoginHint: Eh,
  movedLogin: $h,
  Main: xh,
  Preform: Mh,
  FormGroup: Fh,
  SubmitContainer: kh,
  darkMode: Wh,
  useSafeArea: Oh,
  Info: Dh,
  UnsavedChangesWarning: Hh,
  SubmitButton: Uh,
  saved: Vh,
  SavedSuccessIcon: zh,
  ShortcutHint: qh,
  ImportLink: jh
}, Gh = {
  [U.creditCard]: vc,
  [U.elsterCertificate]: Sc,
  [U.note]: Nc,
  [U.login]: Ic,
  [U.wifi]: Ac
};
function cr({
  uiType: e,
  ...t
}) {
  const o = Gh[e];
  return o ? /* @__PURE__ */ n(o, { ...t }) : null;
}
const Kh = "_DropdownWrapper_3h7h3_1", Yh = "_Dropdown_3h7h3_1", Xh = "_OptionButton_3h7h3_15 _UnstyledButton_r3cpb_208", Jh = "_UiTypeButton_3h7h3_33 _UnstyledButton_r3cpb_208", Qh = "_light_3h7h3_54", Zh = "_dark_3h7h3_58", em = "_Arrow_3h7h3_62", tm = "_UiTypeIcon_3h7h3_67", nt = {
  DropdownWrapper: Kh,
  Dropdown: Yh,
  OptionButton: Xh,
  UiTypeButton: Jh,
  light: Qh,
  dark: Zh,
  Arrow: em,
  UiTypeIcon: tm
}, nm = Object.values(ce);
function om({
  uiType: e,
  setUiType: t,
  className: o
}) {
  const [i, r] = R(!1), s = B(() => r(!1), []), a = D(null);
  return ki(a, s), /* @__PURE__ */ m("div", { ref: a, className: C(nt.DropdownWrapper, o), children: [
    /* @__PURE__ */ n(ar, { uiType: e, onClick: () => r((c) => !c), open: i }),
    i && /* @__PURE__ */ n(Oi, { className: nt.Dropdown, children: nm.map((c) => /* @__PURE__ */ m("button", { type: "button", onClick: () => {
      t(c), s();
    }, className: nt.OptionButton, role: "option", "aria-selected": !1, children: [
      /* @__PURE__ */ n(cr, { uiType: c, className: nt.UiTypeIcon }),
      fi(c)
    ] }, c)) })
  ] });
}
function ar({
  uiType: e,
  open: t,
  className: o,
  ...i
}) {
  const r = X();
  return /* @__PURE__ */ m("button", { type: "button", className: C(o, nt.UiTypeButton, nt[r]), ...i, children: [
    /* @__PURE__ */ n(cr, { uiType: e, className: nt.UiTypeIcon }),
    fi(e),
    !i.disabled && /* @__PURE__ */ n(Jn, { direction: t ? "up" : "down", className: nt.Arrow })
  ] });
}
const im = "_LoginOptions_1nqiz_1", rm = "_UiTypeButton_1nqiz_21", sm = "_ActionsDropdown_1nqiz_25", Ft = {
  LoginOptions: im,
  UiTypeButton: rm,
  ActionsDropdown: sm
}, cm = he(["uiType", "password", "customFields", "elsterCertificate", "passkey"])(({
  formik: e,
  initialGeneratedPassword: t,
  newLogin: o,
  resetNonEmptyFields: i,
  resetNonEmptyField: r,
  openShareModal: s,
  canLinkLogin: a,
  isNewLogin: c,
  permissions: d,
  addCustomField: l,
  deleteLogin: p,
  duplicateLogin: _,
  goToLogin: h,
  isLoginTrashable: g,
  isLinkedLogin: w,
  additionalActions: b,
  addCustomFieldDisabled: y
}) => {
  const v = X(), S = ot(e.values.uiType), I = am(_, h), E = M(() => d.editLogin ? [{
    element: {
      type: "button",
      props: {
        type: "button",
        onClick: l,
        disabled: y
      }
    },
    key: "addCustomField",
    label: u._(
      /** i18n */
      {
        id: "CgUQh7"
      }
    ),
    icon: Lc
  }] : [], [l, y, d.editLogin]), A = M(() => {
    const L = [];
    return b && L.push(...b), I && d.duplicateLogin && L.push(I), p && d.deleteLogin && L.push({
      element: {
        type: "button",
        props: {
          type: "button",
          onClick: () => {
            p().catch($);
          }
        }
      },
      key: "delete",
      label: w ? u._(
        /** i18n */
        {
          id: "Clnbgt"
        }
      ) : g ? u._(
        /** i18n */
        {
          id: "IK-8Ec"
        }
      ) : u._(
        /** i18n */
        {
          id: "cnGeoo"
        }
      ),
      icon: Pc
    }), L;
  }, [b, p, I, w, g, d.deleteLogin, d.duplicateLogin]), N = !c && (d.shareLoginExternal || a), P = !!e.values.passkey || // Can't change back to another type once certificate has been added
  S === U.elsterCertificate && e.values.elsterCertificate;
  return /* @__PURE__ */ m("div", { className: C(Ft.LoginOptions, Ft[v]), children: [
    P ? /* @__PURE__ */ n(ar, { uiType: S, disabled: !0, className: Ft.UiTypeButton }) : /* @__PURE__ */ n(om, { uiType: S, setUiType: (L) => {
      e.values.uiType !== L && (e.setFieldValue("uiType", L).catch($), i(), o && (L === U.login && e.values.password === "" ? e.setFieldValue("password", t).catch($) : L !== U.login && e.values.password === t && (e.setFieldValue("password", "").catch($), r("password"))));
    }, className: Ft.UiTypeButton }),
    N && s && /* @__PURE__ */ n(it, { type: "button", onClick: s, children: /* @__PURE__ */ n(f, { id: "Z8lGw6" }) }),
    /* @__PURE__ */ n(yn, { inlineActions: E, dropdownActions: A, dropdownClassName: Ft.ActionsDropdown, horizontalDots: !0 })
  ] });
});
function am(e, t) {
  const [o, i] = R(!1), [r, s] = R(), a = B(async () => {
    if (e) {
      i(!0);
      try {
        const c = await e();
        s(c);
      } finally {
        i(!1);
      }
    }
  }, [e]);
  return M(() => {
    if (e)
      return !o && r && t ? {
        key: "duplicateLogin",
        element: {
          type: "button",
          props: {
            type: "button",
            onClick: () => t(r)
          }
        },
        label: u._(
          /** i18n */
          {
            id: "myEFzu"
          }
        ),
        icon: cn
      } : {
        key: "duplicateLogin",
        element: {
          type: "button",
          props: {
            type: "button",
            onClick: (c) => {
              a().catch($), c.stopPropagation();
            },
            disabled: o
          }
        },
        label: o ? u._(
          /** i18n */
          {
            id: "06EQqT"
          }
        ) : u._(
          /** i18n */
          {
            id: "GHs0V4"
          }
        ),
        icon: cn
      };
  }, [e, r, t, o, a]);
}
const lm = "_NoteTextarea_eca5n_1", dm = "_large_eca5n_4", ei = {
  NoteTextarea: lm,
  large: dm
}, um = he(["note", "uiType"])(({
  formik: e,
  readOnly: t
}) => t && !e.values.note ? null : /* @__PURE__ */ n(Y, { el: se, element: {
  type: "autosizeTextarea",
  props: {
    ...e.getFieldProps("note"),
    readOnly: t,
    className: C(ei.NoteTextarea, e.values.uiType === ce.note && ei.large)
  }
}, label: u._(
  /** i18n */
  {
    id: "KiJn9B"
  }
), error: e.touched.note ? e.errors.note : void 0, isSubmitting: e.isSubmitting })), pm = he(["uiType", "password"])(({
  formik: e,
  newLogin: t,
  writeToClipboard: o,
  openInlineDialog: i,
  setOpenInlineDialog: r,
  savePasswordGeneratorSettings: s,
  passwordGeneratorSettings: a,
  writeAuditlogEvent: c,
  updateLoginStatusPasswordChecks: d,
  enqueueUpdateLoginStatusPasswordChecks: l,
  leakedPasswordCheckStatus: p,
  permissions: _,
  passwordIsGenerated: h,
  setPasswordIsGenerated: g,
  passwordPolicy: w,
  elsterError: b,
  setElsterError: y,
  autoFocus: v,
  clearAutoFocus: S,
  deletePassword: I
}) => {
  const E = !_.editLogin, A = M(() => t && !E && e.values.uiType === U.login ? "initialPasswordGenerator" : i?.type === "password" && i.field === "password" && !E ? "editPasswordGenerator" : "edit", [e.values.uiType, t, i, E]), N = B(() => {
    b === "passwordIncorrect" && y(void 0);
  }, [b, y]), P = B((ie, Le) => {
    e.setFieldValue("password", ie, !0).catch($), l(ie), g(Le), N();
  }, [l, e, N, g]), [L, F] = R(""), [O, W] = R(h), j = B((ie, Le) => {
    F(ie), g(Le), l(ie), N();
  }, [l, N, g]), V = Ui({
    ...A === "initialPasswordGenerator" ? {
      password: e.values.password,
      setPassword: P
    } : {
      password: L,
      setPassword: j
    },
    initialState: w ? {
      type: "generatedPolicy",
      policy: w
    } : {
      type: "generatedNoPolicy",
      settings: a
    },
    onSettingsChange: d
  }), {
    action: J,
    show: G,
    setShow: oe
  } = vt({
    isEmpty: !e.values.password,
    onShow: () => {
      c?.({
        type: Ne.LOGIN_R_PASSWORD_SHOW
      });
    }
  }), {
    action: H
  } = fe((ie) => {
    o(ie, !0), c?.({
      type: Ne.LOGIN_R_PASSWORD_COPY
    });
  }, e.values.password), q = M(() => ({
    icon: jn,
    element: {
      type: "button",
      props: {
        type: "button",
        disabled: i !== void 0 || e.isSubmitting,
        onClick: () => {
          r({
            type: "password",
            field: "password"
          }), V.regeneratePassword(), c?.({
            type: Ne.LOGIN_R_PASSWORD_SHOW
          }), W(h);
        }
      }
    },
    key: "generate",
    label: u._(
      /** i18n */
      {
        id: "19BWU3"
      }
    )
  }), [e.isSubmitting, i, V, h, r, c]), be = M(() => {
    const ie = [H, J];
    return E || ie.push(q), I && ie.push(ze(() => {
      I().catch($);
    }, {
      disabled: e.isSubmitting
    }).action), ie;
  }, [H, I, e.isSubmitting, q, E, J]), {
    ref: ee,
    inlineUi: Oe
  } = pe(
    be,
    // Always show copy action inline
    {
      minInlineActions: 2
    }
  ), dt = D(!1);
  k(() => {
    dt.current || (dt.current = !0, d(A === "initialPasswordGenerator" || A === "editPasswordGenerator" ? V.password : e.values.password));
  }, [e.values.password, p, A, V.password, d]);
  let x;
  if (A === "initialPasswordGenerator")
    x = /* @__PURE__ */ n(Y, { el: Vn, ...V, hideButtons: !0, writeToClipboard: o, error: e.touched.password ? e.errors.password : void 0, saveSettings: s, savedSettings: a, onNewPasswordBlur: d, animateHeightChanges: !0 });
  else if (A === "editPasswordGenerator")
    x = /* @__PURE__ */ n(Y, { el: Vn, ...V, oldPassword: e.values.password, close: () => {
      r(void 0), d(e.values.password), dt.current = !1, V.resetToInitial(), g(O);
    }, apply: () => {
      e.setFieldValue("password", V.password).catch($), r(void 0), N();
    }, writeToClipboard: o, saveSettings: s, savedSettings: a, onNewPasswordBlur: d, animateHeightChanges: !0 });
  else if (A === "edit") {
    const ie = p?.status === "checked" && p.leakCount > 0, Le = e.getFieldProps("password"), st = b === "passwordIncorrect" ? u._(
      /** i18n */
      {
        id: "5g3jl9"
      }
    ) : e.touched.password && e.errors.password ? e.errors.password : void 0;
    x = /* @__PURE__ */ n(Y, { children: G ? /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        type: "text",
        autoComplete: "off",
        autoCapitalize: "off",
        autoCorrect: "off",
        ...Le,
        autoFocus: v,
        onBlur: (qe) => {
          Le.onBlur(qe), d(qe.currentTarget.value), S();
        },
        onChange: (qe) => {
          Le.onChange(qe), l(qe.currentTarget.value), g(!1), N();
        },
        readOnly: E,
        ref: ee
      }
    }, isSubmitting: e.isSubmitting, label: u._(
      /** i18n */
      {
        id: "8ZsakT"
      }
    ), error: st || ie, inlineUi: Oe, monospace: !0 }) : /* @__PURE__ */ n(St, { inlineUi: Oe, ref: ee, onButtonClick: () => oe(!0), changed: e.initialValues.password !== e.values.password, error: st, children: /* @__PURE__ */ n(f, { id: "7C-Jn5" }) }) });
  } else
    z(A);
  return /* @__PURE__ */ m(T, { children: [
    x,
    /* @__PURE__ */ n(oo, { anchor: "password" })
  ] });
});
function lr({
  availableAndroidAppsById: e,
  addEntry: t
}) {
  return /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(bt, { onClick: () => t({
      kind: "newWebsite"
    }), children: /* @__PURE__ */ n(f, { id: "hKxpSq" }) }),
    e && /* @__PURE__ */ n(bt, { onClick: () => t({
      kind: "newAndroidApp"
    }), children: /* @__PURE__ */ n(f, { id: "bWn0ME" }) }),
    /* @__PURE__ */ n(bt, { onClick: () => t({
      kind: "newWindowsDesktopApp"
    }), children: /* @__PURE__ */ n(f, { id: "cOchHG" }) })
  ] });
}
const _m = he(["scope"])(({
  formik: e,
  availableAndroidAppsById: t,
  writeToClipboard: o,
  readOnly: i,
  focusedScopeEntryInputRef: r,
  allowAdd: s,
  newEntryPlaceholder: a,
  autoFocusNewEntry: c,
  clearNewEntryAutoFocus: d,
  removeField: l
}) => {
  const p = jt("scope"), _ = M(() => e.values.scope ? e.values.scope?.flatMap((A, N) => {
    const P = ot(A);
    return P.kind === "unknown" ? [] : {
      scope: P,
      index: N
    };
  }) : [], [e.values.scope]);
  let h;
  _.length ? h = _ : h = [{
    scope: a ?? {
      kind: "newWebsite"
    },
    index: e.values.scope?.length ?? 0
  }];
  const [g, w] = R(), b = (A) => g === A || !_.length && c, y = B(() => {
    w(void 0), d();
  }, [d]), v = B((A, N) => {
    w(h?.length), _.length || A.push({
      kind: "newWebsite"
    }), A.push(N);
  }, [_.length, h?.length]), S = h.length === 1 && sr(h[0].scope) && !l, I = (A, N) => {
    A.remove(N), (e.values.scope?.length ?? 0) <= 1 && l?.();
  }, E = B(({
    iconDataUri: A,
    ...N
  }) => ({
    ...N,
    signature: ""
  }), []);
  return i && !_.length ? null : /* @__PURE__ */ n(zt, { name: "scope", render: (A) => /* @__PURE__ */ n(T, { children: h.map(({
    scope: N,
    index: P
  }, L) => {
    const F = !i && L === h.length - 1 && (s || p.length > 0) ? /* @__PURE__ */ m(qt, { children: [
      s && /* @__PURE__ */ n(lr, { availableAndroidAppsById: t, addEntry: (O) => v(A, O) }),
      /* @__PURE__ */ n(Gt, { buttons: p })
    ] }) : void 0;
    switch (N.kind) {
      case "website":
      case "newWebsite": {
        const O = `scope.${P}`, W = `${O}.pattern`, j = e.getFieldProps(W);
        return /* @__PURE__ */ n(ro, { fieldProps: j, writeToClipboard: o, deleteWebsite: () => I(A, P), hideDelete: S, autoFocus: b(P), clearAutoFocus: y, onFocus: () => {
          r.current = {
            index: P
          }, N.kind === "newWebsite" && e.setFieldValue(O, {
            kind: "website",
            pattern: ""
          }).catch($);
        }, onBlur: () => {
          r.current = void 0, N.kind === "website" && e.setFieldValue(O, Ns(N)).catch($);
        }, infoLineButtons: F, protocol: N.kind === "website" ? ot(N?.protocol) : void 0, readOnly: i, isSubmitting: e.isSubmitting }, O);
      }
      case "androidApp":
      case "newAndroidApp": {
        const O = `scope.${P}`;
        return /* @__PURE__ */ m(Mn, { children: [
          /* @__PURE__ */ n(er, { availableAndroidAppsById: t, toOption: E, value: N.kind === "newAndroidApp" ? void 0 : N, readOnly: i, autoFocus: b(P), clearAutoFocus: y, hideDelete: S, deleteApp: () => I(A, P), onChange: (W) => {
            e.setFieldValue(O, {
              kind: "androidApp",
              ...W
            }, !1).catch($);
          }, isSubmitting: e.isSubmitting }),
          F && /* @__PURE__ */ n(rt, { children: F })
        ] }, O);
      }
      case "windowsDesktopApp":
      case "newWindowsDesktopApp": {
        const O = `scope.${P}`, W = `${O}.exeName`, j = e.getFieldProps(W);
        return /* @__PURE__ */ m(Mn, { children: [
          /* @__PURE__ */ n(hm, { fieldProps: j, writeToClipboard: o, deleteApp: () => I(A, P), hideDelete: S, autoFocus: b(P), clearAutoFocus: y, onFocus: () => {
            r.current = {
              index: P
            }, N.kind === "newWindowsDesktopApp" && e.setFieldValue(O, {
              kind: "windowsDesktopApp",
              exeName: ""
            }).catch($);
          }, onBlur: () => {
            r.current = void 0, N.kind === "windowsDesktopApp" && e.setFieldValue(O, Is(N)).catch($);
          }, readOnly: i, isSubmitting: e.isSubmitting }),
          F && /* @__PURE__ */ n(rt, { children: F })
        ] }, O);
      }
      default:
        return z(N);
    }
  }) }) });
});
function hm({
  fieldProps: e,
  deleteApp: t,
  writeToClipboard: o,
  readOnly: i,
  hideDelete: r,
  autoFocus: s,
  clearAutoFocus: a,
  onFocus: c,
  onBlur: d,
  isSubmitting: l
}) {
  const {
    onBlur: p,
    ..._
  } = e, {
    action: h
  } = fe(o, _?.value ?? ""), {
    ref: g,
    inlineUi: w
  } = pe([h, !i && !r ? ze(t, {
    disabled: l
  }).action : []].flat());
  return /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { label: u._(
    /** i18n */
    {
      id: "QfUffE"
    }
  ), element: {
    type: "input",
    props: {
      type: "text",
      ..._,
      autoFocus: s,
      readOnly: i,
      autoCapitalize: "off",
      autoCorrect: "off",
      onFocus: c,
      onBlur: (b) => {
        p(b), !i && (a(), d(b));
      },
      ref: g
    }
  }, isSubmitting: l, inlineUi: w }) });
}
function mm({
  login: e
}) {
  const {
    sender: t
  } = e;
  if (!t)
    return null;
  const o = t.company ? `${t.name}, ${t.company}` : t.name;
  return /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(Y, { el: se, element: {
    type: "input",
    props: {
      type: "text",
      readOnly: !0,
      value: o
    }
  }, label: u._(
    /** i18n */
    {
      id: "byfRNP"
    }
  ) }) });
}
const fm = "_TagChipInput_16w39_1", gm = "_Input_16w39_17", ym = "_darkMode_16w39_22", Cm = "_error_16w39_27", wm = "_done_16w39_51", bm = "_cancel_16w39_54", vm = "_Suggestions_16w39_58", Sm = "_hidden_16w39_80", Im = "_Suggestion_16w39_58", Nm = "_highlighted_16w39_95", Am = "_visible_16w39_131", Se = {
  TagChipInput: fm,
  Input: gm,
  darkMode: ym,
  error: Cm,
  done: wm,
  cancel: bm,
  Suggestions: vm,
  hidden: Sm,
  Suggestion: Im,
  highlighted: Nm,
  Error: "_Error_16w39_105",
  visible: Am
}, ti = 12;
function Lm({
  suggestions: e,
  tags: t,
  addTag: o,
  cancelEdit: i
}) {
  const [r, s] = R(!1), [a, c] = R(), d = (I) => {
    const E = As(I);
    if (!E.length) {
      c("noTagEntered"), s(!0);
      return;
    }
    if (t?.includes(E)) {
      c("alreadyExists"), s(!0);
      return;
    }
    o(E);
  }, l = X(), [p, _] = R(""), h = M(() => {
    const I = p.toLowerCase().trim();
    return I ? e.filter((E) => E.toLowerCase().includes(I)).slice(0, ti) : e.slice(0, ti);
  }, [p, e]), {
    isOpen: g,
    getMenuProps: w,
    getInputProps: b,
    highlightedIndex: y,
    getItemProps: v
  } = an({
    initialIsOpen: !0,
    items: h,
    inputValue: p,
    selectedItem: p,
    itemToString: (I) => I ?? "",
    onSelectedItemChange: ({
      selectedItem: I
    }) => {
      I && d(I);
    }
  }), S = g && h.length > 0;
  return /* @__PURE__ */ m("div", { className: C(Se.TagChipInput, l === "dark" && Se.darkMode, a && r && Se.error), children: [
    /* @__PURE__ */ n("input", { ...b({
      type: "text",
      className: Se.Input,
      value: p,
      placeholder: u._(
        /** i18n */
        {
          id: "2L4nL2"
        }
      ),
      autoFocus: !0,
      onChange: (I) => {
        _(I.currentTarget.value), s(!1);
      },
      onKeyDown: (I) => {
        I.key === "Enter" && (!S || y === -1) && (d(p), I.preventDefault()), I.key === "Escape" && !S && (i(), I.preventDefault()), (I.key === "ArrowDown" || I.key === "ArrowUp" || I.key === "Home" || I.key === "End") && !S && (I.preventDownshiftDefault = !0);
      }
    }) }),
    /* @__PURE__ */ n(yn, { inlineActions: [{
      className: Se.cancel,
      icon: Bc,
      label: u._(
        /** i18n */
        {
          id: "dEgA5A"
        }
      ),
      key: "cancel",
      element: {
        type: "button",
        props: {
          type: "button",
          onClick: () => {
            i();
          }
        }
      }
    }, {
      className: Se.done,
      icon: Tc,
      label: u._(
        /** i18n */
        {
          id: "DPfwMq"
        }
      ),
      key: "done",
      element: {
        type: "button",
        props: {
          type: "button",
          onClick: () => {
            d(p);
          }
        }
      }
    }] }),
    /* @__PURE__ */ n("ul", { ...w(), className: C(Se.Suggestions, !S && Se.hidden), children: h.map((I, E) => /* @__PURE__ */ n("li", { className: C(Se.Suggestion, {
      [Se.highlighted]: y === E
    }), ...v({
      item: I,
      index: E
    }), title: I, children: I }, E)) }),
    /* @__PURE__ */ n("div", { className: C(Se.Error, r && Se.visible), "aria-hidden": !r, children: a === "alreadyExists" ? u._(
      /** i18n */
      {
        id: "oYNiCo"
      }
    ) : a === "noTagEntered" ? u._(
      /** i18n */
      {
        id: "XdSz-P"
      }
    ) : void 0 })
  ] });
}
const Pm = "_Tags_qzxtx_1", Rm = "_TagsLabel_qzxtx_11", Bm = "_LastTagWrapper_qzxtx_16", Tm = "_TagChip_qzxtx_23", Em = "_TagText_qzxtx_36 _UnstyledButton_r3cpb_208", $m = "_TagSeparator_qzxtx_52", xm = "_readOnly_qzxtx_56", Mm = "_TagChipRemove_qzxtx_60 _UnstyledButton_r3cpb_208", Fm = "_darkMode_qzxtx_76", km = "_InitialAddButton_qzxtx_80 _UnstyledButton_r3cpb_208", Wm = "_AddButton_qzxtx_92 _UnstyledButton_r3cpb_208", Om = "_AddIcon_qzxtx_104", Ce = {
  Tags: Pm,
  TagsLabel: Rm,
  LastTagWrapper: Bm,
  TagChip: Tm,
  TagText: Em,
  TagSeparator: $m,
  readOnly: xm,
  TagChipRemove: Mm,
  darkMode: Fm,
  InitialAddButton: km,
  AddButton: Wm,
  AddIcon: Om
}, Dm = he(["tags"])(({
  formik: e,
  tagSuggestions: t,
  readOnly: o,
  onTagClick: i,
  showTagInput: r,
  setShowTagInput: s
}) => {
  const {
    tags: a
  } = e.values, c = M(() => (t ?? []).filter((l) => !a?.includes(l)), [a, t]), d = M(() => we(e.initialValues.tags ?? [], e.values.tags ?? []) ? null : /* @__PURE__ */ n("strong", { children: /* @__PURE__ */ n(f, { id: "d_ZbMk" }) }), [e.initialValues.tags, e.values.tags]);
  return /* @__PURE__ */ n(zt, { name: "tags", render: (l) => {
    function p(h) {
      l.push(h), s(!1);
    }
    const _ = o ? void 0 : r ? {
      attachToLastTag: !1,
      el: /* @__PURE__ */ n(Lm, { suggestions: c, addTag: p, cancelEdit: () => s(!1), tags: a })
    } : a?.length ? {
      attachToLastTag: !0,
      el: /* @__PURE__ */ n(Ht, { element: "button", tooltip: u._(
        /** i18n */
        {
          id: "m16xKo"
        }
      ), className: Ce.AddButton, type: "button", onClick: () => s(!0), children: /* @__PURE__ */ n(Rc, { className: Ce.AddIcon, title: u._(
        /** i18n */
        {
          id: "m16xKo"
        }
      ) }) })
    } : {
      attachToLastTag: !1,
      el: /* @__PURE__ */ n("button", { className: Ce.InitialAddButton, type: "button", onClick: () => s(!0), children: /* @__PURE__ */ n(f, { id: "m16xKo" }) })
    };
    return /* @__PURE__ */ n(T, { children: /* @__PURE__ */ m(Y, { className: Ce.Tags, children: [
      /* @__PURE__ */ n("strong", { className: Ce.TagsLabel, children: /* @__PURE__ */ n(f, { id: "hko_4A" }) }),
      a?.map((h, g) => {
        const w = /* @__PURE__ */ n(Hm, { readOnly: o, name: h, onTagClick: i, disabled: e.isSubmitting, remove: () => l.remove(g) }, g);
        return g === a.length - 1 && _?.attachToLastTag ? /* @__PURE__ */ m("div", { className: Ce.LastTagWrapper, children: [
          w,
          _.el,
          d
        ] }, g) : w;
      }),
      _ && !_.attachToLastTag && /* @__PURE__ */ m(T, { children: [
        _.el,
        d
      ] })
    ] }) });
  } });
});
function ni({
  name: e
}) {
  return /* @__PURE__ */ n(T, { children: e.split("/").map((t, o) => /* @__PURE__ */ m(Mn, { children: [
    o > 0 && /* @__PURE__ */ n("span", { className: Ce.TagSeparator, children: "/" }),
    t
  ] }, o)) });
}
function Hm({
  name: e,
  readOnly: t,
  disabled: o,
  onTagClick: i,
  remove: r
}) {
  const s = X();
  return /* @__PURE__ */ m("span", { className: C(Ce.TagChip, t && Ce.readOnly), title: e, children: [
    i ? /* @__PURE__ */ n("button", { type: "button", onClick: () => i(e), className: Ce.TagText, children: /* @__PURE__ */ n(ni, { name: e }) }) : /* @__PURE__ */ n("span", { className: Ce.TagText, children: /* @__PURE__ */ n(ni, { name: e }) }),
    !t && /* @__PURE__ */ n(Ht, { element: "button", tooltip: u._(
      /** i18n */
      {
        id: "_7FPnu"
      }
    ), type: "button", onClick: () => r(), className: C(Ce.TagChipRemove, s === "dark" && Ce.darkMode), disabled: o, children: /* @__PURE__ */ n(fn, {}) })
  ] });
}
const Um = "_TotpCodeWrapper_1138k_1", Vm = "_TotpLabel_1138k_7", zm = "_TotpInput_1138k_12", qm = "_TotpCodeContainer_1138k_17", jm = "_TotpValue_1138k_29", lt = {
  TotpCodeWrapper: Um,
  TotpLabel: Vm,
  TotpInput: zm,
  TotpCodeContainer: qm,
  TotpValue: jm
}, Gm = he(["totp", "totpDigits", "totpAlgorithm", "totpPeriod"])(({
  formik: e,
  writeToClipboard: t,
  showTotpTimeOffsetWarning: o,
  checkTotpTimeOffset: i,
  writeAuditlogEvent: r,
  permissions: s,
  autoFocus: a,
  clearAutoFocus: c,
  deleteTotp: d
}) => {
  const l = s.viewSecrets ? "edit" : "codeOnly", [p, _] = R(!e.initialValues.totp);
  k(() => {
    e.values.totp || _(!0);
  }, [e.values.totp]);
  const {
    action: h,
    show: g,
    setShow: w
  } = vt({
    isEmpty: !e.values.totp,
    onShow: () => {
      r?.({
        type: Ne.LOGIN_R_TOTP_SECRET_SHOW
      });
    },
    onHide: () => {
      _(!1);
    }
  }), {
    action: b
  } = ze(() => {
    e.setFieldValue("totp", "").catch($), e.setFieldValue("totpAlgorithm", void 0).catch($), e.setFieldValue("totpDigits", void 0).catch($), e.setFieldValue("totpPeriod", void 0).catch($), d();
  }, {
    disabled: e.isSubmitting
  }), y = M(() => {
    const P = e.values.totp ? kn(e.values.totp) : void 0;
    return P || {
      secret: e.values.totp,
      algorithm: Fe(e.values.totpAlgorithm),
      digits: e.values.totpDigits,
      period: e.values.totpPeriod
    };
  }, [e.values.totp, e.values.totpAlgorithm, e.values.totpDigits, e.values.totpPeriod]), v = M(() => !!(y.algorithm && y.algorithm !== Ci || y.digits && y.digits !== wi || y.period && y.period !== bi), [y.algorithm, y.digits, y.period]), {
    ref: S,
    inlineUi: I
  } = pe([h, b]), {
    onBlur: E,
    ...A
  } = e.getFieldProps("totp"), N = /* @__PURE__ */ n(Y, { el: iu, hidden: !o, recheck: i });
  if (l === "codeOnly")
    return e.values.totp && s.useLogin ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ m(Y, { className: lt.TotpCodeWrapper, children: [
        /* @__PURE__ */ n("div", { className: lt.TotpLabel, children: /* @__PURE__ */ n(f, { id: "dME5Kz" }) }),
        /* @__PURE__ */ n(oi, { writeToClipboard: t, totpSecret: e.values.totp ?? "", totpAlgorithm: Fe(e.values.totpAlgorithm), totpDigits: e.values.totpDigits, totpPeriod: e.values.totpPeriod })
      ] }),
      N
    ] }) : null;
  if (l === "edit")
    return /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ m(Y, { className: lt.TotpCodeWrapper, children: [
        g ? /* @__PURE__ */ n(se, { className: lt.TotpInput, element: {
          type: "input",
          props: {
            type: "text",
            autoComplete: "off",
            autoFocus: a,
            ...A,
            readOnly: !s.editLogin || !p,
            ref: S,
            onBlur: (P) => {
              if (E(P), !s.editLogin)
                return;
              const L = kn(P.currentTarget.value);
              if (L)
                e.setFieldValue("totp", L.secret).catch($), e.setFieldValue("totpAlgorithm", L.algorithm).catch($), e.setFieldValue("totpDigits", L.digits).catch($), e.setFieldValue("totpPeriod", L.period).catch($);
              else {
                const F = Si(P.currentTarget.value);
                F ? e.setFieldValue("totp", F).catch($) : P.currentTarget.value || (e.setFieldValue("totpAlgorithm", void 0).catch($), e.setFieldValue("totpDigits", void 0).catch($), e.setFieldValue("totpPeriod", void 0).catch($));
              }
              c();
            }
          }
        }, isSubmitting: e.isSubmitting, label: u._(
          /** i18n */
          {
            id: "g4uCmi"
          }
        ), error: e.touched.totp ? e.errors.totp : void 0, inlineUi: I, monospace: !0 }) : /* @__PURE__ */ n(St, { className: lt.TotpInput, inlineUi: I, ref: S, onButtonClick: () => w(!0), changed: e.initialValues.totp !== e.values.totp, children: /* @__PURE__ */ n(f, { id: "nld5XV" }) }),
        /* @__PURE__ */ n(oi, { writeToClipboard: t, totpSecret: y.secret ?? "", totpAlgorithm: Fe(y.algorithm), totpDigits: y.digits, totpPeriod: y.period })
      ] }),
      v && /* @__PURE__ */ n(rt, { children: /* @__PURE__ */ n(f, { id: "ESK-7k" }) }),
      N
    ] });
  z(l);
});
function oi({
  writeToClipboard: e,
  totpSecret: t,
  totpAlgorithm: o,
  totpDigits: i,
  totpPeriod: r
}) {
  const {
    totp: s,
    totpPercent: a,
    totpDigits: c
  } = ea(t, o, i, r), {
    action: d
  } = fe(e, s);
  return /* @__PURE__ */ m("div", { className: lt.TotpCodeContainer, children: [
    /* @__PURE__ */ n("div", { className: lt.TotpValue, children: s ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("span", { children: s.substring(0, c / 2) }),
      /* @__PURE__ */ n("span", { children: s.substring(c / 2) })
    ] }) : /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("span", { children: "???" }),
      /* @__PURE__ */ n("span", { children: "???" })
    ] }) }),
    a && /* @__PURE__ */ n(Id, { percent: a }),
    /* @__PURE__ */ n(yn, { inlineActions: [d] })
  ] });
}
function Km(e) {
  const [t, o] = R([]), [i, r] = R(), s = B((l) => {
    o((p) => p.includes(l) ? p : [...p, l]), r(l);
  }, []), a = B((l) => {
    o((p) => p.filter((_) => _ !== l)), e(l);
  }, [e]), c = B((l) => {
    r((p) => p === l ? void 0 : p);
  }, []), d = B((l) => t.includes(l), [t]);
  return M(() => ({
    isAdded: d,
    autoFocused: i,
    add: s,
    remove: a,
    clearAutoFocus: c
  }), [d, i, s, a, c]);
}
const Ym = 100;
function Ut({
  disabled: e,
  children: t,
  ...o
}) {
  const i = _i("(prefers-reduced-motion: reduce)");
  return e || i ? /* @__PURE__ */ n("div", { ...o, children: t }) : /* @__PURE__ */ n(Xm, { ...o, children: t });
}
function Xm({
  children: e,
  fadeDuration: t = 250,
  heightDuration: o = 250,
  ...i
}) {
  const r = D(null), s = D(null), [a, c] = R(), d = D(), l = B((g, w) => {
    const b = s.current;
    if (!b)
      return;
    const y = b.animate([{
      opacity: 1
    }, {
      opacity: 0
    }], {
      // Speed up fade out if there's no old content
      duration: g ? t : 1,
      easing: "ease-out",
      fill: "forwards"
    });
    c({
      kind: "out",
      children: g
    }), y.addEventListener("finish", () => {
      c({
        kind: "outFinished",
        prevChildrenHeight: b.offsetHeight,
        children: w
      });
    });
  }, [t]);
  Io(() => {
    if (!r.current || !s.current || a?.kind !== "outFinished")
      return;
    const g = a.children ? t : 1, w = a.prevChildrenHeight, b = s.current.offsetHeight, y = Math.abs(w - b);
    let v;
    if (y > 0) {
      const S = o * Math.min(1, y / Ym);
      r.current.animate([{
        height: `${w}px`
      }, {
        height: `${b}px`
      }], {
        duration: S,
        easing: "ease-in-out"
      }), v = s.current.animate([{
        opacity: 0
      }, {
        opacity: 1
      }], {
        duration: g,
        delay: S,
        easing: "ease-in",
        fill: "forwards"
      });
    } else
      v = s.current.animate([{
        opacity: 0
      }, {
        opacity: 1
      }], {
        duration: g,
        easing: "ease-in",
        fill: "forwards"
      });
    c({
      kind: "in",
      children: a.children
    }), v.addEventListener("finish", () => {
      c(void 0), d.current && (ii(a.children, d.current) && l(a.children, d.current), d.current = void 0);
    });
  }, [a, t, o, l]);
  const p = D(e), _ = p.current;
  p.current = e;
  const h = D();
  return ii(_, e) && (a ? d.current = e : h.current = {
    prevChildren: _,
    nextChildren: e
  }), Io(() => {
    h.current && (l(h.current.prevChildren, h.current.nextChildren), h.current = void 0);
  }), /* @__PURE__ */ n("div", { ref: r, ...i, children: /* @__PURE__ */ n("div", { ref: s, children: a ? a.children : h.current ? h.current.prevChildren : e }) });
}
function ii(e, t) {
  return e === t || !e && !t ? !1 : !e && t || e && !t ? !0 : !(typeof e == "object" && e !== null && "key" in e && typeof t == "object" && t !== null && "key" in t && e.key === t.key && e.type === t.type);
}
function Jm({
  suggestions: e,
  applySuggestion: t,
  inputProps: o,
  inlineUi: i,
  optionsOverlay: r,
  onInputEnter: s,
  renderSuggestionValueLabel: a,
  ...c
}) {
  const d = D(null), l = typeof o.value == "string" ? o.value : "", [p, _] = R(e), {
    isOpen: h,
    getMenuProps: g,
    getInputProps: w,
    highlightedIndex: b,
    getItemProps: y,
    closeMenu: v
  } = an({
    items: p,
    inputValue: l,
    selectedItem: l,
    itemToString: (A) => A ?? "",
    onSelectedItemChange: ({
      selectedItem: A
    }) => {
      A && t(A);
    },
    stateReducer: (A, {
      changes: N
    }) => (o.disabled || o.readOnly) && N.isOpen ? {
      ...N,
      isOpen: !1
    } : N
  }), S = h && p.length > 0;
  k(() => {
    const A = l.toLowerCase().trim();
    if (!A) {
      _(e);
      return;
    }
    _(e.filter((N) => N.toLowerCase().includes(A)));
  }, [e, l]);
  const [I, E] = R(!1);
  return /* @__PURE__ */ n(gn, { ...c, focus: I, disabled: !!o?.disabled, readOnly: !!o?.readOnly, value: l, renderInputElement: (A, N, P) => /* @__PURE__ */ n("input", { ...w({
    ...o,
    id: P,
    onFocus: (L) => {
      o?.onFocus?.(L), !L.defaultPrevented && E(!0);
    },
    onBlur: (L) => {
      o?.onBlur?.(L), !L.defaultPrevented && E(!1);
    },
    onKeyDown: (L) => {
      if (L.key === "Enter" && s && (!S || b === -1)) {
        const F = s();
        if (F?.closeMenu && v(), F?.preventDefault) {
          L.preventDefault();
          return;
        }
      }
      o?.onKeyDown?.(L), !L.defaultPrevented && (L.key === "ArrowDown" || L.key === "ArrowUp" || L.key === "Home" || L.key === "End") && !S && (L.preventDownshiftDefault = !0);
    },
    className: N,
    ref: d
  }), "data-lpignore": "true" }), suggestionsVisible: S, suggestions: /* @__PURE__ */ n(Hi, { isOpen: S, value: l, colorize: !!(c.warning || c.error), filteredOptions: p, highlightedIndex: b, optionsOverlay: r, getMenuProps: g, getItemProps: y, valuesEqual: (A, N) => A === N, renderValueLabel: a ?? ((A) => /* @__PURE__ */ n(T, { children: A })) }), inlineUi: i });
}
const Qm = "_InfoLineContent_17l15_1", Zm = {
  InfoLineContent: Qm
}, ef = he(["username"])(({
  formik: e,
  writeToClipboard: t,
  readOnly: o,
  usernameSuggestions: i
}) => {
  const {
    action: r
  } = fe(t, e.values.username), {
    ref: s,
    inlineUi: a
  } = pe([r]), c = jt("username"), d = M(() => c.includes("displayName") && /\d{4,}/.test(e.values.username), [c, e.values.username]);
  return o && !e.values.username ? null : /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(Jm, { inputProps: {
      type: "text",
      ...e.getFieldProps("username"),
      readOnly: o,
      ref: s,
      inputMode: "email",
      autoComplete: "off",
      autoCapitalize: "off",
      autoCorrect: "off"
    }, isSubmitting: e.isSubmitting, label: u._(
      /** i18n */
      {
        id: "d3ZUIN"
      }
    ), error: e.touched.username ? e.errors.username : void 0, inlineUi: a, suggestions: i ?? [], applySuggestion: (l) => {
      e.setFieldValue("username", l).catch($);
    }, optionsOverlay: !0 }) }),
    c.length > 0 && !o && /* @__PURE__ */ n(rt, { children: /* @__PURE__ */ m("div", { className: Zm.InfoLineContent, children: [
      /* @__PURE__ */ n(Ut, { children: d && /* @__PURE__ */ n(f, { id: "Kr-gR3" }) }),
      /* @__PURE__ */ n(qt, { children: /* @__PURE__ */ n(Gt, { buttons: c, emphasized: d ? "displayName" : void 0 }) })
    ] }) })
  ] });
});
function tf({
  uiType: e,
  nonEmptyFields: t,
  optionalFields: o,
  permissions: i,
  enableScopeCreationBetaUi: r,
  disableLoginStatus: s,
  hasImplicitWebsites: a,
  hasPasskey: c
}) {
  return M(() => ({
    displayHeadline: dr(e) || !!t.displayHeadline || o.isAdded("displayHeadline"),
    implicitWebsites: a,
    scope: e === U.login && r && !a || !!t.scope || o.isAdded("scope"),
    androidApps: e === U.login && !r && !a || !!t.androidApps || o.isAdded("androidApps"),
    websites: e === U.login && !r && !a || !!t.websites || o.isAdded("websites"),
    elsterCertificate: e === U.elsterCertificate,
    wifiSsid: e === U.wifi || !!t.wifiSsid,
    title: !!t.title || o.isAdded("title"),
    username: e === U.login || e === U.elsterCertificate || !!t.username,
    password: i.viewSecrets && (!!t.password || i.editLogin && (e === U.login && !c || e === U.elsterCertificate || e === U.wifi || o.isAdded("password"))),
    passkey: !!t.passkey,
    totp: !!t.totp || o.isAdded("totp"),
    wifiQrCode: e === U.wifi && i.viewSecrets,
    loginStatus: !s && (e === U.login || e === U.elsterCertificate) && i.viewLoginStatus
  }), [s, r, t.androidApps, t.displayHeadline, t.scope, t.title, t.totp, t.username, t.password, t.passkey, t.websites, t.wifiSsid, a, c, o, i.viewLoginStatus, i.viewSecrets, i.editLogin, e]);
}
function dr(e) {
  return e === U.note || e === U.creditCard;
}
function ri(e) {
  return e = e.replaceAll("\\", "\\\\"), e = e.replaceAll(":", "\\:"), e = e.replaceAll(";", "\\;"), e = e.replaceAll(",", "\\,"), e;
}
function nf(e, t) {
  return M(() => {
    let o = "WIFI:";
    return o += "T:WPA;", o += `S:${ri(e)};`, o += `P:${ri(t)};`, o += ";", o;
  }, [e, t]);
}
const of = "_QrCodeWrapper_7qr4w_1", rf = "_QrCode_7qr4w_1", si = {
  QrCodeWrapper: of,
  QrCode: rf
};
function sf({
  data: e,
  inlineUi: t,
  className: o
}) {
  return /* @__PURE__ */ n(gn, { value: e, readOnly: !0, disabled: !1, focus: !1, inlineUi: t, className: o, renderInputElement: (i, r, s) => /* @__PURE__ */ n("div", { className: C(r, si.QrCodeWrapper), children: /* @__PURE__ */ n(Ec, { className: si.QrCode, value: i, renderAs: "svg", bgColor: "transparent", fgColor: "currentColor", id: s }) }) });
}
const cf = he(["wifiSsid", "password"])(({
  formik: e,
  writeAuditlogEvent: t
}) => {
  const {
    action: o,
    show: i,
    setShow: r
  } = vt({
    isEmpty: !1,
    onShow: () => {
      t?.({
        type: Ne.WIFI_R_QR_SHOW
      });
    }
  }), s = M(() => [o], [o]), {
    ref: a,
    inlineUi: c
  } = pe(s), d = nf(e.values.wifiSsid ?? "", e.values.password);
  return !e.values.wifiSsid || !e.values.password ? null : /* @__PURE__ */ n(Y, { children: i ? /* @__PURE__ */ n(sf, { data: d, inlineUi: c }) : /* @__PURE__ */ n(St, { inlineUi: c, ref: a, onButtonClick: () => r(!0), changed: !1, children: /* @__PURE__ */ n(f, { id: "xCM_Cn" }) }) });
}), af = he(["wifiSsid"])(({
  formik: e,
  writeToClipboard: t,
  readOnly: o
}) => {
  const {
    action: i
  } = fe(t, e.values.wifiSsid), {
    ref: r,
    inlineUi: s
  } = pe([i]);
  return o && !e.values.wifiSsid ? null : /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(se, { element: {
      type: "input",
      props: {
        type: "text",
        ...e.getFieldProps("wifiSsid"),
        readOnly: o,
        ref: r,
        autoComplete: "off",
        autoCapitalize: "off",
        autoCorrect: "off"
      }
    }, label: u._(
      /** i18n */
      {
        id: "MKYFuo"
      }
    ), error: e.touched.wifiSsid ? e.errors.wifiSsid : void 0, inlineUi: s, isSubmitting: e.isSubmitting }) }),
    /* @__PURE__ */ n(oo, { anchor: "wifiSsid" })
  ] });
});
function pn(e) {
  const [t] = R(() => Vi(e.passwordPolicy ? Zn(e.passwordPolicy) : e.passwordGeneratorSettings)), o = M(() => {
    const {
      initialLogin: W,
      auditlogInfo: j
    } = mf(e), V = W?.uiType ?? e.initialUiType ?? ce.login, J = V === ce.login && !e.login ? t : "", G = {
      uiType: V,
      title: "",
      username: "",
      password: J,
      note: "",
      customFields: [],
      websites: [],
      totp: "",
      ...W
    };
    return {
      formValues: G,
      auditlogInfo: j
    };
  }, [t, e]), [i, r] = R(o.formValues), s = D(o.auditlogInfo);
  k(() => {
    !we(s.current, o.auditlogInfo) && we(i, o.formValues) && (s.current = o.auditlogInfo);
  }, [i, o.auditlogInfo, o.formValues]);
  const a = B((W) => {
    W({
      values: o.formValues
    }), s.current = o.auditlogInfo;
  }, [o]), [c, d] = R(!1), l = D(), p = D(), {
    writeAuditlogEvent: _
  } = e, h = M(() => _ ? (W) => {
    _({
      ...W,
      ...s.current
    });
  } : void 0, [_]), {
    leakedPasswordCheckStatus: g,
    updateLeakedPasswordCheck: w,
    updateLeakedPasswordCheckWithResult: b,
    enqueueUpdateLeakedPasswordCheck: y
  } = vu({
    initialLeakedPasswordCheckStatus: e.initialLeakedPasswordCheckStatus,
    updateEnabled: !e.disableLoginStatus && (e.newLogin || e.permissions.editLogin),
    getLeakedPasswordData: e.getLeakedPasswordData
  }), {
    passwordQualityCheckStatus: v,
    updatePasswordQualityCheck: S,
    updatePasswordQualityCheckWithResult: I
  } = Xi({
    policy: e.passwordPolicy,
    initialPassword: i.password
  }), E = B((W) => {
    w(W), S(W);
  }, [w, S]), A = B((W) => {
    y(W), S(W);
  }, [y, S]), [N, P] = R(e.initialPasswordOrigin?.type === "generator" || i.password === t), L = D();
  k(() => () => L.current?.cancel(), []);
  const [F, O] = R();
  return /* @__PURE__ */ n(Ni, { initialValues: i, onSubmit: async (W, j) => {
    const V = await ff(W, e.elsterValidator);
    if (!V.success) {
      O(V.error);
      return;
    }
    O(void 0);
    const {
      normalizedValues: J,
      newFocusedWebsiteValue: G
    } = ir({
      values: {
        ...W,
        elsterCertificate: V.elsterCertificate
      },
      focusedWebsiteInput: p.current,
      focusedScopeEntryInput: l.current
    });
    if (p.current && G !== void 0 && (p.current.oldNormalizedValue = G), e.onSave) {
      L.current?.cancel(), L.current = new hi();
      try {
        await e.onSave(J, N, await b(J.password), I(J.password), L.current);
      } catch (oe) {
        if (!(oe instanceof We))
          throw oe;
      }
    }
    j.resetForm({
      values: J
    }), r(J), d(!0);
  }, children: (W) => /* @__PURE__ */ n(lf, { outerProps: e, formik: W, formValuesFromRepo: o.formValues, focusedScopeEntryInputRef: l, focusedWebsiteInputRef: p, initialGeneratedPassword: t, resetToRepoState: a, writeAuditlogEventForLogin: h, leakedPasswordCheckStatus: g, updateLoginStatusPasswordChecks: E, enqueueUpdateLoginStatusPasswordChecks: A, passwordQualityCheckStatus: v, passwordIsGenerated: N, setPasswordIsGenerated: P, initialPassword: i.password, saveSuccess: c, setSaveSuccess: d, elsterError: F, setElsterError: O }) });
}
function lf({
  outerProps: {
    availableAndroidApps: e,
    blockNavigation: t,
    confirmDelete: o,
    disabled: i,
    login: r,
    loginId: s,
    newLogin: a,
    onDelete: c,
    onTagClick: d,
    passwordGeneratorSettings: l,
    preFormChildren: p,
    savePasswordGeneratorSettings: _,
    showSavedSuccess: h,
    tagSuggestions: g,
    usernameSuggestions: w,
    writeToClipboard: b,
    movedLoginInfo: y,
    initialUiType: v,
    permissions: S,
    showTotpTimeOffsetWarning: I,
    checkTotpTimeOffset: E,
    editProfileEmail: A,
    creationProfileEmail: N,
    additionalActions: P,
    isLoginTrashable: L,
    duplicate: F,
    goToLogin: O,
    initialPasswordOrigin: W,
    passwordPolicy: j,
    enableScopeCreationBetaUi: V,
    disableLoginStatus: J,
    onSaveSuccess: G,
    openShareModal: oe,
    canLinkLogin: H,
    handleSubmitError: q,
    importInfoLink: be,
    showSaveShortcutHint: ee,
    elsterValidator: Oe,
    useSafeArea: dt
  },
  formik: x,
  formValuesFromRepo: ie,
  focusedScopeEntryInputRef: Le,
  focusedWebsiteInputRef: st,
  initialGeneratedPassword: qe,
  resetToRepoState: co,
  writeAuditlogEventForLogin: At,
  leakedPasswordCheckStatus: ao,
  updateLoginStatusPasswordChecks: fr,
  enqueueUpdateLoginStatusPasswordChecks: gr,
  passwordQualityCheckStatus: yr,
  passwordIsGenerated: lo,
  setPasswordIsGenerated: Cr,
  initialPassword: wr,
  saveSuccess: uo,
  setSaveSuccess: po,
  elsterError: bn,
  setElsterError: _o
}) {
  const br = X(), Q = S ?? Ls, [ut, Kt] = R(), {
    changeCount: ho,
    hasChanges: je
  } = _f(x, qe, ut);
  k(() => {
    S && !S.editLogin && je && x.resetForm();
  }, [S, x, je]);
  const {
    setDisableNavigationConfirm: vn,
    willBlockNavigation: mo
  } = df({
    formik: x,
    requireNavigationConfirm: je,
    blockNavigation: t,
    openInlineDialog: ut,
    setOpenInlineDialog: Kt
  });
  k(() => {
    uo && G && !mo && (Promise.resolve(G()).catch($), po(!1));
  }, [G, uo, vn, po, mo]);
  const fo = D(ie);
  k(() => {
    // the form has not been touched
    !je && // form values form repo have changed
    !we(fo.current, ie) && // initial values have not yet changed with them
    !we(x.initialValues, ie) && co(x.resetForm), fo.current = ie;
  }, [ie, x, je, co]), pf(x, je, s);
  const vr = uf(je, x.isSubmitting), [Sn, go] = R(!1);
  k(() => {
    if (Sn) {
      const le = window.setTimeout(() => {
        go(!1);
      }, 1500);
      return () => window.clearTimeout(le);
    }
  }, [Sn]);
  const yo = h || Sn, [Co, Sr] = R(!1), Lt = i || !Q.editLogin || x.isSubmitting || ut !== void 0 || y !== void 0 || Co || bn !== void 0, In = M(() => mi() ? "command" : "ctrl", []);
  oa([`${In}+s`, `${In}+enter`], (le) => {
    le.preventDefault(), !Lt && Uo(x, q);
  }, {
    global: !0,
    deps: [x, Lt]
  });
  const {
    uiType: pt
  } = x.values, {
    nonEmptyFields: Nn,
    resetNonEmptyFields: An,
    resetNonEmptyField: Ln
  } = fp(x.values), Ir = Ip(x.values), Nr = gp({
    passwordIsGenerated: lo,
    password: x.values.password,
    initialPassword: wr,
    initialPasswordOrigin: W
  }), Pt = M(() => e && Object.fromEntries(e.map((le) => [le.appId, le])), [e]), ae = Km(Ln), [Ar, Lr] = R(), wo = M(() => Ps(x.values), [x.values]), ne = tf({
    uiType: pt,
    nonEmptyFields: Nn,
    optionalFields: ae,
    permissions: Q,
    enableScopeCreationBetaUi: !!V,
    disableLoginStatus: !!J,
    hasImplicitWebsites: wo.length > 0,
    hasPasskey: !!x.values.passkey
  }), Pr = M(() => ({
    resolved: Dp({
      availableAnchors: Op(ne),
      applicableButtons: Wp(ne, {
        uiType: pt,
        permissions: Q,
        enableScopeCreationBetaUi: !!V,
        hasAvailableAndroidApps: !!Pt
      })
    }),
    disabled: x.isSubmitting,
    add: (le) => ae.add(kp(le))
  }), [Pt, V, x.isSubmitting, ae, Q, ne, pt]), {
    add: bo,
    clearAutoFocus: Ge,
    remove: Ke
  } = ae, Rr = B(() => Ge("totp"), [Ge]), Br = B(() => Ke("totp"), [Ke]), Tr = B(() => Ge("scope"), [Ge]), Er = B(() => Ge("websites"), [Ge]), $r = B(() => Ge("androidApps"), [Ge]), xr = B(() => Ke("scope"), [Ke]), Mr = B(() => Ke("websites"), [Ke]), Fr = B(() => Ke("androidApps"), [Ke]), kr = B((le) => {
    Lr(le), bo("scope");
  }, [bo]), vo = pt === ce.login && !!V, Wr = M(() => {
    if (c)
      return async () => {
        c && (!L && o && !await o() || (vn(!0), await c()));
      };
  }, [o, L, c, vn]), Or = B(() => {
    const le = {
      id: Ai(),
      name: "",
      protected: !1,
      value: "",
      multiline: !1,
      autofill: {
        enabled: !1,
        fieldIdOrName: ""
      }
    };
    x.setFieldValue("customFields", [...x.values.customFields, le]).catch($), Kt({
      type: "customFieldSettings",
      id: le.id,
      isNewField: !0
    });
  }, [x]);
  return /* @__PURE__ */ n($p, { value: Pr, children: /* @__PURE__ */ m("section", { className: C(de.LoginEdit, {
    [de.darkMode]: br === "dark",
    [de.movedLogin]: y,
    [de.useSafeArea]: dt
  }), children: [
    y && /* @__PURE__ */ n(rp, { loginLabel: r ? gi(r, {
      noScopeEntryCount: !0
    }).headline : zr(v), className: de.MovedLoginHint, movedLoginInfo: y }),
    /* @__PURE__ */ m("form", { className: de.Main, onSubmit: (le) => {
      Lt ? le.preventDefault() : !je && !a ? (go(!0), An(), le.preventDefault()) : (Uo(x, q, le), An());
    }, autoComplete: "off", children: [
      /* @__PURE__ */ n("div", { className: de.Preform, children: p }),
      Q.editLogin && /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(cm, { formik: x, initialGeneratedPassword: qe, newLogin: a, resetNonEmptyFields: An, resetNonEmptyField: Ln, openShareModal: oe, canLinkLogin: H, permissions: Q, isNewLogin: a, addCustomField: Or, isLinkedLogin: !!r?.linkedFrom, isLoginTrashable: !!L, deleteLogin: Wr, duplicateLogin: F, goToLogin: O, additionalActions: P, addCustomFieldDisabled: !!ut }) }),
      r && /* @__PURE__ */ n(mm, { login: r }),
      ne.displayHeadline && /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(J_, { formik: x, readOnly: !Q.editLogin, autoFocus: ae.autoFocused === "displayHeadline", clearAutoFocus: () => ae.clearAutoFocus("displayHeadline"), deleteDisplayHeadline: dr(pt) ? void 0 : async () => {
        await x.setFieldValue("displayHeadline", void 0), ae.remove("displayHeadline");
      } }) }),
      /* @__PURE__ */ m(xe, { children: [
        ne.implicitWebsites && /* @__PURE__ */ n(Bh, { implicitWebsites: wo, writeToClipboard: b, addEntryButtons: (
          // The scope is not laid out while these websites stand in for it, so the kind of
          // entry to start it with is picked here rather than from the scope itself.
          vo && Q.editLogin && !ne.scope ? /* @__PURE__ */ n(lr, { availableAndroidAppsById: Pt, addEntry: kr }) : void 0
        ) }),
        ne.scope && /* @__PURE__ */ n(_m, { formik: x, availableAndroidAppsById: Pt, focusedScopeEntryInputRef: Le, readOnly: !Q.editLogin, writeToClipboard: b, allowAdd: vo, newEntryPlaceholder: Ar, autoFocusNewEntry: ae.autoFocused === "scope", clearNewEntryAutoFocus: Tr, removeField: ne.implicitWebsites ? xr : void 0 }),
        ne.androidApps && /* @__PURE__ */ n(qp, { formik: x, availableAndroidAppsById: Pt, readOnly: !Q.editLogin, autoFocusNewEntry: ae.autoFocused === "androidApps", clearNewEntryAutoFocus: $r, removeField: ne.implicitWebsites ? Fr : void 0 }),
        ne.websites && /* @__PURE__ */ n(Lh, { formik: x, writeToClipboard: b, readOnly: !Q.editLogin, focusedWebsiteInputRef: st, allowAdd: pt === ce.login, enableExeDetection: !0, autoFocusNewEntry: ae.autoFocused === "websites", clearNewEntryAutoFocus: Er, removeField: ne.implicitWebsites ? Mr : void 0 })
      ] }),
      ne.elsterCertificate && /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(yh, { formik: x, elsterValidator: Oe, elsterError: bn, setElsterError: _o, permissions: Q }) }),
      /* @__PURE__ */ m(xe, { children: [
        ne.wifiSsid && /* @__PURE__ */ n(af, { formik: x, readOnly: !Q.editLogin, writeToClipboard: b }),
        ne.title && /* @__PURE__ */ n(Q_, { formik: x, readOnly: !Q.editLogin, autoFocus: ae.autoFocused === "title", clearAutoFocus: () => ae.clearAutoFocus("title"), deleteDisplayName: async () => {
          await x.setFieldValue("title", ""), ae.remove("title");
        } }),
        ne.username && /* @__PURE__ */ n(ef, { formik: x, writeToClipboard: b, readOnly: !Q.editLogin, usernameSuggestions: w }),
        ne.passkey && x.values.passkey && r && /* @__PURE__ */ m(T, { children: [
          /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(mp, { passkey: x.values.passkey, creationTime: r.creationTime }) }),
          /* @__PURE__ */ n(oo, { anchor: "passkey" })
        ] }),
        ne.password && /* @__PURE__ */ n(pm, { formik: x, openInlineDialog: ut, setOpenInlineDialog: Kt, newLogin: a, writeToClipboard: b, savePasswordGeneratorSettings: _, passwordGeneratorSettings: l, writeAuditlogEvent: At, leakedPasswordCheckStatus: ao, updateLoginStatusPasswordChecks: fr, enqueueUpdateLoginStatusPasswordChecks: gr, permissions: Q, passwordIsGenerated: lo, setPasswordIsGenerated: Cr, passwordPolicy: j, elsterError: bn, setElsterError: _o, autoFocus: ae.autoFocused === "password", clearAutoFocus: () => ae.clearAutoFocus("password"), deletePassword: x.values.passkey ? async () => {
          await x.setFieldValue("password", ""), ae.remove("password"), Ln("password");
        } : void 0 }),
        ne.totp && /* @__PURE__ */ n(Gm, { formik: x, permissions: Q, writeToClipboard: b, showTotpTimeOffsetWarning: I, checkTotpTimeOffset: E, writeAuditlogEvent: At, autoFocus: ae.autoFocused === "totp", clearAutoFocus: Rr, deleteTotp: Br }),
        ne.wifiQrCode && /* @__PURE__ */ n(cf, { formik: x, writeAuditlogEvent: At }),
        ne.loginStatus && /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(Xu, { leakedPasswordCheckStatus: ao, passwordQualityCheckStatus: yr, totpAvailableCheckStatus: Ir, passwordOrigin: Nr, hidePasswordStatus: !ne.password }) })
      ] }),
      /* @__PURE__ */ n(a_, { writeAuditlogEvent: At, formik: x, readOnly: !Q.editLogin, hideSecrets: !Q.viewSecrets, writeToClipboard: b, nonEmptyFields: Nn.creditCard ? Nn.creditCard : {} }),
      /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(K_, { formik: x, writeToClipboard: b, readOnly: !Q.editLogin, hideSecrets: !Q.viewSecrets, savePasswordGeneratorSettings: _, passwordGeneratorSettings: l, openInlineDialog: ut, setOpenInlineDialog: Kt, writeAuditlogEvent: At, passwordPolicy: j }) }),
      (Q.editLogin || !!x.values.tags?.length) && /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(Dm, { formik: x, readOnly: !Q.editLogin, tagSuggestions: g, onTagClick: d, showTagInput: Co, setShowTagInput: Sr }) }),
      /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(um, { formik: x, readOnly: !Q.editLogin }) }),
      Q.editLogin && /* @__PURE__ */ m("fieldset", { className: de.SubmitContainer, children: [
        /* @__PURE__ */ n(Ot, { className: de.UnsavedChangesWarning, hidden: !vr, type: "warning", children: /* @__PURE__ */ n(f, { id: "QNFK92", components: {
          0: /* @__PURE__ */ n(it, { type: "submit", disabled: Lt })
        } }) }),
        /* @__PURE__ */ m(Qa, { type: "submit", className: C(de.SubmitButton, {
          [de.saved]: yo
        }), disabled: Lt, children: [
          yo ? /* @__PURE__ */ m(T, { children: [
            /* @__PURE__ */ n(js, { className: de.SavedSuccessIcon }),
            /* @__PURE__ */ n("span", { children: /* @__PURE__ */ n(f, { id: "OFqAkw" }) })
          ] }) : x.isSubmitting ? /* @__PURE__ */ n("span", { children: /* @__PURE__ */ n(f, { id: "uF9ruK" }) }) : /* @__PURE__ */ n("span", { children: a ? /* @__PURE__ */ n(T, { children: /* @__PURE__ */ n(f, { id: "u5eWCX" }) }) : ho ? /* @__PURE__ */ n(f, { id: "mwMktx", values: {
            changeCount: ho
          } }) : /* @__PURE__ */ n(f, { id: "tfDRzk" }) }),
          ee && /* @__PURE__ */ n(_u, { className: de.ShortcutHint, label: `${In === "command" ? "⌘" : u._(
            /** i18n */
            {
              id: "F5QOVM"
            }
          )} S`, lightBackground: !0 })
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: C(de.FormGroup, de.Info), children: [
        r?.creationTime && !r.importInfo && /* @__PURE__ */ m("p", { children: [
          /* @__PURE__ */ n(f, { id: "t3sqJR", values: {
            0: Rt(new Date(r.creationTime), "PPPp", {
              locale: Ve()
            })
          } }),
          N && /* @__PURE__ */ m(T, { children: [
            " ",
            /* @__PURE__ */ n(f, { id: "NamUYY", values: {
              creationProfileEmail: N
            } })
          ] })
        ] }),
        r?.importInfo && /* @__PURE__ */ m(T, { children: [
          r.creationTime && r.creationTime !== r.importInfo.importTime && /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "t3sqJR", values: {
            0: Rt(new Date(r.creationTime), "PPPp", {
              locale: Ve()
            })
          } }) }),
          /* @__PURE__ */ m("p", { children: [
            be ? /* @__PURE__ */ n(f, { id: "dr4b7w", values: {
              0: Rt(new Date(r.importInfo.importTime), "PPPp", {
                locale: Ve()
              })
            }, components: {
              0: /* @__PURE__ */ n(qi, { element: et, to: be, className: de.ImportLink })
            } }) : /* @__PURE__ */ n(f, { id: "5WzHv2", values: {
              0: Rt(new Date(r.importInfo.importTime), "PPPp", {
                locale: Ve()
              })
            } }),
            N && /* @__PURE__ */ m(T, { children: [
              " ",
              /* @__PURE__ */ n(f, { id: "NamUYY", values: {
                creationProfileEmail: N
              } })
            ] })
          ] })
        ] }),
        r?.editTime && /* @__PURE__ */ m("p", { children: [
          /* @__PURE__ */ n(f, { id: "Lr4lJo", values: {
            0: Rt(new Date(r.editTime), "PPPp", {
              locale: Ve()
            })
          } }),
          A && /* @__PURE__ */ m(T, { children: [
            " ",
            /* @__PURE__ */ n(f, { id: "nmimYO", values: {
              editProfileEmail: A
            } })
          ] })
        ] }),
        /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "xkWEmO" }) }),
        /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "odnPUt", components: {
          0: /* @__PURE__ */ n(Ae, { href: "https://2fa.directory/" })
        } }) })
      ] })
    ] })
  ] }) });
}
function xe({
  children: e,
  className: t,
  ...o
}) {
  return ke.Children.toArray(e).some((r) => ke.isValidElement(r)) ? /* @__PURE__ */ n("fieldset", { className: C(de.FormGroup, t), ...o, children: e }) : null;
}
function df({
  formik: e,
  requireNavigationConfirm: t,
  blockNavigation: o,
  openInlineDialog: i,
  setOpenInlineDialog: r
}) {
  const [s, a] = R(!1), c = t || e.isSubmitting || i !== void 0, d = !s && c && !!o;
  return k(() => {
    if (d) {
      const {
        unblock: l
      } = o({
        resetCurrentPage: () => {
          e.resetForm(), r(void 0);
        }
      });
      return l;
    }
  }, [o, s, e, i, t, r, c, d]), {
    setDisableNavigationConfirm: a,
    willBlockNavigation: d
  };
}
function uf(e, t) {
  const [o, i] = R(!1);
  return k(() => {
    if (!e) {
      i(!1);
      return;
    }
    if (t)
      return;
    const r = window.setTimeout(() => {
      i(!0);
    }, 1e4);
    return () => window.clearTimeout(r);
  }, [e, t]), o;
}
function pf(e, t, o) {
  const {
    setOpenLogin: i
  } = Mi(), r = D(e);
  r.current = e;
  const s = B(async () => {
    await r.current.submitForm();
  }, []);
  k(() => {
    if (!o) {
      i(void 0);
      return;
    }
    return i({
      id: o,
      dirty: t,
      save: s
    }), () => i(void 0);
  }, [t, o, i, s]);
}
function _f(e, t, o) {
  const [i, r] = R({
    count: 0,
    stale: !1
  }), s = M(() => mn(200, (...d) => {
    r({
      count: hf(...d),
      stale: !1
    });
  }), []), a = D();
  k(() => {
    const d = a.current;
    a.current = e, !(we(d?.values, e.values) && we(d?.initialValues, e.initialValues) && d?.dirty === e.dirty) && (r((l) => l.stale ? l : {
      ...l,
      stale: !0
    }), s(e.initialValues, e.values, e.dirty, t, o));
  }, [e, t, o, s]);
  const c = (
    // If formik reports non-dirty old and new values are exactly equal, no need to check any
    // further
    e.dirty ? i.stale ? !0 : i.count > 0 : !1
  );
  return {
    changeCount: i.count,
    hasChanges: c
  };
}
function hf(e, t, o, i, r) {
  if (!o)
    return 0;
  const {
    normalizedValues: s
  } = ir({
    values: t,
    focusedWebsiteInput: void 0,
    focusedScopeEntryInput: void 0,
    allowElsterCertificatePlaceholder: !0
  });
  return Zt(e, s, {
    ignoreKeys: ["websiteAttributes"],
    customGetDifferenceCount: {
      // recurse into credit card
      creditCard: (a, c) => a === void 0 || c === void 0 ? a === void 0 && c === void 0 ? 0 : 1 : Zt(a, c, {
        ignoreKeys: ["displayMaskedNumber", "displayType"]
      }),
      // switching between initial pw and "" is not considered a change
      password: (a, c) => a === c || a === "" && c === i || a === i && c === "" ? 0 : 1,
      // Empty totp can be represented by `undefined` or by empty string depending on the age of the
      // login. We now always normalized to `undefined` but that was not always the case.
      totp: (a, c) => a === c || a === "" && c === void 0 || a === void 0 && c === "" ? 0 : 1,
      customFields: (a, c) => r?.type === "customFieldSettings" && r.isNewField ? Zt(a.filter(({
        id: d
      }) => d !== r.id), c.filter(({
        id: d
      }) => d !== r.id)) : Zt(a, c)
    }
  });
}
function mf(e) {
  if (e.login) {
    const {
      creationTime: t,
      editTime: o,
      linkedFrom: i,
      linkedTo: r,
      history: s,
      shareLinks: a,
      shareSecrets: c,
      sender: d,
      pendingInboxConfirmation: l,
      creationProfileId: p,
      editProfileId: _,
      linkedViewSecrets: h,
      creationSource: g,
      editSource: w,
      archiveInfo: b,
      changeTime: y,
      loginSummaryVersion: v,
      importInfo: S,
      ...I
    } = e.login, E = e.overrideAuditlogInfo ?? {
      loginEditTime: o,
      loginRevisionId: s?.currentRevisionId,
      loginId: e.loginId
    };
    return {
      initialLogin: I,
      auditlogInfo: E
    };
  }
  return {
    initialLogin: e.initialValues,
    auditlogInfo: void 0
  };
}
async function ff(e, t) {
  return e.uiType === ce.elsterCertificate && !e.elsterCertificate ? {
    success: !1,
    error: "certificateFileNotUploaded"
  } : e.elsterCertificate?.isPlaceholder ? await t.getElsterCertificateFromFile(e.elsterCertificate.file, e.password) : e.elsterCertificate ? await t.validateElsterCertificate(e.elsterCertificate, e.password) : {
    success: !0,
    elsterCertificate: e.elsterCertificate
  };
}
function ci({
  uiType: e,
  permissions: t,
  usePronoun: o
}) {
  return ur(t) ? e === ce.creditCard ? o ? u._(
    /** i18n */
    {
      id: "2rz_ET"
    }
  ) : u._(
    /** i18n */
    {
      id: "KBRW1Z"
    }
  ) : e === ce.wifi ? o ? u._(
    /** i18n */
    {
      id: "Y1K7WH"
    }
  ) : u._(
    /** i18n */
    {
      id: "2_EdO2"
    }
  ) : e === ce.login ? t.useLogin && !t.viewSecrets ? /* @__PURE__ */ m(T, { children: [
    o ? /* @__PURE__ */ n(f, { id: "9RYLny" }) : /* @__PURE__ */ n(f, { id: "M3SiiC" }),
    " ",
    /* @__PURE__ */ n(Ae, { href: u._(
      /** i18n */
      {
        id: "7kmpgW"
      }
    ), children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) })
  ] }) : o ? u._(
    /** i18n */
    {
      id: "mJdpuD"
    }
  ) : u._(
    /** i18n */
    {
      id: "ntxE_T"
    }
  ) : e === ce.note ? o ? u._(
    /** i18n */
    {
      id: "7uotGR"
    }
  ) : u._(
    /** i18n */
    {
      id: "U7HgqM"
    }
  ) : e === ce.elsterCertificate ? t.useLogin && !t.viewSecrets ? /* @__PURE__ */ m(T, { children: [
    o ? /* @__PURE__ */ n(f, { id: "Ap1liZ" }) : /* @__PURE__ */ n(f, { id: "j4O_RR" }),
    " ",
    /* @__PURE__ */ n(Ae, { href: u._(
      /** i18n */
      {
        id: "7kmpgW"
      }
    ), children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) })
  ] }) : o ? u._(
    /** i18n */
    {
      id: "ulwAW4"
    }
  ) : u._(
    /** i18n */
    {
      id: "aTX2HV"
    }
  ) : z(e) : null;
}
function ur(e) {
  return !e.editLogin;
}
const gf = "_LoginPermissionHintBox_1hw0b_1", yf = "_LinkedFromIconWrapper_1hw0b_5", Cf = "_Icon_1hw0b_9", wf = "_Message_1hw0b_15", sn = {
  LoginPermissionHintBox: gf,
  LinkedFromIconWrapper: yf,
  Icon: Cf,
  Message: wf
};
function bf(e) {
  const t = vf(e);
  return t ? /* @__PURE__ */ n(no, { bodyClassName: sn.LoginPermissionHintBox, children: t }) : null;
}
function vf({
  permissions: e,
  uiType: t,
  foreignLoginPermissionTimeoutMs: o,
  vaultMetadata: i,
  linkedFromInfo: r,
  hideInternalLinks: s
}) {
  if (o)
    return Sf({
      uiType: t,
      foreignLoginPermissionTimeoutMs: o,
      vaultMetadata: i
    });
  if (r) {
    const a = If({
      uiType: t,
      linkedFromInfo: r,
      hideInternalLinks: s
    }), c = /* @__PURE__ */ n(ci, { uiType: t, permissions: e, usePronoun: !0 });
    return c ? /* @__PURE__ */ m(ai, { children: [
      a,
      " ",
      c
    ] }) : /* @__PURE__ */ n(ai, { children: a });
  }
  return ur(e) ? /* @__PURE__ */ n(ci, { uiType: t, permissions: e }) : null;
}
function ai({
  children: e
}) {
  return /* @__PURE__ */ m("div", { className: sn.LinkedFromIconWrapper, children: [
    /* @__PURE__ */ n(Ri, { className: sn.Icon }),
    /* @__PURE__ */ n("div", { className: sn.Message, children: e })
  ] });
}
function Sf({
  uiType: e,
  foreignLoginPermissionTimeoutMs: t,
  vaultMetadata: o
}) {
  const i = o.type === Ur.ORGANIZATION_PERSONAL && o.owner.email || u._(
    /** i18n */
    {
      id: "kWroQx"
    }
  ), r = Math.ceil(t / 6e4);
  return e === ce.creditCard ? u._(
    /** i18n */
    {
      id: "T9CzYt",
      values: {
        remainingMinutes: r,
        ownerEmail: i
      }
    }
  ) : u._(
    /** i18n */
    {
      id: "KoxsxA",
      values: {
        remainingMinutes: r,
        ownerEmail: i
      }
    }
  );
}
function If({
  uiType: e,
  linkedFromInfo: t,
  hideInternalLinks: o
}) {
  if (e === ce.creditCard) {
    if (t.type === "profile") {
      const i = t.originProfileEmail ?? t.linkedByEmail;
      return i ? u._(
        /** i18n */
        {
          id: "xdufSh",
          values: {
            originEmail: i
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "JWTc8Z"
        }
      );
    }
    if (t.type === "vault") {
      if (t.originLoginLink && t.originVaultName) {
        const i = o ? t.originVaultName : /* @__PURE__ */ n(et, { to: t.originLoginLink, children: t.originVaultName });
        return /* @__PURE__ */ n(f, { id: "RCxO9Q", values: {
          link: i
        } });
      }
      if (t.linkedByEmail) {
        const {
          linkedByEmail: i
        } = t;
        return u._(
          /** i18n */
          {
            id: "2vXxVm",
            values: {
              linkedByEmail: i
            }
          }
        );
      }
      return u._(
        /** i18n */
        {
          id: "HoCMO6"
        }
      );
    }
    return z(t);
  }
  if (e === ce.wifi) {
    if (t.type === "profile") {
      const i = t.originProfileEmail ?? t.linkedByEmail;
      return i ? u._(
        /** i18n */
        {
          id: "rrI5TL",
          values: {
            originEmail: i
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "v6om1b"
        }
      );
    }
    if (t.type === "vault") {
      if (t.originLoginLink && t.originVaultName) {
        const i = o ? t.originVaultName : /* @__PURE__ */ n(et, { to: t.originLoginLink, children: t.originVaultName });
        return /* @__PURE__ */ n(f, { id: "GjEgu9", values: {
          link: i
        } });
      }
      if (t.linkedByEmail) {
        const {
          linkedByEmail: i
        } = t;
        return u._(
          /** i18n */
          {
            id: "QUNzLd",
            values: {
              linkedByEmail: i
            }
          }
        );
      }
      return u._(
        /** i18n */
        {
          id: "26mpgy"
        }
      );
    }
    return z(t);
  }
  if (e === ce.login) {
    if (t.type === "profile") {
      const i = t.originProfileEmail ?? t.linkedByEmail;
      return i ? u._(
        /** i18n */
        {
          id: "0lXBAq",
          values: {
            originEmail: i
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "OXhtqX"
        }
      );
    }
    if (t.type === "vault") {
      if (t.originLoginLink && t.originVaultName) {
        const i = o ? t.originVaultName : /* @__PURE__ */ n(et, { to: t.originLoginLink, children: t.originVaultName });
        return /* @__PURE__ */ n(f, { id: "sQ0SXs", values: {
          link: i
        } });
      }
      if (t.linkedByEmail) {
        const {
          linkedByEmail: i
        } = t;
        return u._(
          /** i18n */
          {
            id: "QAuBJT",
            values: {
              linkedByEmail: i
            }
          }
        );
      }
      return u._(
        /** i18n */
        {
          id: "thM6gj"
        }
      );
    }
    return z(t);
  }
  if (e === ce.note) {
    if (t.type === "profile") {
      const i = t.originProfileEmail ?? t.linkedByEmail;
      return i ? u._(
        /** i18n */
        {
          id: "RzvhXF",
          values: {
            originEmail: i
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "UMBnwA"
        }
      );
    }
    if (t.type === "vault") {
      if (t.originLoginLink && t.originVaultName) {
        const i = o ? t.originVaultName : /* @__PURE__ */ n(et, { to: t.originLoginLink, children: t.originVaultName });
        return /* @__PURE__ */ n(f, { id: "a9Vkxt", values: {
          link: i
        } });
      }
      if (t.linkedByEmail) {
        const {
          linkedByEmail: i
        } = t;
        return u._(
          /** i18n */
          {
            id: "S_ZmvX",
            values: {
              linkedByEmail: i
            }
          }
        );
      }
      return u._(
        /** i18n */
        {
          id: "lr_OH6"
        }
      );
    }
    return z(t);
  }
  if (e === ce.elsterCertificate) {
    if (t.type === "profile") {
      const i = t.originProfileEmail ?? t.linkedByEmail;
      return i ? u._(
        /** i18n */
        {
          id: "s2qgba",
          values: {
            originEmail: i
          }
        }
      ) : u._(
        /** i18n */
        {
          id: "rCtXSw"
        }
      );
    }
    if (t.type === "vault") {
      if (t.originLoginLink && t.originVaultName) {
        const i = o ? t.originVaultName : /* @__PURE__ */ n(et, { to: t.originLoginLink, children: t.originVaultName });
        return /* @__PURE__ */ n(f, { id: "_16fO_", values: {
          link: i
        } });
      }
      if (t.linkedByEmail) {
        const {
          linkedByEmail: i
        } = t;
        return u._(
          /** i18n */
          {
            id: "H2vcjB",
            values: {
              linkedByEmail: i
            }
          }
        );
      }
      return u._(
        /** i18n */
        {
          id: "rTieLO"
        }
      );
    }
    return z(t);
  }
  return z(e);
}
const Nf = "_CircularIcon_qpgqf_1", Af = "_small_qpgqf_13", Lf = "_fullBleedImage_qpgqf_17", Pf = "_centerImage_qpgqf_53", gt = {
  CircularIcon: Nf,
  small: Af,
  fullBleedImage: Lf,
  centerImage: Pf
};
function Rf({
  icon: e,
  small: t,
  className: o,
  size: i,
  centerImage: r
}) {
  return typeof e == "string" ? /* @__PURE__ */ n("div", { className: C(gt.CircularIcon, {
    [gt.fullBleedImage]: !r,
    [gt.centerImage]: r,
    [gt.small]: t
  }, o), style: {
    // @ts-ignore
    "--size": i
  }, children: /* @__PURE__ */ n("img", { src: e, alt: "" }) }) : /* @__PURE__ */ n(e, { className: C(gt.CircularIcon, {
    [gt.small]: t
  }, o), style: {
    // @ts-ignore
    "--size": i
  } });
}
const Bf = "_Wrapper_1ty5h_1", Tf = "_Description_1ty5h_8", Ef = "_TeamName_1ty5h_13", xn = {
  Wrapper: Bf,
  Description: Tf,
  TeamName: Ef
};
function $f({
  vaultMetadata: e,
  organizationMetadata: t
}) {
  const o = qr(e);
  return /* @__PURE__ */ m(no, { bodyClassName: xn.Wrapper, children: [
    /* @__PURE__ */ n(Rf, { icon: t ? t.icon ? t.icon : xc : e.type === Rs.PRIVATE ? $c : Mc, size: "3rem" }),
    /* @__PURE__ */ m("div", { className: xn.Description, children: [
      /* @__PURE__ */ n("div", { className: xn.TeamName, children: o }),
      t && /* @__PURE__ */ n("div", { children: t.name })
    ] })
  ] });
}
function Rb({
  add: e,
  isLocked: t,
  login: o,
  modify: i,
  remove: r,
  unprotect: s,
  confirmInboxLogin: a,
  vaultMetadata: c,
  organizationMetadata: d,
  preFormChildren: l,
  showTeamInfo: p,
  permissions: _,
  foreignLoginPermissionTimeoutMs: h,
  linkedFromInfo: g,
  initialValues: w,
  hideInternalLinks: b,
  movedLoginInfo: y,
  ...v
}) {
  const {
    loginId: S,
    goToLogin: I
  } = v, [E, A] = R();
  k(() => {
    if (E) {
      const W = window.setTimeout(() => {
        A(void 0);
      }, 1500);
      return () => window.clearTimeout(W);
    }
  }, [E]);
  const N = E !== void 0 && S === E, P = D(), L = B(async (W, j, V, J, G) => {
    const oe = pr(void 0, W), H = _r(void 0, oe, V, J, j), q = await e(H, G);
    A(q), P.current = q;
  }, [e]), F = B(async () => {
    P.current && I(P.current);
  }, [I]), O = /* @__PURE__ */ m(T, { children: [
    S && a && o && /* @__PURE__ */ m(Ot, { type: "success", onClose: () => a(c.id, S), hidden: !o.pendingInboxConfirmation, children: [
      /* @__PURE__ */ n(f, { id: "c_nFq0", values: {
        0: ln(new Date(o.editTime), "PPP", {
          locale: Ve()
        })
      } }),
      " ",
      /* @__PURE__ */ n(it, { type: "button", onClick: () => a(c.id, S), children: /* @__PURE__ */ n(f, { id: "76gPWk" }) })
    ] }),
    _ && /* @__PURE__ */ n(bf, { vaultMetadata: c, permissions: _, uiType: Fe(o.uiType), foreignLoginPermissionTimeoutMs: h, linkedFromInfo: g, hideInternalLinks: b }),
    p && /* @__PURE__ */ n($f, { vaultMetadata: c, organizationMetadata: d }),
    l
  ] });
  return o && S ? /* @__PURE__ */ n(xf, { ...v, isLocked: t, login: o, permissions: _, onSave: async (W, j) => {
    await i(S, W, j), A(S);
  }, onDelete: async () => r(S), preFormChildren: O, showSavedSuccess: N, unprotect: s, movedLoginInfo: y }) : /* @__PURE__ */ n(pn, { ...v, permissions: void 0, disabled: t, login: void 0, newLogin: !0, onDelete: void 0, onSave: L, onSaveSuccess: F, showSavedSuccess: N, preFormChildren: O, initialValues: w, initialLeakedPasswordCheckStatus: void 0, initialPasswordOrigin: void 0, movedLoginInfo: void 0 });
}
function xf({
  login: e,
  onSave: t,
  unprotect: o,
  isLocked: i,
  showSavedSuccess: r,
  permissions: s,
  movedLoginInfo: a,
  ...c
}) {
  const [d, l] = Mf(e, i, !!a, o), p = Fe(e.passwordOrigin);
  return l ? /* @__PURE__ */ No(pn, { ...c, permissions: s, key: `${c.loginId}dummy`, disabled: !0, login: li(d), newLogin: !1, onSave: async () => {
    throw new Error("Save while in dummy state");
  }, onDelete: async () => {
    throw new Error("Delete while in dummy state");
  }, onSaveSuccess: void 0, showSavedSuccess: r, initialLeakedPasswordCheckStatus: void 0, initialPasswordOrigin: void 0, movedLoginInfo: a, disableLoginStatus: !0 }) : /* @__PURE__ */ No(pn, { ...c, permissions: s, key: c.loginId, disabled: !1, login: li(d), newLogin: !1, onSave: (_, h, g, w, b) => {
    const y = pr(d, _), v = _r(d, y, g, w, h);
    return t ? t(v, b) : void 0;
  }, onSaveSuccess: void 0, showSavedSuccess: r, initialLeakedPasswordCheckStatus: d.password.contentId === d.leakedPasswordCheck?.checkedPasswordContentId && Fe(d.leakedPasswordCheck?.checkSkippedReason) === void 0 ? {
    status: "checked",
    leakCount: d.leakedPasswordCheck.leakCount,
    checkedAt: d.leakedPasswordCheck.checkedAt,
    password: d.password.unencrypted,
    leakedPasswordsChangeTime: d.leakedPasswordCheck.leakedPasswordsChangeTime
  } : void 0, initialPasswordOrigin: p?.passwordContentId === d.password.contentId ? p : void 0, movedLoginInfo: a });
}
function pr(e, t) {
  return Bs(e, t, (o) => o);
}
function li(e) {
  return Es(e, (t) => t.unencrypted);
}
function Mf(e, t, o, i) {
  return M(() => {
    const r = {
      ...e,
      history: e.history ? {
        ...e.history,
        revisions: {}
      } : void 0
    };
    if (t || o)
      return [Pn(r, () => ({
        contentId: "00000000-0000-0000-0000-000000000000",
        unencrypted: "********"
      })), !0];
    try {
      return [Pn(r, i), !1];
    } catch (s) {
      if (s instanceof Ts)
        return [Pn(r, () => ({
          contentId: "00000000-0000-0000-0000-000000000000",
          unencrypted: "********"
        })), !0];
      throw s;
    }
  }, [t, o, e, i]);
}
function _r(e, t, o, i, r) {
  return {
    ...t,
    leakedPasswordCheck: Ff(t, o),
    passwordPolicyCheck: kf(t, i),
    passwordOrigin: Of(e, t, r)
  };
}
function Ff(e, t) {
  if (t.status === "checked" && e.password.unencrypted === t.password)
    return {
      checkedAt: t.checkedAt,
      leakCount: t.leakCount,
      checkedPasswordContentId: e.password.contentId,
      leakedPasswordsChangeTime: t.leakedPasswordsChangeTime
    };
  if (t.status === "skipped" && e.password.unencrypted === t.password)
    return {
      checkedAt: (/* @__PURE__ */ new Date()).toISOString(),
      leakCount: 0,
      checkedPasswordContentId: e.password.contentId,
      checkSkippedReason: t.reason
    };
  if (e.password.contentId === e.leakedPasswordCheck?.checkedPasswordContentId)
    return e.leakedPasswordCheck;
}
function kf(e, t) {
  if (!(t.status === "noPolicy" || t.checkSource !== "passwordPolicy")) {
    if (e.password.contentId === e.passwordPolicyCheck?.checkedPasswordContentId)
      return e.passwordPolicyCheck;
    if (e.password.unencrypted === t.password)
      return {
        status: Wf(t),
        checkedPasswordContentId: e.password.contentId,
        passwordPolicyChangeTime: t.passwordPolicyChangeTime,
        checkedAt: (/* @__PURE__ */ new Date()).toISOString()
      };
  }
}
function Wf(e) {
  if (e.status === "checked")
    return {
      type: "checked",
      result: e.result
    };
  if (e.status === "skipped")
    return {
      type: "skipped",
      reason: e.reason
    };
  z(e);
}
function Of(e, t, o) {
  return e?.password.contentId === t.password.contentId ? Fe(e.passwordOrigin) : {
    type: o ? "generator" : "userInput",
    passwordContentId: t.password.contentId
  };
}
const Df = "_Push_16a0u_2", Hf = "_landscape_16a0u_7", Uf = "_PushStateInfo_16a0u_11", Vf = "_HelpMessage_16a0u_33", zf = "_hidden_16a0u_38", qf = "_PushStateActionButton_16a0u_46", jf = "_OpenMessage_16a0u_52", Gf = "_OpenIcon_16a0u_64", Kf = "_OpenAnimated_16a0u_77", Ee = {
  Push: Df,
  landscape: Hf,
  PushStateInfo: Uf,
  HelpMessage: Vf,
  hidden: zf,
  PushStateActionButton: qf,
  OpenMessage: jf,
  OpenIcon: Gf,
  OpenAnimated: Kf
}, Yf = "_LoginWindow_mea60_1", Xf = "_open_mea60_16", Jf = "_cornerBackground_mea60_19", Qf = "_cornerBackgroundTransparent_mea60_33", Zf = "_Background_mea60_44", eg = "_animateOpen_mea60_54", tg = "_landscape_mea60_76", ng = "_Content_mea60_86", og = "_additionalSideMargin_mea60_96", ig = "_respectContainerSize_mea60_100", rg = "_Close_mea60_106", sg = "_Back_mea60_44", Ie = {
  LoginWindow: Yf,
  open: Xf,
  cornerBackground: Jf,
  cornerBackgroundTransparent: Qf,
  Background: Zf,
  animateOpen: eg,
  landscape: tg,
  Content: ng,
  additionalSideMargin: og,
  respectContainerSize: ig,
  Close: rg,
  Back: sg
};
function cg({
  children: e,
  className: t,
  open: o,
  landscape: i,
  cornerBackground: r,
  cornerBackgroundTransparent: s,
  respectContainerSize: a,
  noOpenAnimation: c,
  onResize: d,
  onClose: l,
  onBack: p,
  onOpenEnd: _
}) {
  const [h, g] = $e(), [w, b] = $e();
  k(() => {
    d && d(b.width, b.height);
  }, [b.height, b.width, d]);
  const [y, v] = $e(), [S, I] = $e(), E = M(() => {
    const L = (g.height - b.height) / 2, F = v.height || I.height;
    return L < F;
  }, [I.height, v.height, g.height, b.height]), A = D();
  k(() => {
    window.clearTimeout(A.current), o && _ && (A.current = window.setTimeout(_, 1e3));
  }, [_, o]);
  const N = M(() => mn(10, () => {
    o && (window.clearTimeout(A.current), _?.());
  }), [_, o]), P = i ? Wc : Oc;
  return /* @__PURE__ */ m("div", { ref: h, className: C(Ie.LoginWindow, t, {
    [Ie.open]: o,
    [Ie.landscape]: i,
    [Ie.cornerBackground]: r,
    [Ie.cornerBackgroundTransparent]: s,
    [Ie.animateOpen]: !c
  }), style: {
    // @ts-ignore css custom properties are a thing, even if typescript pretends they're not
    // stylelint-disable
    "--container-width": `${g.width}px`,
    "--container-height": `${g.height}px`,
    "--content-width": `${b.width}px`,
    "--content-height": `${b.height}px`,
    // stylelint-enable
    boxShadow: jr
  }, children: [
    !r && /* @__PURE__ */ n(P, { className: Ie.Background, role: "presentation", onTransitionEnd: N }),
    /* @__PURE__ */ n("div", { ref: w, className: C(Ie.Content, {
      [Ie.additionalSideMargin]: E,
      [Ie.respectContainerSize]: a
    }), children: e }),
    l && /* @__PURE__ */ n("button", { type: "button", onClick: l, className: Ie.Close, ref: y, children: /* @__PURE__ */ n(fn, { "aria-label": "Close" }) }),
    p && /* @__PURE__ */ n("button", { type: "button", onClick: p, className: Ie.Back, ref: S, children: /* @__PURE__ */ n(kc, { "aria-label": "Back" }) })
  ] });
}
function ag({
  unlockMethods: e
}) {
  const t = yi(e);
  switch (t) {
    case "phone":
      return /* @__PURE__ */ n(f, { id: "F0GBL0" });
    case "mobileSafari":
      return /* @__PURE__ */ n(f, { id: "aIJHYe" });
    case "multiple":
      return /* @__PURE__ */ n(f, { id: "MpA0AY" });
    case "securityKey":
      return /* @__PURE__ */ n(f, { id: "1yegnp" });
    default:
      z(t);
  }
}
function Bb({
  children: e,
  state: t,
  unlockMethods: o,
  landscape: i,
  cornerBackground: r,
  cornerBackgroundTransparent: s,
  respectContainerSize: a,
  noOpenAnimation: c,
  onResize: d,
  onClose: l,
  onBack: p,
  onOpenEnd: _,
  onRetry: h,
  onCancel: g
}) {
  const w = t === "confirmed";
  return /* @__PURE__ */ n(cg, { open: w, onResize: d, onClose: l, onBack: p, onOpenEnd: _, landscape: i, cornerBackground: t === void 0 ? r : !1, cornerBackgroundTransparent: t === void 0 ? s : !1, respectContainerSize: a, noOpenAnimation: c, children: t === void 0 ? e : w ? /* @__PURE__ */ n(dg, { landscape: i }) : /* @__PURE__ */ n(lg, { landscape: i, state: t, onRetry: h, onCancel: g, unlockMethods: o }) });
}
function lg({
  landscape: e,
  state: t,
  unlockMethods: o,
  onRetry: i,
  onCancel: r
}) {
  const [s, a] = R(!1);
  return k(() => {
    if ((t === "warning" || t === "error") && a(!0), t === "connecting") {
      const c = setTimeout(() => a(!0), 15e3);
      return () => clearTimeout(c);
    }
  }, [t]), /* @__PURE__ */ m("div", { className: C(Ee.Push, {
    [Ee.landscape]: e
  }), children: [
    /* @__PURE__ */ n(Aa, { state: t, small: e, unlockDeviceType: yi(o) }),
    /* @__PURE__ */ m("div", { className: Ee.PushStateInfo, children: [
      t === "error" || t === "warning" ? /* @__PURE__ */ n("p", { children: t === "error" ? u._(
        /** i18n */
        {
          id: "zUtMod"
        }
      ) : u._(
        /** i18n */
        {
          id: "7Bj3x9"
        }
      ) }) : /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(ag, { unlockMethods: o }) }),
      (t === "error" || t === "warning") && i && /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(me, { buttonStyle: "secondary", type: "button", onClick: i, size: e ? "small" : "medium", className: Ee.PushStateActionButton, children: /* @__PURE__ */ n(f, { id: "KDw4GX" }) }) }),
      (t === "connecting" || t === "connected") && r && /* @__PURE__ */ n("p", { children: i && /* @__PURE__ */ n(me, { buttonStyle: "secondary", type: "button", onClick: r, size: e ? "small" : "medium", className: Ee.PushStateActionButton, children: /* @__PURE__ */ n(f, { id: "dEgA5A" }) }) }),
      /* @__PURE__ */ n("p", { "aria-hidden": !s, className: C(Ee.HelpMessage, !s && Ee.hidden), children: /* @__PURE__ */ n(Ae, { href: u._(
        /** i18n */
        {
          id: "62ft_Z"
        }
      ), children: /* @__PURE__ */ n(f, { id: "xAAcWG" }) }) })
    ] })
  ] });
}
function dg({
  landscape: e
}) {
  return /* @__PURE__ */ m("div", { className: C(Ee.OpenMessage, {
    [Ee.landscape]: e
  }), children: [
    /* @__PURE__ */ n(Fc, { className: Ee.OpenIcon, role: "presentation" }),
    /* @__PURE__ */ n("div", { className: Ee.OpenAnimated, children: /* @__PURE__ */ n(f, { id: "zUDyah" }) })
  ] });
}
const ug = "_Button_ouh1f_1", pg = "_Username_ouh1f_23", di = {
  Button: ug,
  Username: pg
};
function Tb({
  children: e,
  onClick: t,
  size: o,
  className: i,
  icon: r
}) {
  return /* @__PURE__ */ m(me, { buttonStyle: "secondary", className: C(di.Button, i), onClick: t, size: o, children: [
    r && /* @__PURE__ */ n(_g, { icon: r }),
    /* @__PURE__ */ n("span", { className: di.Username, children: e }),
    " ",
    /* @__PURE__ */ n(Dc, {})
  ] });
}
function _g({
  icon: e,
  ...t
}) {
  const o = e === "team" ? Uc : e === "inbox" ? Hc : e === "linked" ? Ri : z(e);
  return /* @__PURE__ */ n(o, { ...t });
}
const hg = "_Action_2a8qd_1 _UnstyledButton_r3cpb_208", mg = "_ActionIcon_2a8qd_23", fg = "_darkMode_2a8qd_43", gg = "_ActionText_2a8qd_52", yg = "_ActionArrow_2a8qd_63", yt = {
  Action: hg,
  ActionIcon: mg,
  darkMode: fg,
  ActionText: gg,
  ActionArrow: yg
};
function Eb({
  children: e,
  element: t,
  icon: o,
  rightIcon: i,
  iconSize: r,
  open: s,
  ...a
}) {
  const c = t ?? "button", d = X();
  return /* @__PURE__ */ m(c, { className: C(yt.Action, {
    [yt.darkMode]: d === "dark"
  }), ...a, children: [
    o && /* @__PURE__ */ n("div", { className: yt.ActionIcon, style: {
      // @ts-ignore
      // stylelint-disable
      "--icon-size": r
    }, children: /* @__PURE__ */ n(o, {}) }),
    /* @__PURE__ */ n("div", { className: yt.ActionText, children: e }),
    i ? /* @__PURE__ */ n(i, { className: yt.ActionArrow }) : /* @__PURE__ */ n(Jn, { direction: s ? "down" : "right", className: yt.ActionArrow })
  ] });
}
const Cg = "_LabeledSwitch_19hx2_1", wg = "_Switch_19hx2_10", bg = "_Label_19hx2_1", vg = "_Subtitle_19hx2_21", tn = {
  LabeledSwitch: Cg,
  Switch: wg,
  Label: bg,
  Subtitle: vg
};
function $b({
  subtitle: e,
  children: t,
  className: o,
  ...i
}) {
  const r = M(() => i.id ?? Ai(), [i.id]);
  return /* @__PURE__ */ m("div", { className: C(tn.LabeledSwitch, o), children: [
    /* @__PURE__ */ n(on, { ...i, className: tn.Switch, id: r }),
    /* @__PURE__ */ n("label", { htmlFor: r, className: tn.Label, children: t }),
    e && /* @__PURE__ */ n("div", { className: tn.Subtitle, children: e })
  ] });
}
const Sg = "_SectionBoxSubheadline_1pfni_1", Ig = {
  SectionBoxSubheadline: Sg
};
function xb({
  className: e,
  children: t,
  level: o,
  ...i
}) {
  const r = `h${o ?? 4}`;
  return /* @__PURE__ */ n(r, { className: C(Ig.SectionBoxSubheadline, e), ...i, children: t });
}
const Ng = "_SectionBoxSubsection_4q1fe_1", Ag = "_bottomMargin_4q1fe_1", Lg = "_bottomBorder_4q1fe_4", Pg = "_twoCol_4q1fe_9", Rg = "_singleCol_4q1fe_12", Bg = "_Secondary_4q1fe_12", Tg = "_Primary_4q1fe_16", at = {
  SectionBoxSubsection: Ng,
  bottomMargin: Ag,
  bottomBorder: Lg,
  twoCol: Pg,
  singleCol: Rg,
  Secondary: Bg,
  Primary: Tg
};
function Mb({
  primary: e,
  secondary: t,
  noBorder: o,
  last: i,
  primaryProportion: r = 0.5
}) {
  const [s, {
    width: a
  }] = $e(), c = a > 400;
  return /* @__PURE__ */ m("div", { className: C(at.SectionBoxSubsection, {
    [at.singleCol]: !c,
    [at.twoCol]: c,
    [at.bottomBorder]: !o && !i,
    [at.bottomMargin]: o && !i
  }), style: {
    "--primary-proportion": `${r * 100}%`
  }, ref: s, children: [
    e && /* @__PURE__ */ n("div", { className: at.Primary, children: e }),
    t && /* @__PURE__ */ n("div", { className: at.Secondary, children: t })
  ] });
}
const Eg = "_RadioButton_m57t9_1", $g = {
  RadioButton: Eg
};
function Fb({
  className: e,
  checked: t,
  ...o
}) {
  return /* @__PURE__ */ n("input", { type: "radio", checked: t, ...o, className: C($g.RadioButton, e) });
}
const xg = "_NativeSelectWrapper_9ajt1_1", Mg = "_disabled_9ajt1_5", Fg = "_NativeSelect_9ajt1_1", kg = "_Chevron_9ajt1_31", nn = {
  NativeSelectWrapper: xg,
  disabled: Mg,
  NativeSelect: Fg,
  Chevron: kg
};
function kb({
  className: e,
  wrapperClassName: t,
  ...o
}) {
  return /* @__PURE__ */ m("div", { className: C(nn.NativeSelectWrapper, {
    [nn.disabled]: o.disabled
  }, t), children: [
    /* @__PURE__ */ n("select", { className: C(nn.NativeSelect, e), ...o }),
    /* @__PURE__ */ n(Vc, { className: nn.Chevron })
  ] });
}
const Wg = "_SearchInputWrapper_1f8f1_1", Og = "_small_1f8f1_8", Dg = "_dark_1f8f1_11", Hg = "_SearchInput_1f8f1_1", Ug = "_SearchOverlay_1f8f1_49", Vg = "_SearchOverlayIcon_1f8f1_61", zg = "_PlaceholderText_1f8f1_73", qg = "_InlineUi_1f8f1_84", jg = "_ClearButton_1f8f1_90 _UnstyledButton_r3cpb_208", He = {
  SearchInputWrapper: Wg,
  small: Og,
  dark: Dg,
  SearchInput: Hg,
  SearchOverlay: Ug,
  SearchOverlayIcon: Vg,
  PlaceholderText: zg,
  InlineUi: qg,
  ClearButton: jg
}, Wb = ke.forwardRef(({
  value: e,
  suggestions: t,
  onKeyDown: o,
  placeholder: i,
  className: r,
  size: s,
  inlineUi: a,
  clear: c,
  ...d
}, l) => {
  const p = D(null), _ = X(), [h, {
    width: g
  }] = $e();
  return /* @__PURE__ */ m("div", { className: C(He.SearchInputWrapper, r, He[_], He[s ?? "medium"]), style: {
    "--inline-ui-width": `${g}px`
  }, children: [
    /* @__PURE__ */ n("input", { ...d, type: "search", value: e, className: C(He.SearchInput), autoCapitalize: "off", autoCorrect: "off", onKeyDown: c ? (w) => {
      o?.(w), !w.defaultPrevented && w.key === "Escape" && e && (c(), w.preventDefault());
    } : o, ref: Gg(l, p) }),
    !!e && !!c && /* @__PURE__ */ n("button", { type: "button", onClick: () => {
      p.current?.focus(), c();
    }, className: He.ClearButton, children: /* @__PURE__ */ n(zc, { title: u._(
      /** i18n */
      {
        id: "xCJdfg"
      }
    ) }) }),
    /* @__PURE__ */ m("div", { className: He.SearchOverlay, children: [
      /* @__PURE__ */ n("div", { className: He.SearchOverlayIcon, children: /* @__PURE__ */ n(qc, {}) }),
      /* @__PURE__ */ n("div", { className: He.PlaceholderText, children: !e && i }),
      a && /* @__PURE__ */ n("div", { className: He.InlineUi, ref: h, children: a })
    ] }),
    t
  ] });
});
function Gg(...e) {
  return (t) => {
    for (const o of e)
      typeof o == "function" ? o(t) : o !== null && (o.current = t);
  };
}
const Kg = "_InlineProgressButton_1td7k_1 _UnstyledButton_r3cpb_208", Yg = "_light_1td7k_24", Xg = "_dark_1td7k_28", Jg = "_highlight_1td7k_29", Qg = "_Icon_1td7k_35", Zg = "_Text_1td7k_40", ey = "_Action_1td7k_45", ty = "_initial_1td7k_55", ny = "_inProgress_1td7k_60", oy = "_success_1td7k_73", iy = "_successRedo_1td7k_94", ry = "_error_1td7k_100", Te = {
  InlineProgressButton: Kg,
  light: Yg,
  dark: Xg,
  highlight: Jg,
  Icon: Qg,
  Text: Zg,
  Action: ey,
  initial: ty,
  inProgress: ny,
  default: "_default_1td7k_60",
  success: oy,
  successRedo: iy,
  error: ry
};
function sy({
  state: e,
  initialLabel: t,
  inProgressLabel: o,
  successLabel: i,
  successRedoActionLabel: r,
  errorLabel: s,
  errorRedoActionLabel: a,
  className: c,
  disabled: d,
  ...l
}) {
  const p = Nt(), _ = X();
  return /* @__PURE__ */ n("button", { ...l, type: "button", className: C(c, Te.InlineProgressButton, Te[e], Te[p], Te[_]), disabled: d || e === "inProgress" || e === "success", children: e === "initial" ? /* @__PURE__ */ n(T, { children: t }) : e === "inProgress" ? /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(Cn, { armCount: 10, size: "1.5rem" }),
    /* @__PURE__ */ n("span", { className: Te.Text, children: o })
  ] }) : e === "success" ? /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n(jc, { className: Te.Icon }),
    /* @__PURE__ */ n("span", { className: Te.Text, children: i })
  ] }) : e === "successRedo" ? /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n("span", { className: Te.Text, children: i }),
    /* @__PURE__ */ n("span", { className: Te.Action, children: r })
  ] }) : e === "error" ? /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n("span", { className: Te.Text, children: s }),
    /* @__PURE__ */ n("span", { className: Te.Action, children: a })
  ] }) : z(e) });
}
function Ob({
  performAction: e,
  getErrorLabel: t,
  minActionDuration: o,
  ...i
}) {
  const [r, s] = R("initial"), [a, c] = R(""), d = D(!1), l = B(async () => {
    if (!d.current)
      try {
        d.current = !0, c(""), s("inProgress"), await na(e, o)(), s("success"), await hn(1e3), s("successRedo");
      } catch (p) {
        c(t(p)), s("error");
      } finally {
        d.current = !1;
      }
  }, [t, o, e]);
  return /* @__PURE__ */ n(sy, { ...i, state: r, errorLabel: a, onClick: () => {
    l().catch($);
  } });
}
function hr({
  className: e
}) {
  const t = Nt(), o = X();
  return t === "highlight" || o === "dark" ? /* @__PURE__ */ n(Kc, { role: "img", "aria-label": "heylogin", className: e }) : /* @__PURE__ */ n(Gc, { role: "img", "aria-label": "heylogin", className: e });
}
const cy = "_Frame_b336c_1", ay = "_Header_b336c_8", ly = "_Logo_b336c_19", dy = "_Content_b336c_24", uy = "_warning_b336c_32", py = "_light_b336c_32", _y = "_dark_b336c_36", Ct = {
  Frame: cy,
  Header: ay,
  Logo: ly,
  Content: dy,
  warning: uy,
  light: py,
  dark: _y
};
function so({
  childrenContainerClassName: e,
  headerContent: t,
  children: o,
  backgroundStyle: i
}) {
  const r = X();
  return /* @__PURE__ */ m("div", { className: C(Ct.Frame, {
    [Ct.warning]: i === "warning"
  }, Ct[r]), children: [
    /* @__PURE__ */ m("header", { className: Ct.Header, children: [
      /* @__PURE__ */ n(hr, { className: Ct.Logo }),
      t
    ] }),
    /* @__PURE__ */ n("div", { className: C(Ct.Content, e), children: o })
  ] });
}
const hy = "_Footer_1rr4m_1", my = {
  Footer: hy
};
function fy({
  className: e
}) {
  return /* @__PURE__ */ n("footer", { className: C(my.Footer, e), children: /* @__PURE__ */ m("ul", { children: [
    /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(f, { id: "Fvb86B", components: {
      0: /* @__PURE__ */ n(Ae, { href: u._(
        /** i18n */
        {
          id: "I1Vdph"
        }
      ), noIcon: !0 })
    } }) }),
    /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(Ae, { href: u._(
      /** i18n */
      {
        id: "k7F8ip"
      }
    ), noIcon: !0, children: /* @__PURE__ */ n(f, { id: "JPSaZE" }) }) })
  ] }) });
}
function gy(e, t) {
  const o = {
    type: "setClearValueFromClipboardAfterTimeout",
    clearAfterTimeout: !!t,
    value: e
  };
  window.postMessage(o), navigator.clipboard.writeText(e).catch($);
}
const yy = "_Content_1ubfw_1", Cy = "_ColumnWrapper_1ubfw_5", wy = "_LoginColumn_1ubfw_14", by = "_SenderInfo_1ubfw_25", vy = "_InfoHeadline_1ubfw_30", Sy = "_InfoText_1ubfw_34", Iy = "_PreviewLogin_1ubfw_39", Ny = "_dark_1ubfw_46", Ay = "_Headline_1ubfw_50", Ly = "_Subheadline_1ubfw_53", Py = "_monospace_1ubfw_53", Ry = "_ButtonGroup_1ubfw_57", By = "_ShowLoginButton_1ubfw_64", Ty = "_AddToHeyloginButton_1ubfw_68", Ey = "_standalone_1ubfw_73", $y = "_HeyloginInfoBox_1ubfw_77", xy = "_StartLink_1ubfw_98", My = "_InfoLine_1ubfw_102", Fy = "_Label_1ubfw_106", ky = "_ErrorWrapper_1ubfw_110", Wy = "_ErrorImage_1ubfw_117", Oy = "_LearnMoreButton_1ubfw_123", Dy = "_LegalFooter_1ubfw_128", Z = {
  Content: yy,
  ColumnWrapper: Cy,
  LoginColumn: wy,
  SenderInfo: by,
  InfoHeadline: vy,
  InfoText: Sy,
  PreviewLogin: Iy,
  dark: Ny,
  Headline: Ay,
  Subheadline: Ly,
  monospace: Py,
  ButtonGroup: Ry,
  ShowLoginButton: By,
  AddToHeyloginButton: Ty,
  standalone: Ey,
  HeyloginInfoBox: $y,
  StartLink: xy,
  InfoLine: My,
  Label: Fy,
  ErrorWrapper: ky,
  ErrorImage: Wy,
  LearnMoreButton: Oy,
  LegalFooter: Dy
};
function Db({
  shareLinkState: e,
  ...t
}) {
  return e.state === "loading" ? /* @__PURE__ */ n(so, { children: /* @__PURE__ */ n(Dn, {}) }) : e.state === "error" ? /* @__PURE__ */ n(Uy, {}) : /* @__PURE__ */ n(Hy, { shareLinkState: e, ...t });
}
function Hy({
  shareLinkState: e,
  openShareLink: t,
  addToHeylogin: o,
  showingUnlockOverlay: i,
  renderStartLink: r,
  displayError: s = $
}) {
  const [a, c] = un(t, [t]), d = () => {
    a().catch(s);
  }, {
    headline: l,
    subheadline: p,
    subheadlineMonospace: _
  } = M(() => {
    const v = gi(e.login, {
      noScopeEntryCount: !0
    });
    return e.login.uiType === U.note ? {
      ...v,
      subheadline: void 0
    } : v;
  }, [e.login]), h = X(), [g, w] = un(async () => {
    await o?.();
  }, [o]), b = () => {
    g().catch(s);
  };
  if (w && !i)
    return /* @__PURE__ */ n(Dn, {});
  const y = ot(e.login.uiType);
  return /* @__PURE__ */ m(so, { childrenContainerClassName: Z.Content, headerContent: /* @__PURE__ */ n(mr, {}), children: [
    /* @__PURE__ */ m("main", { className: Z.ColumnWrapper, children: [
      /* @__PURE__ */ m("section", { className: Z.LoginColumn, children: [
        /* @__PURE__ */ n("h2", { children: /* @__PURE__ */ n(f, { id: "HW5fQk" }) }),
        /* @__PURE__ */ m("div", { className: Z.SenderInfo, children: [
          e.organizationName && /* @__PURE__ */ n(ui, { label: u._(
            /** i18n */
            {
              id: "ucgZ0o"
            }
          ), value: e.organizationName }),
          /* @__PURE__ */ n(ui, { label: u._(
            /** i18n */
            {
              id: "ATGYL1"
            }
          ), value: e.senderEmail })
        ] }),
        /* @__PURE__ */ n("h2", { className: Z.InfoHeadline, children: y === U.login ? /* @__PURE__ */ n(f, { id: "i_Jezz" }) : y === U.creditCard ? /* @__PURE__ */ n(f, { id: "eKBgW-" }) : y === U.note ? /* @__PURE__ */ n(f, { id: "pHs-l6" }) : y === U.wifi ? /* @__PURE__ */ n(f, { id: "TxbnkN" }) : y === U.elsterCertificate ? /* @__PURE__ */ n(f, { id: "24x4wz" }) : z(y) }),
        /* @__PURE__ */ n("p", { className: Z.InfoText, children: y === U.login ? /* @__PURE__ */ n(f, { id: "KVq2Ij" }) : y === U.creditCard ? /* @__PURE__ */ n(f, { id: "aZpEar" }) : y === U.note ? /* @__PURE__ */ n(f, { id: "dTkmlj" }) : y === U.wifi ? /* @__PURE__ */ n(f, { id: "m0yeTC" }) : y === U.elsterCertificate ? /* @__PURE__ */ n(f, { id: "KpGyEE" }) : z(y) }),
        e.state === "preview" ? /* @__PURE__ */ m(T, { children: [
          /* @__PURE__ */ m("div", { className: C(Z.PreviewLogin, Z[h]), children: [
            /* @__PURE__ */ n("div", { className: Z.Headline, children: l }),
            /* @__PURE__ */ n("div", { className: C(Z.Subheadline, {
              [Z.monospace]: _
            }), children: p })
          ] }),
          c ? /* @__PURE__ */ n(Dn, {}) : /* @__PURE__ */ m("div", { className: Z.ButtonGroup, children: [
            /* @__PURE__ */ n(me, { size: "small", buttonStyle: "primary", element: "button", type: "button", onClick: d, className: Z.ShowLoginButton, children: y === U.login ? /* @__PURE__ */ n(f, { id: "NoYewX" }) : y === U.creditCard ? /* @__PURE__ */ n(f, { id: "TeIYJb" }) : y === U.note ? /* @__PURE__ */ n(f, { id: "pfqjcu" }) : y === U.wifi ? /* @__PURE__ */ n(f, { id: "zY0D4K" }) : y === U.elsterCertificate ? /* @__PURE__ */ n(f, { id: "Wnd6dA" }) : z(y) }),
            o && /* @__PURE__ */ n(me, { size: "small", buttonStyle: "secondary", element: "button", type: "button", onClick: b, className: Z.AddToHeyloginButton, children: /* @__PURE__ */ n(f, { id: "kgPjYl" }) })
          ] })
        ] }) : /* @__PURE__ */ m(T, { children: [
          /* @__PURE__ */ n(pn, { login: {
            ...e.login,
            editTime: void 0,
            creationTime: void 0
          }, writeToClipboard: gy, passwordGeneratorSettings: void 0, savePasswordGeneratorSettings: () => {
          }, newLogin: !1, permissions: {
            ...$s,
            viewSecrets: !0
          }, disabled: !1, onDelete: () => $(new Error("called onDelete with read only login")), onSave: () => $(new Error("called onSave with read only login")), onSaveSuccess: () => $(new Error("called onSaveSuccess with read only login")), showSavedSuccess: !1, initialLeakedPasswordCheckStatus: void 0, initialPasswordOrigin: void 0, getLeakedPasswordData: () => ($(new Error("called getLeakedPasswordData with read only login")), new Promise(() => {
          })), movedLoginInfo: void 0, handleSubmitError: s, elsterValidator: {
            getElsterCertificateFromFile: () => ($(new Error("called getElsterCertificateFromFile with read only login")), new Promise(() => {
            })),
            isElsterCertificateFile: () => ($(new Error("called isElsterCertificateFile with read only login")), new Promise(() => {
            })),
            validateElsterCertificate: () => ($(new Error("called validateElsterCertificate with read only login")), new Promise(() => {
            }))
          } }),
          o && /* @__PURE__ */ n(me, { size: "small", buttonStyle: "secondary", element: "button", type: "button", onClick: b, className: C(Z.AddToHeyloginButton, Z.standalone), children: /* @__PURE__ */ n(f, { id: "kgPjYl" }) })
        ] })
      ] }),
      /* @__PURE__ */ m("section", { className: C(Z.HeyloginInfoBox, Z[h]), children: [
        /* @__PURE__ */ n("img", { src: Xc, alt: u._(
          /** i18n */
          {
            id: "XWPhsn"
          }
        ) }),
        /* @__PURE__ */ n("h2", { children: /* @__PURE__ */ n(f, { id: "VXWtcy" }) }),
        /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "OcduGg" }) }),
        r({
          className: Z.StartLink,
          children: /* @__PURE__ */ n(f, { id: "XO628f" })
        })
      ] })
    ] }),
    /* @__PURE__ */ n(fy, { className: Z.LegalFooter })
  ] });
}
function ui({
  label: e,
  value: t
}) {
  return /* @__PURE__ */ m("div", { className: Z.InfoLine, children: [
    /* @__PURE__ */ n("div", { className: Z.Label, children: e }),
    /* @__PURE__ */ n("div", { children: t })
  ] });
}
function Uy() {
  return /* @__PURE__ */ n(so, { backgroundStyle: "warning", headerContent: /* @__PURE__ */ n(mr, {}), children: /* @__PURE__ */ m("div", { className: Z.ErrorWrapper, children: [
    /* @__PURE__ */ n(Yc, { className: Z.ErrorImage }),
    /* @__PURE__ */ n("h1", { children: /* @__PURE__ */ n(f, { id: "fxHUMf" }) }),
    /* @__PURE__ */ n(f, { id: "isVEGK" })
  ] }) });
}
function mr() {
  return /* @__PURE__ */ n(me, { buttonStyle: "primary", element: "a", href: "https://heylogin.com", target: "_blank", rel: "noreferrer", className: Z.LearnMoreButton, children: /* @__PURE__ */ n(f, { id: "8dv9S4" }) });
}
function Vy(e) {
  return typeof e == "object" && e !== null && "message" in e && e.message === "The operation failed for an unknown transient reason";
}
const zy = "_Content_qb11n_1", qy = "_Logo_qb11n_8", jy = "_Headline_qb11n_19", Xe = {
  Content: zy,
  Logo: qy,
  Headline: jy
};
function Hb({
  error: e,
  hideReload: t = !1
}) {
  const o = Kn();
  return /* @__PURE__ */ m("div", { className: Xe.Content, children: [
    /* @__PURE__ */ n("h1", { className: Xe.Logo, children: /* @__PURE__ */ n(hr, {}) }),
    e instanceof pi || Xy(e) ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: e.userTitle }),
      /* @__PURE__ */ n("p", { children: e.userDetail })
    ] }) : Ky(e) ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: /* @__PURE__ */ n(f, { id: "-AzmrG" }) }),
      /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "QsZjF-" }) })
    ] }) : Yy(e) ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: /* @__PURE__ */ n(f, { id: "0MMpme" }) }),
      /* @__PURE__ */ n("p", { children: /* @__PURE__ */ n(f, { id: "MDM7ip" }) })
    ] }) : Vy(e) ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: /* @__PURE__ */ n(f, { id: "4_yrq7" }) }),
      /* @__PURE__ */ m("p", { children: [
        /* @__PURE__ */ n(f, { id: "vcb1PI" }),
        " ",
        /* @__PURE__ */ n(Ae, { href: u._(
          /** i18n */
          {
            id: "0-J9NZ"
          }
        ), children: /* @__PURE__ */ n(f, { id: "zwWKhA" }) })
      ] })
    ] }) : e instanceof Error ? /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: /* @__PURE__ */ n(f, { id: "fEjABR", values: {
        0: e?.name
      } }) }),
      /* @__PURE__ */ n("p", { children: e?.message })
    ] }) : /* @__PURE__ */ m(T, { children: [
      /* @__PURE__ */ n("h2", { className: Xe.Headline, children: /* @__PURE__ */ n(f, { id: "29VNqC" }) }),
      /* @__PURE__ */ n("p", { children: JSON.stringify(e) })
    ] }),
    !t && /* @__PURE__ */ n(me, { buttonStyle: "primary", type: "button", onClick: () => window.location.reload(), children: /* @__PURE__ */ n(f, { id: "HpK_8d" }) }),
    o && /* @__PURE__ */ n("div", { style: {
      border: "5px solid #f0f",
      marginTop: "2rem",
      padding: ".5rem"
    }, children: /* @__PURE__ */ n("button", { onClick: () => (localStorage.clear(), window.location.reload()), children: "Clear local storage and reload" }) })
  ] });
}
const Gy = [
  "Unable to preload CSS for",
  // Firefox
  "error loading dynamically imported module:",
  // Chrome
  "Failed to fetch dynamically imported module:",
  // Safari
  "Importing a module script failed"
];
function Ky(e) {
  return e instanceof Error && Gy.some((t) => e.message.startsWith(t));
}
function Yy(e) {
  return e instanceof DOMException && e.name === "NotFoundError";
}
function Xy(e) {
  return typeof e == "object" && e !== null && "userTitle" in e && "userDetail" in e && typeof e.userTitle == "string" && typeof e.userDetail == "string";
}
const Jy = "_Shortcut_kt1le_1", Qy = "_inverted_kt1le_11", Zy = "_small_kt1le_15", eC = "_disabled_kt1le_20", tC = "_darkMode_kt1le_24", nC = "_Key_kt1le_28", wt = {
  Shortcut: Jy,
  inverted: Qy,
  small: Zy,
  disabled: eC,
  darkMode: tC,
  Key: nC
};
function Ub({
  shortcut: e,
  small: t,
  applePlatform: o,
  invertColors: i,
  disabled: r
}) {
  const s = X(), a = M(() => {
    if (e)
      return Gr(e, o);
  }, [o, e]);
  return /* @__PURE__ */ n("div", { className: C(wt.Shortcut, {
    [wt.small]: t,
    [wt.inverted]: !r && i,
    [wt.disabled]: r,
    [wt.darkMode]: s === "dark"
  }), children: a?.map((c, d, l) => /* @__PURE__ */ n(oC, { keyLabel: c, trailingPlus: !t && d < l.length - 1 }, c)) });
}
function oC({
  keyLabel: e,
  trailingPlus: t
}) {
  return /* @__PURE__ */ m(T, { children: [
    /* @__PURE__ */ n("div", { className: wt.Key, children: e }),
    t && "+"
  ] });
}
function Vb(e) {
  const t = ot(e);
  if (t.type === "unknown")
    return u._(
      /** i18n */
      {
        id: "IU3aCs"
      }
    );
  if (t.type === "creditCard")
    switch (t.key) {
      case "cardHolder":
        return u._(
          /** i18n */
          {
            id: "bMFXRG"
          }
        );
      case "expiration":
        return u._(
          /** i18n */
          {
            id: "sZg7s1"
          }
        );
      case "number":
        return u._(
          /** i18n */
          {
            id: "xHIEQ5"
          }
        );
      case "pin":
        return u._(
          /** i18n */
          {
            id: "sXULwc"
          }
        );
      case "securityCode":
        return u._(
          /** i18n */
          {
            id: "wLmRnI"
          }
        );
    }
  if (t.type === "login")
    switch (t.key) {
      case "androidApps":
        return u._(
          /** i18n */
          {
            id: "zVJj0U"
          }
        );
      case "displayHeadline":
        return u._(
          /** i18n */
          {
            id: "MHrjPM"
          }
        );
      case "note":
        return u._(
          /** i18n */
          {
            id: "KiJn9B"
          }
        );
      case "password":
        return u._(
          /** i18n */
          {
            id: "8ZsakT"
          }
        );
      case "tags":
        return u._(
          /** i18n */
          {
            id: "h8DugX"
          }
        );
      case "title":
        return u._(
          /** i18n */
          {
            id: "pfa8F0"
          }
        );
      case "totp":
        return u._(
          /** i18n */
          {
            id: "Kvajkr"
          }
        );
      case "totpAlgorithm":
        return u._(
          /** i18n */
          {
            id: "yoyvgB"
          }
        );
      case "totpDigits":
        return u._(
          /** i18n */
          {
            id: "16oMiL"
          }
        );
      case "totpPeriod":
        return u._(
          /** i18n */
          {
            id: "rsWzn3"
          }
        );
      case "passkey":
        return u._(
          /** i18n */
          {
            id: "FGSN4s"
          }
        );
      case "username":
        return u._(
          /** i18n */
          {
            id: "7sNhEz"
          }
        );
      case "websites":
        return u._(
          /** i18n */
          {
            id: "1J9wMe"
          }
        );
      case "wifiSsid":
        return u._(
          /** i18n */
          {
            id: "MKYFuo"
          }
        );
      case "elsterCertificate":
        return u._(
          /** i18n */
          {
            id: "xkM21M"
          }
        );
    }
  return t.type === "customField" ? t.name : t.type === "scope" ? t.kinds.map((o) => iC(ot(o))).join(", ") : z(t);
}
function iC(e) {
  switch (e) {
    case "unknown":
      return u._(
        /** i18n */
        {
          id: "IU3aCs"
        }
      );
    case "website":
      return u._(
        /** i18n */
        {
          id: "1J9wMe"
        }
      );
    case "androidApp":
      return u._(
        /** i18n */
        {
          id: "Gk2Igf"
        }
      );
    case "windowsDesktopApp":
      return u._(
        /** i18n */
        {
          id: "YEK0YQ"
        }
      );
  }
}
const rC = "_BoxHighlight_1bbo1_1", sC = {
  BoxHighlight: rC
};
function zb({
  highlight: e,
  children: t
}) {
  const o = D(null), i = D(!1);
  return k(() => {
    e && !i.current && o.current && (Ii(o.current, {
      behavior: "smooth"
    }), i.current = !0);
  }, [e]), /* @__PURE__ */ n("div", { ref: o, className: C(e && sC.BoxHighlight), children: t });
}
function qb({
  wrappers: e,
  children: t
}) {
  return [...e].reverse().reduce((i, r) => /* @__PURE__ */ n(r, { children: i }), /* @__PURE__ */ n(T, { children: t }));
}
function jb({
  children: e
}) {
  const {
    i18n: t
  } = ks();
  return k(() => {
    document.documentElement.lang = t.locale;
  }, [t.locale]), /* @__PURE__ */ n(T, { children: e });
}
export {
  me as ActionButton,
  Nb as ActionInput,
  Jn as ArrowIcon,
  Cb as AuditlogWriteContextProvider,
  Ut as AutoFadeTransition,
  gn as BaseFormInput,
  zb as BoxHighlight,
  Wi as Checkbox,
  Rf as CircularIcon,
  Ab as CopyButton,
  Yn as CrossFadeTransition,
  Gy as DYNAMIC_IMPORT_ERROR_PREFIXES,
  mb as DebugVisibleContextProvider,
  fb as DebugWrapper,
  Oi as DropdownFrame,
  Ae as ExternalLink,
  Hb as FallbackComponent,
  Pb as FileInput,
  Qa as FormButton,
  se as FormInput,
  Jm as FormInputWithSuggestions,
  _d as FormSelectSearch,
  Wt as GENERATE_PASSWORD_MAX_LENGTH,
  hr as HeyloginLogo,
  Xn as HoverOverlay,
  Ht as HoverTooltip,
  yn as IconActions,
  Di as InlineIconAction,
  Ob as InlineProgressButton,
  __ as LabeledSuccessButton,
  jb as LangAttributeWrapper,
  fy as LegalFooter,
  Zl as LightweightInput,
  it as LinkButton,
  Dn as Loading,
  Tb as LoginButton,
  _g as LoginButtonIcon,
  Rb as LoginDetail,
  pn as LoginEdit,
  gb as LoginEditContextProvider,
  ci as LoginPermissionHint,
  Db as LoginShareLinkView,
  Bb as LoginWindow,
  Ot as MessageBox,
  Lb as MoreOptions,
  kb as NativeSelect,
  mp as PasskeyView,
  Vn as PasswordGenerator,
  Aa as PushState,
  Fb as RadioButton,
  Wb as SearchInput,
  no as SectionBox,
  Eb as SectionBoxAction,
  $b as SectionBoxLabeledSwitch,
  xb as SectionBoxSubheadline,
  Mb as SectionBoxSubsection,
  _u as ShortcutHint,
  Ub as ShortcutView,
  Cn as Spinner,
  Rd as SuccessButton,
  on as Switch,
  ou as SystemTimeOffsetWarning,
  so as TopBarFrame,
  Id as TotpCountdown,
  iu as TotpTimeOffsetWarning,
  hb as UIModeContextProvider,
  _b as UIStyleContainer,
  Zc as UIStyleContextProvider,
  cr as UiTypeIcon,
  ag as UnlockLabel,
  qb as WrapperProvider,
  tv as availableUnlockMethods,
  Zn as deriveSettingsFromPolicy,
  nv as extractCredentialCreateResult,
  ov as extractCredentialGetResult,
  On as formInputActionsInlineUi,
  Vi as generateInitialPassword,
  dn as generatePassword,
  Ve as getDateFnsLocale,
  ze as getDeleteAction,
  zr as getEmptyLoginHeadline,
  iv as getFullLoginVaultLabel,
  gi as getLocalizedLoginDisplayInfo,
  qr as getLoginVaultLabel,
  Yb as getLoginsForUrl,
  rv as getNavigatorCredentials,
  fi as getUiTypeName,
  Qe as globalStyles,
  Uo as handleFormikSubmit,
  _v as initLocale,
  mi as isApplePlatform,
  sv as isFirefox149OrNewer,
  cv as isIPadSafariPretendingToBeMac,
  ur as isLoginPermissionHintNeeded,
  Xb as isValidDomain,
  av as isWebauthnAllowedForBrowser,
  lv as isWebauthnExtensionUnlockAllowedForBrowser,
  Vy as isWebauthnTransientError,
  hv as loadLocale,
  Vb as localizeLoginDifference,
  Jb as parseUrlWithPsl,
  Dr as pslParse,
  Qb as pslParseWithCache,
  dv as supportsQuickAccess,
  uv as toUint8Array,
  yi as unlockDeviceTypeForMethods,
  Zb as urlMatchesPattern,
  wb as useAuditlogWriteContext,
  un as useCallbackWithProgress,
  la as useComposedRef,
  fe as useCopyAction,
  vb as useDebugTrigger,
  Kn as useDebugVisibleContext,
  da as useDelayedProgressIndication,
  $e as useElementSize,
  ta as useElementSizeCallback,
  pe as useFormInputActionsInlineUi,
  Sb as useModifierKeyName,
  Z_ as useMountedRef,
  oa as useMousetrap,
  ki as useOnClickOutside,
  yb as useOpenLogin,
  Ui as usePasswordGeneration,
  ra as usePositionedPortal,
  Ib as useRefs,
  vt as useRevealPasswordAction,
  bb as useScrollMemory,
  ea as useTotp,
  X as useUIMode,
  Nt as useUIStyle,
  na as withMinimumDuration,
  gy as writeToClipboard
};
//# sourceMappingURL=index.js.map
